import { jsx as L, jsxs as _, Fragment as Xt } from "react/jsx-runtime";
import { useMemo as Lr } from "react";
function Mr(u) {
  return u && u.__esModule && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u;
}
function Gr(u) {
  if (Object.prototype.hasOwnProperty.call(u, "__esModule")) return u;
  var d = u.default;
  if (typeof d == "function") {
    var l = function x() {
      var v = !1;
      try {
        v = this instanceof x;
      } catch {
      }
      return v ? Reflect.construct(d, arguments, this.constructor) : d.apply(this, arguments);
    };
    l.prototype = d.prototype;
  } else l = {};
  return Object.defineProperty(l, "__esModule", { value: !0 }), Object.keys(u).forEach(function(x) {
    var v = Object.getOwnPropertyDescriptor(u, x);
    Object.defineProperty(l, x, v.get ? v : {
      enumerable: !0,
      get: function() {
        return u[x];
      }
    });
  }), l;
}
var te = {}, ue = {}, xe = {}, et = {}, tt = {}, zt;
function $t() {
  return zt || (zt = 1, (function(u) {
    var d;
    Object.defineProperty(u, "__esModule", { value: !0 }), u.fromCodePoint = void 0, u.replaceCodePoint = x, u.decodeCodePoint = v;
    const l = /* @__PURE__ */ new Map([
      [0, 65533],
      // C1 Unicode control character reference replacements
      [128, 8364],
      [130, 8218],
      [131, 402],
      [132, 8222],
      [133, 8230],
      [134, 8224],
      [135, 8225],
      [136, 710],
      [137, 8240],
      [138, 352],
      [139, 8249],
      [140, 338],
      [142, 381],
      [145, 8216],
      [146, 8217],
      [147, 8220],
      [148, 8221],
      [149, 8226],
      [150, 8211],
      [151, 8212],
      [152, 732],
      [153, 8482],
      [154, 353],
      [155, 8250],
      [156, 339],
      [158, 382],
      [159, 376]
    ]);
    u.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, n/no-unsupported-features/es-builtins
    (d = String.fromCodePoint) !== null && d !== void 0 ? d : ((b) => {
      let g = "";
      return b > 65535 && (b -= 65536, g += String.fromCharCode(b >>> 10 & 1023 | 55296), b = 56320 | b & 1023), g += String.fromCharCode(b), g;
    });
    function x(b) {
      var g;
      return b >= 55296 && b <= 57343 || b > 1114111 ? 65533 : (g = l.get(b)) !== null && g !== void 0 ? g : b;
    }
    function v(b) {
      return (0, u.fromCodePoint)(x(b));
    }
  })(tt)), tt;
}
var Se = {}, qe = {}, eu;
function pr() {
  if (eu) return qe;
  eu = 1, Object.defineProperty(qe, "__esModule", { value: !0 }), qe.decodeBase64 = u;
  function u(d) {
    const l = (
      // eslint-disable-next-line n/no-unsupported-features/node-builtins
      typeof atob == "function" ? (
        // Browser (and Node >=16)
        // eslint-disable-next-line n/no-unsupported-features/node-builtins
        atob(d)
      ) : (
        // Older Node versions (<16)
        // eslint-disable-next-line n/no-unsupported-features/node-builtins
        typeof Buffer.from == "function" ? (
          // eslint-disable-next-line n/no-unsupported-features/node-builtins
          Buffer.from(d, "base64").toString("binary")
        ) : (
          // eslint-disable-next-line unicorn/no-new-buffer, n/no-deprecated-api
          new Buffer(d, "base64").toString("binary")
        )
      )
    ), x = l.length & -2, v = new Uint16Array(x / 2);
    for (let b = 0, g = 0; b < x; b += 2) {
      const a = l.charCodeAt(b), c = l.charCodeAt(b + 1);
      v[g++] = a | c << 8;
    }
    return v;
  }
  return qe;
}
var tu;
function uu() {
  if (tu) return Se;
  tu = 1, Object.defineProperty(Se, "__esModule", { value: !0 }), Se.htmlDecodeTree = void 0;
  const u = pr();
  return Se.htmlDecodeTree = (0, u.decodeBase64)("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"), Se;
}
var Ne = {}, ru;
function iu() {
  if (ru) return Ne;
  ru = 1, Object.defineProperty(Ne, "__esModule", { value: !0 }), Ne.xmlDecodeTree = void 0;
  const u = pr();
  return Ne.xmlDecodeTree = (0, u.decodeBase64)("AAJhZ2xxBwARABMAFQBtAg0AAAAAAA8AcAAmYG8AcwAnYHQAPmB0ADxg9SFvdCJg"), Ne;
}
var Re = {}, nu;
function Hr() {
  if (nu) return Re;
  nu = 1, Object.defineProperty(Re, "__esModule", { value: !0 }), Re.BinTrieFlags = void 0;
  var u;
  return (function(d) {
    d[d.VALUE_LENGTH = 49152] = "VALUE_LENGTH", d[d.FLAG13 = 8192] = "FLAG13", d[d.BRANCH_LENGTH = 8064] = "BRANCH_LENGTH", d[d.JUMP_TABLE = 127] = "JUMP_TABLE";
  })(u || (Re.BinTrieFlags = u = {})), Re;
}
var au;
function mr() {
  return au || (au = 1, (function(u) {
    Object.defineProperty(u, "__esModule", { value: !0 }), u.xmlDecodeTree = u.htmlDecodeTree = u.replaceCodePoint = u.fromCodePoint = u.decodeCodePoint = u.EntityDecoder = u.DecodingMode = void 0, u.determineBranch = y, u.decodeHTML = f, u.decodeHTMLAttribute = h, u.decodeHTMLStrict = m, u.decodeXML = o;
    const d = $t(), l = uu(), x = iu(), v = Hr();
    var b;
    (function(B) {
      B[B.NUM = 35] = "NUM", B[B.SEMI = 59] = "SEMI", B[B.EQUALS = 61] = "EQUALS", B[B.ZERO = 48] = "ZERO", B[B.NINE = 57] = "NINE", B[B.LOWER_A = 97] = "LOWER_A", B[B.LOWER_F = 102] = "LOWER_F", B[B.LOWER_X = 120] = "LOWER_X", B[B.LOWER_Z = 122] = "LOWER_Z", B[B.UPPER_A = 65] = "UPPER_A", B[B.UPPER_F = 70] = "UPPER_F", B[B.UPPER_Z = 90] = "UPPER_Z";
    })(b || (b = {}));
    const g = 32;
    function a(B) {
      return B >= b.ZERO && B <= b.NINE;
    }
    function c(B) {
      return B >= b.UPPER_A && B <= b.UPPER_F || B >= b.LOWER_A && B <= b.LOWER_F;
    }
    function e(B) {
      return B >= b.UPPER_A && B <= b.UPPER_Z || B >= b.LOWER_A && B <= b.LOWER_Z || a(B);
    }
    function t(B) {
      return B === b.EQUALS || e(B);
    }
    var n;
    (function(B) {
      B[B.EntityStart = 0] = "EntityStart", B[B.NumericStart = 1] = "NumericStart", B[B.NumericDecimal = 2] = "NumericDecimal", B[B.NumericHex = 3] = "NumericHex", B[B.NamedEntity = 4] = "NamedEntity";
    })(n || (n = {}));
    var r;
    (function(B) {
      B[B.Legacy = 0] = "Legacy", B[B.Strict = 1] = "Strict", B[B.Attribute = 2] = "Attribute";
    })(r || (u.DecodingMode = r = {}));
    class i {
      constructor(S, I, E) {
        this.decodeTree = S, this.emitCodePoint = I, this.errors = E, this.state = n.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = r.Strict, this.runConsumed = 0;
      }
      /** Resets the instance to make it reusable. */
      startEntity(S) {
        this.decodeMode = S, this.state = n.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1, this.runConsumed = 0;
      }
      /**
       * Write an entity to the decoder. This can be called multiple times with partial entities.
       * If the entity is incomplete, the decoder will return -1.
       *
       * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
       * entity is incomplete, and resume when the next string is written.
       *
       * @param input The string containing the entity (or a continuation of the entity).
       * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
       * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
       */
      write(S, I) {
        switch (this.state) {
          case n.EntityStart:
            return S.charCodeAt(I) === b.NUM ? (this.state = n.NumericStart, this.consumed += 1, this.stateNumericStart(S, I + 1)) : (this.state = n.NamedEntity, this.stateNamedEntity(S, I));
          case n.NumericStart:
            return this.stateNumericStart(S, I);
          case n.NumericDecimal:
            return this.stateNumericDecimal(S, I);
          case n.NumericHex:
            return this.stateNumericHex(S, I);
          case n.NamedEntity:
            return this.stateNamedEntity(S, I);
        }
      }
      /**
       * Switches between the numeric decimal and hexadecimal states.
       *
       * Equivalent to the `Numeric character reference state` in the HTML spec.
       *
       * @param input The string containing the entity (or a continuation of the entity).
       * @param offset The current offset.
       * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
       */
      stateNumericStart(S, I) {
        return I >= S.length ? -1 : (S.charCodeAt(I) | g) === b.LOWER_X ? (this.state = n.NumericHex, this.consumed += 1, this.stateNumericHex(S, I + 1)) : (this.state = n.NumericDecimal, this.stateNumericDecimal(S, I));
      }
      /**
       * Parses a hexadecimal numeric entity.
       *
       * Equivalent to the `Hexademical character reference state` in the HTML spec.
       *
       * @param input The string containing the entity (or a continuation of the entity).
       * @param offset The current offset.
       * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
       */
      stateNumericHex(S, I) {
        for (; I < S.length; ) {
          const E = S.charCodeAt(I);
          if (a(E) || c(E)) {
            const R = E <= b.NINE ? E - b.ZERO : (E | g) - b.LOWER_A + 10;
            this.result = this.result * 16 + R, this.consumed++, I++;
          } else
            return this.emitNumericEntity(E, 3);
        }
        return -1;
      }
      /**
       * Parses a decimal numeric entity.
       *
       * Equivalent to the `Decimal character reference state` in the HTML spec.
       *
       * @param input The string containing the entity (or a continuation of the entity).
       * @param offset The current offset.
       * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
       */
      stateNumericDecimal(S, I) {
        for (; I < S.length; ) {
          const E = S.charCodeAt(I);
          if (a(E))
            this.result = this.result * 10 + (E - b.ZERO), this.consumed++, I++;
          else
            return this.emitNumericEntity(E, 2);
        }
        return -1;
      }
      /**
       * Validate and emit a numeric entity.
       *
       * Implements the logic from the `Hexademical character reference start
       * state` and `Numeric character reference end state` in the HTML spec.
       *
       * @param lastCp The last code point of the entity. Used to see if the
       *               entity was terminated with a semicolon.
       * @param expectedLength The minimum number of characters that should be
       *                       consumed. Used to validate that at least one digit
       *                       was consumed.
       * @returns The number of characters that were consumed.
       */
      emitNumericEntity(S, I) {
        var E;
        if (this.consumed <= I)
          return (E = this.errors) === null || E === void 0 || E.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
        if (S === b.SEMI)
          this.consumed += 1;
        else if (this.decodeMode === r.Strict)
          return 0;
        return this.emitCodePoint((0, d.replaceCodePoint)(this.result), this.consumed), this.errors && (S !== b.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
      }
      /**
       * Parses a named entity.
       *
       * Equivalent to the `Named character reference state` in the HTML spec.
       *
       * @param input The string containing the entity (or a continuation of the entity).
       * @param offset The current offset.
       * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
       */
      stateNamedEntity(S, I) {
        const { decodeTree: E } = this;
        let R = E[this.treeIndex], k = (R & v.BinTrieFlags.VALUE_LENGTH) >> 14;
        for (; I < S.length; ) {
          if (k === 0 && (R & v.BinTrieFlags.FLAG13) !== 0) {
            const q = (R & v.BinTrieFlags.BRANCH_LENGTH) >> 7;
            if (this.runConsumed === 0) {
              const M = R & v.BinTrieFlags.JUMP_TABLE;
              if (S.charCodeAt(I) !== M)
                return this.result === 0 ? 0 : this.emitNotTerminatedNamedEntity();
              I++, this.excess++, this.runConsumed++;
            }
            for (; this.runConsumed < q; ) {
              if (I >= S.length)
                return -1;
              const M = this.runConsumed - 1, G = E[this.treeIndex + 1 + (M >> 1)], J = M % 2 === 0 ? G & 255 : G >> 8 & 255;
              if (S.charCodeAt(I) !== J)
                return this.runConsumed = 0, this.result === 0 ? 0 : this.emitNotTerminatedNamedEntity();
              I++, this.excess++, this.runConsumed++;
            }
            this.runConsumed = 0, this.treeIndex += 1 + (q >> 1), R = E[this.treeIndex], k = (R & v.BinTrieFlags.VALUE_LENGTH) >> 14;
          }
          if (I >= S.length)
            break;
          const N = S.charCodeAt(I);
          if (N === b.SEMI && k !== 0 && (R & v.BinTrieFlags.FLAG13) !== 0)
            return this.emitNamedEntityData(this.treeIndex, k, this.consumed + this.excess);
          if (this.treeIndex = y(E, R, this.treeIndex + Math.max(1, k), N), this.treeIndex < 0)
            return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === r.Attribute && // We shouldn't have consumed any characters after the entity,
            (k === 0 || // And there should be no invalid characters.
            t(N)) ? 0 : this.emitNotTerminatedNamedEntity();
          if (R = E[this.treeIndex], k = (R & v.BinTrieFlags.VALUE_LENGTH) >> 14, k !== 0) {
            if (N === b.SEMI)
              return this.emitNamedEntityData(this.treeIndex, k, this.consumed + this.excess);
            this.decodeMode !== r.Strict && (R & v.BinTrieFlags.FLAG13) === 0 && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
          }
          I++, this.excess++;
        }
        return -1;
      }
      /**
       * Emit a named entity that was not terminated with a semicolon.
       *
       * @returns The number of characters consumed.
       */
      emitNotTerminatedNamedEntity() {
        var S;
        const { result: I, decodeTree: E } = this, R = (E[I] & v.BinTrieFlags.VALUE_LENGTH) >> 14;
        return this.emitNamedEntityData(I, R, this.consumed), (S = this.errors) === null || S === void 0 || S.missingSemicolonAfterCharacterReference(), this.consumed;
      }
      /**
       * Emit a named entity.
       *
       * @param result The index of the entity in the decode tree.
       * @param valueLength The number of bytes in the entity.
       * @param consumed The number of characters consumed.
       *
       * @returns The number of characters consumed.
       */
      emitNamedEntityData(S, I, E) {
        const { decodeTree: R } = this;
        return this.emitCodePoint(I === 1 ? R[S] & ~(v.BinTrieFlags.VALUE_LENGTH | v.BinTrieFlags.FLAG13) : R[S + 1], E), I === 3 && this.emitCodePoint(R[S + 2], E), E;
      }
      /**
       * Signal to the parser that the end of the input was reached.
       *
       * Remaining data will be emitted and relevant errors will be produced.
       *
       * @returns The number of characters consumed.
       */
      end() {
        var S;
        switch (this.state) {
          case n.NamedEntity:
            return this.result !== 0 && (this.decodeMode !== r.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
          // Otherwise, emit a numeric entity if we have one.
          case n.NumericDecimal:
            return this.emitNumericEntity(0, 2);
          case n.NumericHex:
            return this.emitNumericEntity(0, 3);
          case n.NumericStart:
            return (S = this.errors) === null || S === void 0 || S.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          case n.EntityStart:
            return 0;
        }
      }
    }
    u.EntityDecoder = i;
    function A(B) {
      let S = "";
      const I = new i(B, (E) => S += (0, d.fromCodePoint)(E));
      return function(R, k) {
        let N = 0, q = 0;
        for (; (q = R.indexOf("&", q)) >= 0; ) {
          S += R.slice(N, q), I.startEntity(k);
          const G = I.write(
            R,
            // Skip the "&"
            q + 1
          );
          if (G < 0) {
            N = q + I.end();
            break;
          }
          N = q + G, q = G === 0 ? N + 1 : N;
        }
        const M = S + R.slice(N);
        return S = "", M;
      };
    }
    function y(B, S, I, E) {
      const R = (S & v.BinTrieFlags.BRANCH_LENGTH) >> 7, k = S & v.BinTrieFlags.JUMP_TABLE;
      if (R === 0)
        return k !== 0 && E === k ? I : -1;
      if (k) {
        const G = E - k;
        return G < 0 || G >= R ? -1 : B[I + G] - 1;
      }
      const N = R + 1 >> 1;
      let q = 0, M = R - 1;
      for (; q <= M; ) {
        const G = q + M >>> 1, J = G >> 1, z = B[I + J] >> (G & 1) * 8 & 255;
        if (z < E)
          q = G + 1;
        else if (z > E)
          M = G - 1;
        else
          return B[I + N + G];
      }
      return -1;
    }
    const w = /* @__PURE__ */ A(l.htmlDecodeTree), s = /* @__PURE__ */ A(x.xmlDecodeTree);
    function f(B, S = r.Legacy) {
      return w(B, S);
    }
    function h(B) {
      return w(B, r.Attribute);
    }
    function m(B) {
      return w(B, r.Strict);
    }
    function o(B) {
      return s(B, r.Strict);
    }
    var p = $t();
    Object.defineProperty(u, "decodeCodePoint", { enumerable: !0, get: function() {
      return p.decodeCodePoint;
    } }), Object.defineProperty(u, "fromCodePoint", { enumerable: !0, get: function() {
      return p.fromCodePoint;
    } }), Object.defineProperty(u, "replaceCodePoint", { enumerable: !0, get: function() {
      return p.replaceCodePoint;
    } });
    var C = uu();
    Object.defineProperty(u, "htmlDecodeTree", { enumerable: !0, get: function() {
      return C.htmlDecodeTree;
    } });
    var D = iu();
    Object.defineProperty(u, "xmlDecodeTree", { enumerable: !0, get: function() {
      return D.xmlDecodeTree;
    } });
  })(et)), et;
}
var su;
function yr() {
  if (su) return xe;
  su = 1, Object.defineProperty(xe, "__esModule", { value: !0 }), xe.QuoteType = void 0;
  const u = /* @__PURE__ */ mr();
  var d;
  (function(e) {
    e[e.Tab = 9] = "Tab", e[e.NewLine = 10] = "NewLine", e[e.FormFeed = 12] = "FormFeed", e[e.CarriageReturn = 13] = "CarriageReturn", e[e.Space = 32] = "Space", e[e.ExclamationMark = 33] = "ExclamationMark", e[e.Number = 35] = "Number", e[e.Amp = 38] = "Amp", e[e.SingleQuote = 39] = "SingleQuote", e[e.DoubleQuote = 34] = "DoubleQuote", e[e.Dash = 45] = "Dash", e[e.Slash = 47] = "Slash", e[e.Zero = 48] = "Zero", e[e.Nine = 57] = "Nine", e[e.Semi = 59] = "Semi", e[e.Lt = 60] = "Lt", e[e.Eq = 61] = "Eq", e[e.Gt = 62] = "Gt", e[e.Questionmark = 63] = "Questionmark", e[e.UpperA = 65] = "UpperA", e[e.LowerA = 97] = "LowerA", e[e.UpperF = 70] = "UpperF", e[e.LowerF = 102] = "LowerF", e[e.UpperZ = 90] = "UpperZ", e[e.LowerZ = 122] = "LowerZ", e[e.LowerX = 120] = "LowerX", e[e.OpeningSquareBracket = 91] = "OpeningSquareBracket";
  })(d || (d = {}));
  var l;
  (function(e) {
    e[e.Text = 1] = "Text", e[e.BeforeTagName = 2] = "BeforeTagName", e[e.InTagName = 3] = "InTagName", e[e.InSelfClosingTag = 4] = "InSelfClosingTag", e[e.BeforeClosingTagName = 5] = "BeforeClosingTagName", e[e.InClosingTagName = 6] = "InClosingTagName", e[e.AfterClosingTagName = 7] = "AfterClosingTagName", e[e.BeforeAttributeName = 8] = "BeforeAttributeName", e[e.InAttributeName = 9] = "InAttributeName", e[e.AfterAttributeName = 10] = "AfterAttributeName", e[e.BeforeAttributeValue = 11] = "BeforeAttributeValue", e[e.InAttributeValueDq = 12] = "InAttributeValueDq", e[e.InAttributeValueSq = 13] = "InAttributeValueSq", e[e.InAttributeValueNq = 14] = "InAttributeValueNq", e[e.BeforeDeclaration = 15] = "BeforeDeclaration", e[e.InDeclaration = 16] = "InDeclaration", e[e.InProcessingInstruction = 17] = "InProcessingInstruction", e[e.BeforeComment = 18] = "BeforeComment", e[e.CDATASequence = 19] = "CDATASequence", e[e.InSpecialComment = 20] = "InSpecialComment", e[e.InCommentLike = 21] = "InCommentLike", e[e.BeforeSpecialS = 22] = "BeforeSpecialS", e[e.BeforeSpecialT = 23] = "BeforeSpecialT", e[e.SpecialStartSequence = 24] = "SpecialStartSequence", e[e.InSpecialTag = 25] = "InSpecialTag", e[e.InEntity = 26] = "InEntity";
  })(l || (l = {}));
  function x(e) {
    return e === d.Space || e === d.NewLine || e === d.Tab || e === d.FormFeed || e === d.CarriageReturn;
  }
  function v(e) {
    return e === d.Slash || e === d.Gt || x(e);
  }
  function b(e) {
    return e >= d.LowerA && e <= d.LowerZ || e >= d.UpperA && e <= d.UpperZ;
  }
  var g;
  (function(e) {
    e[e.NoValue = 0] = "NoValue", e[e.Unquoted = 1] = "Unquoted", e[e.Single = 2] = "Single", e[e.Double = 3] = "Double";
  })(g || (xe.QuoteType = g = {}));
  const a = {
    Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
    // CDATA[
    CdataEnd: new Uint8Array([93, 93, 62]),
    // ]]>
    CommentEnd: new Uint8Array([45, 45, 62]),
    // `-->`
    ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
    // `<\/script`
    StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
    // `</style`
    TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101]),
    // `</title`
    TextareaEnd: new Uint8Array([
      60,
      47,
      116,
      101,
      120,
      116,
      97,
      114,
      101,
      97
    ]),
    // `</textarea`
    XmpEnd: new Uint8Array([60, 47, 120, 109, 112])
    // `</xmp`
  };
  let c = class {
    constructor({ xmlMode: t = !1, decodeEntities: n = !0 }, r) {
      this.cbs = r, this.state = l.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.entityStart = 0, this.baseState = l.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.xmlMode = t, this.decodeEntities = n, this.entityDecoder = new u.EntityDecoder(t ? u.xmlDecodeTree : u.htmlDecodeTree, (i, A) => this.emitCodePoint(i, A));
    }
    reset() {
      this.state = l.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = l.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
    }
    write(t) {
      this.offset += this.buffer.length, this.buffer = t, this.parse();
    }
    end() {
      this.running && this.finish();
    }
    pause() {
      this.running = !1;
    }
    resume() {
      this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
    }
    stateText(t) {
      t === d.Lt || !this.decodeEntities && this.fastForwardTo(d.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = l.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && t === d.Amp && this.startEntity();
    }
    stateSpecialStartSequence(t) {
      const n = this.sequenceIndex === this.currentSequence.length;
      if (!(n ? (
        // If we are at the end of the sequence, make sure the tag name has ended
        v(t)
      ) : (
        // Otherwise, do a case-insensitive comparison
        (t | 32) === this.currentSequence[this.sequenceIndex]
      )))
        this.isSpecial = !1;
      else if (!n) {
        this.sequenceIndex++;
        return;
      }
      this.sequenceIndex = 0, this.state = l.InTagName, this.stateInTagName(t);
    }
    /** Look for an end tag. For <title> tags, also decode entities. */
    stateInSpecialTag(t) {
      if (this.sequenceIndex === this.currentSequence.length) {
        if (t === d.Gt || x(t)) {
          const n = this.index - this.currentSequence.length;
          if (this.sectionStart < n) {
            const r = this.index;
            this.index = n, this.cbs.ontext(this.sectionStart, n), this.index = r;
          }
          this.isSpecial = !1, this.sectionStart = n + 2, this.stateInClosingTagName(t);
          return;
        }
        this.sequenceIndex = 0;
      }
      (t | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === a.TitleEnd ? this.decodeEntities && t === d.Amp && this.startEntity() : this.fastForwardTo(d.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(t === d.Lt);
    }
    stateCDATASequence(t) {
      t === a.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === a.Cdata.length && (this.state = l.InCommentLike, this.currentSequence = a.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = l.InDeclaration, this.stateInDeclaration(t));
    }
    /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */
    fastForwardTo(t) {
      for (; ++this.index < this.buffer.length + this.offset; )
        if (this.buffer.charCodeAt(this.index - this.offset) === t)
          return !0;
      return this.index = this.buffer.length + this.offset - 1, !1;
    }
    /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */
    stateInCommentLike(t) {
      t === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === a.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = l.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : t !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
    }
    /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */
    isTagStartChar(t) {
      return this.xmlMode ? !v(t) : b(t);
    }
    startSpecial(t, n) {
      this.isSpecial = !0, this.currentSequence = t, this.sequenceIndex = n, this.state = l.SpecialStartSequence;
    }
    stateBeforeTagName(t) {
      if (t === d.ExclamationMark)
        this.state = l.BeforeDeclaration, this.sectionStart = this.index + 1;
      else if (t === d.Questionmark)
        this.state = l.InProcessingInstruction, this.sectionStart = this.index + 1;
      else if (this.isTagStartChar(t)) {
        const n = t | 32;
        this.sectionStart = this.index, this.xmlMode ? this.state = l.InTagName : n === a.ScriptEnd[2] ? this.state = l.BeforeSpecialS : n === a.TitleEnd[2] || n === a.XmpEnd[2] ? this.state = l.BeforeSpecialT : this.state = l.InTagName;
      } else t === d.Slash ? this.state = l.BeforeClosingTagName : (this.state = l.Text, this.stateText(t));
    }
    stateInTagName(t) {
      v(t) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = l.BeforeAttributeName, this.stateBeforeAttributeName(t));
    }
    stateBeforeClosingTagName(t) {
      x(t) || (t === d.Gt ? this.state = l.Text : (this.state = this.isTagStartChar(t) ? l.InClosingTagName : l.InSpecialComment, this.sectionStart = this.index));
    }
    stateInClosingTagName(t) {
      (t === d.Gt || x(t)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = l.AfterClosingTagName, this.stateAfterClosingTagName(t));
    }
    stateAfterClosingTagName(t) {
      (t === d.Gt || this.fastForwardTo(d.Gt)) && (this.state = l.Text, this.sectionStart = this.index + 1);
    }
    stateBeforeAttributeName(t) {
      t === d.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = l.InSpecialTag, this.sequenceIndex = 0) : this.state = l.Text, this.sectionStart = this.index + 1) : t === d.Slash ? this.state = l.InSelfClosingTag : x(t) || (this.state = l.InAttributeName, this.sectionStart = this.index);
    }
    stateInSelfClosingTag(t) {
      t === d.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = l.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : x(t) || (this.state = l.BeforeAttributeName, this.stateBeforeAttributeName(t));
    }
    stateInAttributeName(t) {
      (t === d.Eq || v(t)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = this.index, this.state = l.AfterAttributeName, this.stateAfterAttributeName(t));
    }
    stateAfterAttributeName(t) {
      t === d.Eq ? this.state = l.BeforeAttributeValue : t === d.Slash || t === d.Gt ? (this.cbs.onattribend(g.NoValue, this.sectionStart), this.sectionStart = -1, this.state = l.BeforeAttributeName, this.stateBeforeAttributeName(t)) : x(t) || (this.cbs.onattribend(g.NoValue, this.sectionStart), this.state = l.InAttributeName, this.sectionStart = this.index);
    }
    stateBeforeAttributeValue(t) {
      t === d.DoubleQuote ? (this.state = l.InAttributeValueDq, this.sectionStart = this.index + 1) : t === d.SingleQuote ? (this.state = l.InAttributeValueSq, this.sectionStart = this.index + 1) : x(t) || (this.sectionStart = this.index, this.state = l.InAttributeValueNq, this.stateInAttributeValueNoQuotes(t));
    }
    handleInAttributeValue(t, n) {
      t === n || !this.decodeEntities && this.fastForwardTo(n) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(n === d.DoubleQuote ? g.Double : g.Single, this.index + 1), this.state = l.BeforeAttributeName) : this.decodeEntities && t === d.Amp && this.startEntity();
    }
    stateInAttributeValueDoubleQuotes(t) {
      this.handleInAttributeValue(t, d.DoubleQuote);
    }
    stateInAttributeValueSingleQuotes(t) {
      this.handleInAttributeValue(t, d.SingleQuote);
    }
    stateInAttributeValueNoQuotes(t) {
      x(t) || t === d.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(g.Unquoted, this.index), this.state = l.BeforeAttributeName, this.stateBeforeAttributeName(t)) : this.decodeEntities && t === d.Amp && this.startEntity();
    }
    stateBeforeDeclaration(t) {
      t === d.OpeningSquareBracket ? (this.state = l.CDATASequence, this.sequenceIndex = 0) : this.state = t === d.Dash ? l.BeforeComment : l.InDeclaration;
    }
    stateInDeclaration(t) {
      (t === d.Gt || this.fastForwardTo(d.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = l.Text, this.sectionStart = this.index + 1);
    }
    stateInProcessingInstruction(t) {
      (t === d.Gt || this.fastForwardTo(d.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = l.Text, this.sectionStart = this.index + 1);
    }
    stateBeforeComment(t) {
      t === d.Dash ? (this.state = l.InCommentLike, this.currentSequence = a.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = l.InDeclaration;
    }
    stateInSpecialComment(t) {
      (t === d.Gt || this.fastForwardTo(d.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = l.Text, this.sectionStart = this.index + 1);
    }
    stateBeforeSpecialS(t) {
      const n = t | 32;
      n === a.ScriptEnd[3] ? this.startSpecial(a.ScriptEnd, 4) : n === a.StyleEnd[3] ? this.startSpecial(a.StyleEnd, 4) : (this.state = l.InTagName, this.stateInTagName(t));
    }
    stateBeforeSpecialT(t) {
      switch (t | 32) {
        case a.TitleEnd[3]: {
          this.startSpecial(a.TitleEnd, 4);
          break;
        }
        case a.TextareaEnd[3]: {
          this.startSpecial(a.TextareaEnd, 4);
          break;
        }
        case a.XmpEnd[3]: {
          this.startSpecial(a.XmpEnd, 4);
          break;
        }
        default:
          this.state = l.InTagName, this.stateInTagName(t);
      }
    }
    startEntity() {
      this.baseState = this.state, this.state = l.InEntity, this.entityStart = this.index, this.entityDecoder.startEntity(this.xmlMode ? u.DecodingMode.Strict : this.baseState === l.Text || this.baseState === l.InSpecialTag ? u.DecodingMode.Legacy : u.DecodingMode.Attribute);
    }
    stateInEntity() {
      const t = this.index - this.offset, n = this.entityDecoder.write(this.buffer, t);
      if (n >= 0)
        this.state = this.baseState, n === 0 && (this.index -= 1);
      else {
        if (t < this.buffer.length && this.buffer.charCodeAt(t) === d.Amp) {
          this.state = this.baseState, this.index -= 1;
          return;
        }
        this.index = this.offset + this.buffer.length - 1;
      }
    }
    /**
     * Remove data that has already been consumed from the buffer.
     */
    cleanup() {
      this.running && this.sectionStart !== this.index && (this.state === l.Text || this.state === l.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === l.InAttributeValueDq || this.state === l.InAttributeValueSq || this.state === l.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
    }
    shouldContinue() {
      return this.index < this.buffer.length + this.offset && this.running;
    }
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */
    parse() {
      for (; this.shouldContinue(); ) {
        const t = this.buffer.charCodeAt(this.index - this.offset);
        switch (this.state) {
          case l.Text: {
            this.stateText(t);
            break;
          }
          case l.SpecialStartSequence: {
            this.stateSpecialStartSequence(t);
            break;
          }
          case l.InSpecialTag: {
            this.stateInSpecialTag(t);
            break;
          }
          case l.CDATASequence: {
            this.stateCDATASequence(t);
            break;
          }
          case l.InAttributeValueDq: {
            this.stateInAttributeValueDoubleQuotes(t);
            break;
          }
          case l.InAttributeName: {
            this.stateInAttributeName(t);
            break;
          }
          case l.InCommentLike: {
            this.stateInCommentLike(t);
            break;
          }
          case l.InSpecialComment: {
            this.stateInSpecialComment(t);
            break;
          }
          case l.BeforeAttributeName: {
            this.stateBeforeAttributeName(t);
            break;
          }
          case l.InTagName: {
            this.stateInTagName(t);
            break;
          }
          case l.InClosingTagName: {
            this.stateInClosingTagName(t);
            break;
          }
          case l.BeforeTagName: {
            this.stateBeforeTagName(t);
            break;
          }
          case l.AfterAttributeName: {
            this.stateAfterAttributeName(t);
            break;
          }
          case l.InAttributeValueSq: {
            this.stateInAttributeValueSingleQuotes(t);
            break;
          }
          case l.BeforeAttributeValue: {
            this.stateBeforeAttributeValue(t);
            break;
          }
          case l.BeforeClosingTagName: {
            this.stateBeforeClosingTagName(t);
            break;
          }
          case l.AfterClosingTagName: {
            this.stateAfterClosingTagName(t);
            break;
          }
          case l.BeforeSpecialS: {
            this.stateBeforeSpecialS(t);
            break;
          }
          case l.BeforeSpecialT: {
            this.stateBeforeSpecialT(t);
            break;
          }
          case l.InAttributeValueNq: {
            this.stateInAttributeValueNoQuotes(t);
            break;
          }
          case l.InSelfClosingTag: {
            this.stateInSelfClosingTag(t);
            break;
          }
          case l.InDeclaration: {
            this.stateInDeclaration(t);
            break;
          }
          case l.BeforeDeclaration: {
            this.stateBeforeDeclaration(t);
            break;
          }
          case l.BeforeComment: {
            this.stateBeforeComment(t);
            break;
          }
          case l.InProcessingInstruction: {
            this.stateInProcessingInstruction(t);
            break;
          }
          case l.InEntity: {
            this.stateInEntity();
            break;
          }
        }
        this.index++;
      }
      this.cleanup();
    }
    finish() {
      this.state === l.InEntity && (this.entityDecoder.end(), this.state = this.baseState), this.handleTrailingData(), this.cbs.onend();
    }
    /** Handle any trailing data. */
    handleTrailingData() {
      const t = this.buffer.length + this.offset;
      this.sectionStart >= t || (this.state === l.InCommentLike ? this.currentSequence === a.CdataEnd ? this.cbs.oncdata(this.sectionStart, t, 0) : this.cbs.oncomment(this.sectionStart, t, 0) : this.state === l.InTagName || this.state === l.BeforeAttributeName || this.state === l.BeforeAttributeValue || this.state === l.AfterAttributeName || this.state === l.InAttributeName || this.state === l.InAttributeValueSq || this.state === l.InAttributeValueDq || this.state === l.InAttributeValueNq || this.state === l.InClosingTagName || this.cbs.ontext(this.sectionStart, t));
    }
    emitCodePoint(t, n) {
      this.baseState !== l.Text && this.baseState !== l.InSpecialTag ? (this.sectionStart < this.entityStart && this.cbs.onattribdata(this.sectionStart, this.entityStart), this.sectionStart = this.entityStart + n, this.index = this.sectionStart - 1, this.cbs.onattribentity(t)) : (this.sectionStart < this.entityStart && this.cbs.ontext(this.sectionStart, this.entityStart), this.sectionStart = this.entityStart + n, this.index = this.sectionStart - 1, this.cbs.ontextentity(t, this.sectionStart));
    }
  };
  return xe.default = c, xe;
}
var ou;
function cu() {
  if (ou) return ue;
  ou = 1;
  var u = ue && ue.__createBinding || (Object.create ? (function(w, s, f, h) {
    h === void 0 && (h = f);
    var m = Object.getOwnPropertyDescriptor(s, f);
    (!m || ("get" in m ? !s.__esModule : m.writable || m.configurable)) && (m = { enumerable: !0, get: function() {
      return s[f];
    } }), Object.defineProperty(w, h, m);
  }) : (function(w, s, f, h) {
    h === void 0 && (h = f), w[h] = s[f];
  })), d = ue && ue.__setModuleDefault || (Object.create ? (function(w, s) {
    Object.defineProperty(w, "default", { enumerable: !0, value: s });
  }) : function(w, s) {
    w.default = s;
  }), l = ue && ue.__importStar || /* @__PURE__ */ (function() {
    var w = function(s) {
      return w = Object.getOwnPropertyNames || function(f) {
        var h = [];
        for (var m in f) Object.prototype.hasOwnProperty.call(f, m) && (h[h.length] = m);
        return h;
      }, w(s);
    };
    return function(s) {
      if (s && s.__esModule) return s;
      var f = {};
      if (s != null) for (var h = w(s), m = 0; m < h.length; m++) h[m] !== "default" && u(f, s, h[m]);
      return d(f, s), f;
    };
  })();
  Object.defineProperty(ue, "__esModule", { value: !0 }), ue.Parser = void 0;
  const x = l(yr()), v = /* @__PURE__ */ mr(), b = /* @__PURE__ */ new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
  ]), g = /* @__PURE__ */ new Set(["p"]), a = /* @__PURE__ */ new Set(["thead", "tbody"]), c = /* @__PURE__ */ new Set(["dd", "dt"]), e = /* @__PURE__ */ new Set(["rt", "rp"]), t = /* @__PURE__ */ new Map([
    ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
    ["th", /* @__PURE__ */ new Set(["th"])],
    ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
    ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
    ["li", /* @__PURE__ */ new Set(["li"])],
    ["p", g],
    ["h1", g],
    ["h2", g],
    ["h3", g],
    ["h4", g],
    ["h5", g],
    ["h6", g],
    ["select", b],
    ["input", b],
    ["output", b],
    ["button", b],
    ["datalist", b],
    ["textarea", b],
    ["option", /* @__PURE__ */ new Set(["option"])],
    ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
    ["dd", c],
    ["dt", c],
    ["address", g],
    ["article", g],
    ["aside", g],
    ["blockquote", g],
    ["details", g],
    ["div", g],
    ["dl", g],
    ["fieldset", g],
    ["figcaption", g],
    ["figure", g],
    ["footer", g],
    ["form", g],
    ["header", g],
    ["hr", g],
    ["main", g],
    ["nav", g],
    ["ol", g],
    ["pre", g],
    ["section", g],
    ["table", g],
    ["ul", g],
    ["rt", e],
    ["rp", e],
    ["tbody", a],
    ["tfoot", a]
  ]), n = /* @__PURE__ */ new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
  ]), r = /* @__PURE__ */ new Set(["math", "svg"]), i = /* @__PURE__ */ new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
  ]), A = /\s|\//;
  let y = class {
    constructor(s, f = {}) {
      var h, m, o, p, C, D;
      this.options = f, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = s ?? {}, this.htmlMode = !this.options.xmlMode, this.lowerCaseTagNames = (h = f.lowerCaseTags) !== null && h !== void 0 ? h : this.htmlMode, this.lowerCaseAttributeNames = (m = f.lowerCaseAttributeNames) !== null && m !== void 0 ? m : this.htmlMode, this.recognizeSelfClosing = (o = f.recognizeSelfClosing) !== null && o !== void 0 ? o : !this.htmlMode, this.tokenizer = new ((p = f.Tokenizer) !== null && p !== void 0 ? p : x.default)(this.options, this), this.foreignContext = [!this.htmlMode], (D = (C = this.cbs).onparserinit) === null || D === void 0 || D.call(C, this);
    }
    // Tokenizer event handlers
    /** @internal */
    ontext(s, f) {
      var h, m;
      const o = this.getSlice(s, f);
      this.endIndex = f - 1, (m = (h = this.cbs).ontext) === null || m === void 0 || m.call(h, o), this.startIndex = f;
    }
    /** @internal */
    ontextentity(s, f) {
      var h, m;
      this.endIndex = f - 1, (m = (h = this.cbs).ontext) === null || m === void 0 || m.call(h, (0, v.fromCodePoint)(s)), this.startIndex = f;
    }
    /**
     * Checks if the current tag is a void element. Override this if you want
     * to specify your own additional void elements.
     */
    isVoidElement(s) {
      return this.htmlMode && n.has(s);
    }
    /** @internal */
    onopentagname(s, f) {
      this.endIndex = f;
      let h = this.getSlice(s, f);
      this.lowerCaseTagNames && (h = h.toLowerCase()), this.emitOpenTag(h);
    }
    emitOpenTag(s) {
      var f, h, m, o;
      this.openTagStart = this.startIndex, this.tagname = s;
      const p = this.htmlMode && t.get(s);
      if (p)
        for (; this.stack.length > 0 && p.has(this.stack[0]); ) {
          const C = this.stack.shift();
          (h = (f = this.cbs).onclosetag) === null || h === void 0 || h.call(f, C, !0);
        }
      this.isVoidElement(s) || (this.stack.unshift(s), this.htmlMode && (r.has(s) ? this.foreignContext.unshift(!0) : i.has(s) && this.foreignContext.unshift(!1))), (o = (m = this.cbs).onopentagname) === null || o === void 0 || o.call(m, s), this.cbs.onopentag && (this.attribs = {});
    }
    endOpenTag(s) {
      var f, h;
      this.startIndex = this.openTagStart, this.attribs && ((h = (f = this.cbs).onopentag) === null || h === void 0 || h.call(f, this.tagname, this.attribs, s), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
    }
    /** @internal */
    onopentagend(s) {
      this.endIndex = s, this.endOpenTag(!1), this.startIndex = s + 1;
    }
    /** @internal */
    onclosetag(s, f) {
      var h, m, o, p, C, D, B, S;
      this.endIndex = f;
      let I = this.getSlice(s, f);
      if (this.lowerCaseTagNames && (I = I.toLowerCase()), this.htmlMode && (r.has(I) || i.has(I)) && this.foreignContext.shift(), this.isVoidElement(I))
        this.htmlMode && I === "br" && ((p = (o = this.cbs).onopentagname) === null || p === void 0 || p.call(o, "br"), (D = (C = this.cbs).onopentag) === null || D === void 0 || D.call(C, "br", {}, !0), (S = (B = this.cbs).onclosetag) === null || S === void 0 || S.call(B, "br", !1));
      else {
        const E = this.stack.indexOf(I);
        if (E !== -1)
          for (let R = 0; R <= E; R++) {
            const k = this.stack.shift();
            (m = (h = this.cbs).onclosetag) === null || m === void 0 || m.call(h, k, R !== E);
          }
        else this.htmlMode && I === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
      }
      this.startIndex = f + 1;
    }
    /** @internal */
    onselfclosingtag(s) {
      this.endIndex = s, this.recognizeSelfClosing || this.foreignContext[0] ? (this.closeCurrentTag(!1), this.startIndex = s + 1) : this.onopentagend(s);
    }
    closeCurrentTag(s) {
      var f, h;
      const m = this.tagname;
      this.endOpenTag(s), this.stack[0] === m && ((h = (f = this.cbs).onclosetag) === null || h === void 0 || h.call(f, m, !s), this.stack.shift());
    }
    /** @internal */
    onattribname(s, f) {
      this.startIndex = s;
      const h = this.getSlice(s, f);
      this.attribname = this.lowerCaseAttributeNames ? h.toLowerCase() : h;
    }
    /** @internal */
    onattribdata(s, f) {
      this.attribvalue += this.getSlice(s, f);
    }
    /** @internal */
    onattribentity(s) {
      this.attribvalue += (0, v.fromCodePoint)(s);
    }
    /** @internal */
    onattribend(s, f) {
      var h, m;
      this.endIndex = f, (m = (h = this.cbs).onattribute) === null || m === void 0 || m.call(h, this.attribname, this.attribvalue, s === x.QuoteType.Double ? '"' : s === x.QuoteType.Single ? "'" : s === x.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
    }
    getInstructionName(s) {
      const f = s.search(A);
      let h = f < 0 ? s : s.substr(0, f);
      return this.lowerCaseTagNames && (h = h.toLowerCase()), h;
    }
    /** @internal */
    ondeclaration(s, f) {
      this.endIndex = f;
      const h = this.getSlice(s, f);
      if (this.cbs.onprocessinginstruction) {
        const m = this.getInstructionName(h);
        this.cbs.onprocessinginstruction(`!${m}`, `!${h}`);
      }
      this.startIndex = f + 1;
    }
    /** @internal */
    onprocessinginstruction(s, f) {
      this.endIndex = f;
      const h = this.getSlice(s, f);
      if (this.cbs.onprocessinginstruction) {
        const m = this.getInstructionName(h);
        this.cbs.onprocessinginstruction(`?${m}`, `?${h}`);
      }
      this.startIndex = f + 1;
    }
    /** @internal */
    oncomment(s, f, h) {
      var m, o, p, C;
      this.endIndex = f, (o = (m = this.cbs).oncomment) === null || o === void 0 || o.call(m, this.getSlice(s, f - h)), (C = (p = this.cbs).oncommentend) === null || C === void 0 || C.call(p), this.startIndex = f + 1;
    }
    /** @internal */
    oncdata(s, f, h) {
      var m, o, p, C, D, B, S, I, E, R;
      this.endIndex = f;
      const k = this.getSlice(s, f - h);
      !this.htmlMode || this.options.recognizeCDATA ? ((o = (m = this.cbs).oncdatastart) === null || o === void 0 || o.call(m), (C = (p = this.cbs).ontext) === null || C === void 0 || C.call(p, k), (B = (D = this.cbs).oncdataend) === null || B === void 0 || B.call(D)) : ((I = (S = this.cbs).oncomment) === null || I === void 0 || I.call(S, `[CDATA[${k}]]`), (R = (E = this.cbs).oncommentend) === null || R === void 0 || R.call(E)), this.startIndex = f + 1;
    }
    /** @internal */
    onend() {
      var s, f;
      if (this.cbs.onclosetag) {
        this.endIndex = this.startIndex;
        for (let h = 0; h < this.stack.length; h++)
          this.cbs.onclosetag(this.stack[h], !0);
      }
      (f = (s = this.cbs).onend) === null || f === void 0 || f.call(s);
    }
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */
    reset() {
      var s, f, h, m;
      (f = (s = this.cbs).onreset) === null || f === void 0 || f.call(s), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (m = (h = this.cbs).onparserinit) === null || m === void 0 || m.call(h, this), this.buffers.length = 0, this.foreignContext.length = 0, this.foreignContext.unshift(!this.htmlMode), this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
    }
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */
    parseComplete(s) {
      this.reset(), this.end(s);
    }
    getSlice(s, f) {
      for (; s - this.bufferOffset >= this.buffers[0].length; )
        this.shiftBuffer();
      let h = this.buffers[0].slice(s - this.bufferOffset, f - this.bufferOffset);
      for (; f - this.bufferOffset > this.buffers[0].length; )
        this.shiftBuffer(), h += this.buffers[0].slice(0, f - this.bufferOffset);
      return h;
    }
    shiftBuffer() {
      this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
    }
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */
    write(s) {
      var f, h;
      if (this.ended) {
        (h = (f = this.cbs).onerror) === null || h === void 0 || h.call(f, new Error(".write() after done!"));
        return;
      }
      this.buffers.push(s), this.tokenizer.running && (this.tokenizer.write(s), this.writeIndex++);
    }
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */
    end(s) {
      var f, h;
      if (this.ended) {
        (h = (f = this.cbs).onerror) === null || h === void 0 || h.call(f, new Error(".end() after done!"));
        return;
      }
      s && this.write(s), this.ended = !0, this.tokenizer.end();
    }
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */
    pause() {
      this.tokenizer.pause();
    }
    /**
     * Resumes parsing after `pause` was called.
     */
    resume() {
      for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
        this.tokenizer.write(this.buffers[this.writeIndex++]);
      this.ended && this.tokenizer.end();
    }
    /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */
    parseChunk(s) {
      this.write(s);
    }
    /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */
    done(s) {
      this.end(s);
    }
  };
  return ue.Parser = y, ue;
}
var pe = {}, ut = {}, lu;
function Fe() {
  return lu || (lu = 1, (function(u) {
    Object.defineProperty(u, "__esModule", { value: !0 }), u.Doctype = u.CDATA = u.Tag = u.Style = u.Script = u.Comment = u.Directive = u.Text = u.Root = u.isTag = u.ElementType = void 0;
    var d;
    (function(x) {
      x.Root = "root", x.Text = "text", x.Directive = "directive", x.Comment = "comment", x.Script = "script", x.Style = "style", x.Tag = "tag", x.CDATA = "cdata", x.Doctype = "doctype";
    })(d = u.ElementType || (u.ElementType = {}));
    function l(x) {
      return x.type === d.Tag || x.type === d.Script || x.type === d.Style;
    }
    u.isTag = l, u.Root = d.Root, u.Text = d.Text, u.Directive = d.Directive, u.Comment = d.Comment, u.Script = d.Script, u.Style = d.Style, u.Tag = d.Tag, u.CDATA = d.CDATA, u.Doctype = d.Doctype;
  })(ut)), ut;
}
var U = {}, Au;
function du() {
  if (Au) return U;
  Au = 1;
  var u = U && U.__extends || /* @__PURE__ */ (function() {
    var o = function(p, C) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(D, B) {
        D.__proto__ = B;
      } || function(D, B) {
        for (var S in B) Object.prototype.hasOwnProperty.call(B, S) && (D[S] = B[S]);
      }, o(p, C);
    };
    return function(p, C) {
      if (typeof C != "function" && C !== null)
        throw new TypeError("Class extends value " + String(C) + " is not a constructor or null");
      o(p, C);
      function D() {
        this.constructor = p;
      }
      p.prototype = C === null ? Object.create(C) : (D.prototype = C.prototype, new D());
    };
  })(), d = U && U.__assign || function() {
    return d = Object.assign || function(o) {
      for (var p, C = 1, D = arguments.length; C < D; C++) {
        p = arguments[C];
        for (var B in p) Object.prototype.hasOwnProperty.call(p, B) && (o[B] = p[B]);
      }
      return o;
    }, d.apply(this, arguments);
  };
  Object.defineProperty(U, "__esModule", { value: !0 }), U.cloneNode = U.hasChildren = U.isDocument = U.isDirective = U.isComment = U.isText = U.isCDATA = U.isTag = U.Element = U.Document = U.CDATA = U.NodeWithChildren = U.ProcessingInstruction = U.Comment = U.Text = U.DataNode = U.Node = void 0;
  var l = /* @__PURE__ */ Fe(), x = (
    /** @class */
    (function() {
      function o() {
        this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
      }
      return Object.defineProperty(o.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.parent;
        },
        set: function(p) {
          this.parent = p;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.prev;
        },
        set: function(p) {
          this.prev = p;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.next;
        },
        set: function(p) {
          this.next = p;
        },
        enumerable: !1,
        configurable: !0
      }), o.prototype.cloneNode = function(p) {
        return p === void 0 && (p = !1), h(this, p);
      }, o;
    })()
  );
  U.Node = x;
  var v = (
    /** @class */
    (function(o) {
      u(p, o);
      function p(C) {
        var D = o.call(this) || this;
        return D.data = C, D;
      }
      return Object.defineProperty(p.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.data;
        },
        set: function(C) {
          this.data = C;
        },
        enumerable: !1,
        configurable: !0
      }), p;
    })(x)
  );
  U.DataNode = v;
  var b = (
    /** @class */
    (function(o) {
      u(p, o);
      function p() {
        var C = o !== null && o.apply(this, arguments) || this;
        return C.type = l.ElementType.Text, C;
      }
      return Object.defineProperty(p.prototype, "nodeType", {
        get: function() {
          return 3;
        },
        enumerable: !1,
        configurable: !0
      }), p;
    })(v)
  );
  U.Text = b;
  var g = (
    /** @class */
    (function(o) {
      u(p, o);
      function p() {
        var C = o !== null && o.apply(this, arguments) || this;
        return C.type = l.ElementType.Comment, C;
      }
      return Object.defineProperty(p.prototype, "nodeType", {
        get: function() {
          return 8;
        },
        enumerable: !1,
        configurable: !0
      }), p;
    })(v)
  );
  U.Comment = g;
  var a = (
    /** @class */
    (function(o) {
      u(p, o);
      function p(C, D) {
        var B = o.call(this, D) || this;
        return B.name = C, B.type = l.ElementType.Directive, B;
      }
      return Object.defineProperty(p.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: !1,
        configurable: !0
      }), p;
    })(v)
  );
  U.ProcessingInstruction = a;
  var c = (
    /** @class */
    (function(o) {
      u(p, o);
      function p(C) {
        var D = o.call(this) || this;
        return D.children = C, D;
      }
      return Object.defineProperty(p.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function() {
          var C;
          return (C = this.children[0]) !== null && C !== void 0 ? C : null;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(p.prototype, "lastChild", {
        /** Last child of the node. */
        get: function() {
          return this.children.length > 0 ? this.children[this.children.length - 1] : null;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(p.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.children;
        },
        set: function(C) {
          this.children = C;
        },
        enumerable: !1,
        configurable: !0
      }), p;
    })(x)
  );
  U.NodeWithChildren = c;
  var e = (
    /** @class */
    (function(o) {
      u(p, o);
      function p() {
        var C = o !== null && o.apply(this, arguments) || this;
        return C.type = l.ElementType.CDATA, C;
      }
      return Object.defineProperty(p.prototype, "nodeType", {
        get: function() {
          return 4;
        },
        enumerable: !1,
        configurable: !0
      }), p;
    })(c)
  );
  U.CDATA = e;
  var t = (
    /** @class */
    (function(o) {
      u(p, o);
      function p() {
        var C = o !== null && o.apply(this, arguments) || this;
        return C.type = l.ElementType.Root, C;
      }
      return Object.defineProperty(p.prototype, "nodeType", {
        get: function() {
          return 9;
        },
        enumerable: !1,
        configurable: !0
      }), p;
    })(c)
  );
  U.Document = t;
  var n = (
    /** @class */
    (function(o) {
      u(p, o);
      function p(C, D, B, S) {
        B === void 0 && (B = []), S === void 0 && (S = C === "script" ? l.ElementType.Script : C === "style" ? l.ElementType.Style : l.ElementType.Tag);
        var I = o.call(this, B) || this;
        return I.name = C, I.attribs = D, I.type = S, I;
      }
      return Object.defineProperty(p.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(p.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.name;
        },
        set: function(C) {
          this.name = C;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(p.prototype, "attributes", {
        get: function() {
          var C = this;
          return Object.keys(this.attribs).map(function(D) {
            var B, S;
            return {
              name: D,
              value: C.attribs[D],
              namespace: (B = C["x-attribsNamespace"]) === null || B === void 0 ? void 0 : B[D],
              prefix: (S = C["x-attribsPrefix"]) === null || S === void 0 ? void 0 : S[D]
            };
          });
        },
        enumerable: !1,
        configurable: !0
      }), p;
    })(c)
  );
  U.Element = n;
  function r(o) {
    return (0, l.isTag)(o);
  }
  U.isTag = r;
  function i(o) {
    return o.type === l.ElementType.CDATA;
  }
  U.isCDATA = i;
  function A(o) {
    return o.type === l.ElementType.Text;
  }
  U.isText = A;
  function y(o) {
    return o.type === l.ElementType.Comment;
  }
  U.isComment = y;
  function w(o) {
    return o.type === l.ElementType.Directive;
  }
  U.isDirective = w;
  function s(o) {
    return o.type === l.ElementType.Root;
  }
  U.isDocument = s;
  function f(o) {
    return Object.prototype.hasOwnProperty.call(o, "children");
  }
  U.hasChildren = f;
  function h(o, p) {
    p === void 0 && (p = !1);
    var C;
    if (A(o))
      C = new b(o.data);
    else if (y(o))
      C = new g(o.data);
    else if (r(o)) {
      var D = p ? m(o.children) : [], B = new n(o.name, d({}, o.attribs), D);
      D.forEach(function(R) {
        return R.parent = B;
      }), o.namespace != null && (B.namespace = o.namespace), o["x-attribsNamespace"] && (B["x-attribsNamespace"] = d({}, o["x-attribsNamespace"])), o["x-attribsPrefix"] && (B["x-attribsPrefix"] = d({}, o["x-attribsPrefix"])), C = B;
    } else if (i(o)) {
      var D = p ? m(o.children) : [], S = new e(D);
      D.forEach(function(k) {
        return k.parent = S;
      }), C = S;
    } else if (s(o)) {
      var D = p ? m(o.children) : [], I = new t(D);
      D.forEach(function(k) {
        return k.parent = I;
      }), o["x-mode"] && (I["x-mode"] = o["x-mode"]), C = I;
    } else if (w(o)) {
      var E = new a(o.name, o.data);
      o["x-name"] != null && (E["x-name"] = o["x-name"], E["x-publicId"] = o["x-publicId"], E["x-systemId"] = o["x-systemId"]), C = E;
    } else
      throw new Error("Not implemented yet: ".concat(o.type));
    return C.startIndex = o.startIndex, C.endIndex = o.endIndex, o.sourceCodeLocation != null && (C.sourceCodeLocation = o.sourceCodeLocation), C;
  }
  U.cloneNode = h;
  function m(o) {
    for (var p = o.map(function(D) {
      return h(D, !0);
    }), C = 1; C < p.length; C++)
      p[C].prev = p[C - 1], p[C - 1].next = p[C];
    return p;
  }
  return U;
}
var fu;
function fe() {
  return fu || (fu = 1, (function(u) {
    var d = pe && pe.__createBinding || (Object.create ? (function(a, c, e, t) {
      t === void 0 && (t = e);
      var n = Object.getOwnPropertyDescriptor(c, e);
      (!n || ("get" in n ? !c.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return c[e];
      } }), Object.defineProperty(a, t, n);
    }) : (function(a, c, e, t) {
      t === void 0 && (t = e), a[t] = c[e];
    })), l = pe && pe.__exportStar || function(a, c) {
      for (var e in a) e !== "default" && !Object.prototype.hasOwnProperty.call(c, e) && d(c, a, e);
    };
    Object.defineProperty(u, "__esModule", { value: !0 }), u.DomHandler = void 0;
    var x = /* @__PURE__ */ Fe(), v = /* @__PURE__ */ du();
    l(/* @__PURE__ */ du(), u);
    var b = {
      withStartIndices: !1,
      withEndIndices: !1,
      xmlMode: !1
    }, g = (
      /** @class */
      (function() {
        function a(c, e, t) {
          this.dom = [], this.root = new v.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof e == "function" && (t = e, e = b), typeof c == "object" && (e = c, c = void 0), this.callback = c ?? null, this.options = e ?? b, this.elementCB = t ?? null;
        }
        return a.prototype.onparserinit = function(c) {
          this.parser = c;
        }, a.prototype.onreset = function() {
          this.dom = [], this.root = new v.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
        }, a.prototype.onend = function() {
          this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
        }, a.prototype.onerror = function(c) {
          this.handleCallback(c);
        }, a.prototype.onclosetag = function() {
          this.lastNode = null;
          var c = this.tagStack.pop();
          this.options.withEndIndices && (c.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(c);
        }, a.prototype.onopentag = function(c, e) {
          var t = this.options.xmlMode ? x.ElementType.Tag : void 0, n = new v.Element(c, e, void 0, t);
          this.addNode(n), this.tagStack.push(n);
        }, a.prototype.ontext = function(c) {
          var e = this.lastNode;
          if (e && e.type === x.ElementType.Text)
            e.data += c, this.options.withEndIndices && (e.endIndex = this.parser.endIndex);
          else {
            var t = new v.Text(c);
            this.addNode(t), this.lastNode = t;
          }
        }, a.prototype.oncomment = function(c) {
          if (this.lastNode && this.lastNode.type === x.ElementType.Comment) {
            this.lastNode.data += c;
            return;
          }
          var e = new v.Comment(c);
          this.addNode(e), this.lastNode = e;
        }, a.prototype.oncommentend = function() {
          this.lastNode = null;
        }, a.prototype.oncdatastart = function() {
          var c = new v.Text(""), e = new v.CDATA([c]);
          this.addNode(e), c.parent = e, this.lastNode = c;
        }, a.prototype.oncdataend = function() {
          this.lastNode = null;
        }, a.prototype.onprocessinginstruction = function(c, e) {
          var t = new v.ProcessingInstruction(c, e);
          this.addNode(t);
        }, a.prototype.handleCallback = function(c) {
          if (typeof this.callback == "function")
            this.callback(c, this.dom);
          else if (c)
            throw c;
        }, a.prototype.addNode = function(c) {
          var e = this.tagStack[this.tagStack.length - 1], t = e.children[e.children.length - 1];
          this.options.withStartIndices && (c.startIndex = this.parser.startIndex), this.options.withEndIndices && (c.endIndex = this.parser.endIndex), e.children.push(c), t && (c.prev = t, t.next = c), c.parent = e, this.lastNode = null;
        }, a;
      })()
    );
    u.DomHandler = g, u.default = g;
  })(pe)), pe;
}
var me = {}, ae = {}, X = {}, rt = {}, re = {}, Qe = {}, hu;
function Ur() {
  return hu || (hu = 1, Object.defineProperty(Qe, "__esModule", { value: !0 }), Qe.default = new Uint16Array(
    // prettier-ignore
    'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(u) {
      return u.charCodeAt(0);
    })
  )), Qe;
}
var Le = {}, gu;
function Wr() {
  return gu || (gu = 1, Object.defineProperty(Le, "__esModule", { value: !0 }), Le.default = new Uint16Array(
    // prettier-ignore
    "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(u) {
      return u.charCodeAt(0);
    })
  )), Le;
}
var it = {}, bu;
function pu() {
  return bu || (bu = 1, (function(u) {
    var d;
    Object.defineProperty(u, "__esModule", { value: !0 }), u.replaceCodePoint = u.fromCodePoint = void 0;
    var l = /* @__PURE__ */ new Map([
      [0, 65533],
      // C1 Unicode control character reference replacements
      [128, 8364],
      [130, 8218],
      [131, 402],
      [132, 8222],
      [133, 8230],
      [134, 8224],
      [135, 8225],
      [136, 710],
      [137, 8240],
      [138, 352],
      [139, 8249],
      [140, 338],
      [142, 381],
      [145, 8216],
      [146, 8217],
      [147, 8220],
      [148, 8221],
      [149, 8226],
      [150, 8211],
      [151, 8212],
      [152, 732],
      [153, 8482],
      [154, 353],
      [155, 8250],
      [156, 339],
      [158, 382],
      [159, 376]
    ]);
    u.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
    (d = String.fromCodePoint) !== null && d !== void 0 ? d : function(b) {
      var g = "";
      return b > 65535 && (b -= 65536, g += String.fromCharCode(b >>> 10 & 1023 | 55296), b = 56320 | b & 1023), g += String.fromCharCode(b), g;
    };
    function x(b) {
      var g;
      return b >= 55296 && b <= 57343 || b > 1114111 ? 65533 : (g = l.get(b)) !== null && g !== void 0 ? g : b;
    }
    u.replaceCodePoint = x;
    function v(b) {
      return (0, u.fromCodePoint)(x(b));
    }
    u.default = v;
  })(it)), it;
}
var mu;
function yu() {
  return mu || (mu = 1, (function(u) {
    var d = re && re.__createBinding || (Object.create ? (function(I, E, R, k) {
      k === void 0 && (k = R);
      var N = Object.getOwnPropertyDescriptor(E, R);
      (!N || ("get" in N ? !E.__esModule : N.writable || N.configurable)) && (N = { enumerable: !0, get: function() {
        return E[R];
      } }), Object.defineProperty(I, k, N);
    }) : (function(I, E, R, k) {
      k === void 0 && (k = R), I[k] = E[R];
    })), l = re && re.__setModuleDefault || (Object.create ? (function(I, E) {
      Object.defineProperty(I, "default", { enumerable: !0, value: E });
    }) : function(I, E) {
      I.default = E;
    }), x = re && re.__importStar || function(I) {
      if (I && I.__esModule) return I;
      var E = {};
      if (I != null) for (var R in I) R !== "default" && Object.prototype.hasOwnProperty.call(I, R) && d(E, I, R);
      return l(E, I), E;
    }, v = re && re.__importDefault || function(I) {
      return I && I.__esModule ? I : { default: I };
    };
    Object.defineProperty(u, "__esModule", { value: !0 }), u.decodeXML = u.decodeHTMLStrict = u.decodeHTMLAttribute = u.decodeHTML = u.determineBranch = u.EntityDecoder = u.DecodingMode = u.BinTrieFlags = u.fromCodePoint = u.replaceCodePoint = u.decodeCodePoint = u.xmlDecodeTree = u.htmlDecodeTree = void 0;
    var b = v(/* @__PURE__ */ Ur());
    u.htmlDecodeTree = b.default;
    var g = v(/* @__PURE__ */ Wr());
    u.xmlDecodeTree = g.default;
    var a = x(/* @__PURE__ */ pu());
    u.decodeCodePoint = a.default;
    var c = /* @__PURE__ */ pu();
    Object.defineProperty(u, "replaceCodePoint", { enumerable: !0, get: function() {
      return c.replaceCodePoint;
    } }), Object.defineProperty(u, "fromCodePoint", { enumerable: !0, get: function() {
      return c.fromCodePoint;
    } });
    var e;
    (function(I) {
      I[I.NUM = 35] = "NUM", I[I.SEMI = 59] = "SEMI", I[I.EQUALS = 61] = "EQUALS", I[I.ZERO = 48] = "ZERO", I[I.NINE = 57] = "NINE", I[I.LOWER_A = 97] = "LOWER_A", I[I.LOWER_F = 102] = "LOWER_F", I[I.LOWER_X = 120] = "LOWER_X", I[I.LOWER_Z = 122] = "LOWER_Z", I[I.UPPER_A = 65] = "UPPER_A", I[I.UPPER_F = 70] = "UPPER_F", I[I.UPPER_Z = 90] = "UPPER_Z";
    })(e || (e = {}));
    var t = 32, n;
    (function(I) {
      I[I.VALUE_LENGTH = 49152] = "VALUE_LENGTH", I[I.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", I[I.JUMP_TABLE = 127] = "JUMP_TABLE";
    })(n = u.BinTrieFlags || (u.BinTrieFlags = {}));
    function r(I) {
      return I >= e.ZERO && I <= e.NINE;
    }
    function i(I) {
      return I >= e.UPPER_A && I <= e.UPPER_F || I >= e.LOWER_A && I <= e.LOWER_F;
    }
    function A(I) {
      return I >= e.UPPER_A && I <= e.UPPER_Z || I >= e.LOWER_A && I <= e.LOWER_Z || r(I);
    }
    function y(I) {
      return I === e.EQUALS || A(I);
    }
    var w;
    (function(I) {
      I[I.EntityStart = 0] = "EntityStart", I[I.NumericStart = 1] = "NumericStart", I[I.NumericDecimal = 2] = "NumericDecimal", I[I.NumericHex = 3] = "NumericHex", I[I.NamedEntity = 4] = "NamedEntity";
    })(w || (w = {}));
    var s;
    (function(I) {
      I[I.Legacy = 0] = "Legacy", I[I.Strict = 1] = "Strict", I[I.Attribute = 2] = "Attribute";
    })(s = u.DecodingMode || (u.DecodingMode = {}));
    var f = (
      /** @class */
      (function() {
        function I(E, R, k) {
          this.decodeTree = E, this.emitCodePoint = R, this.errors = k, this.state = w.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = s.Strict;
        }
        return I.prototype.startEntity = function(E) {
          this.decodeMode = E, this.state = w.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
        }, I.prototype.write = function(E, R) {
          switch (this.state) {
            case w.EntityStart:
              return E.charCodeAt(R) === e.NUM ? (this.state = w.NumericStart, this.consumed += 1, this.stateNumericStart(E, R + 1)) : (this.state = w.NamedEntity, this.stateNamedEntity(E, R));
            case w.NumericStart:
              return this.stateNumericStart(E, R);
            case w.NumericDecimal:
              return this.stateNumericDecimal(E, R);
            case w.NumericHex:
              return this.stateNumericHex(E, R);
            case w.NamedEntity:
              return this.stateNamedEntity(E, R);
          }
        }, I.prototype.stateNumericStart = function(E, R) {
          return R >= E.length ? -1 : (E.charCodeAt(R) | t) === e.LOWER_X ? (this.state = w.NumericHex, this.consumed += 1, this.stateNumericHex(E, R + 1)) : (this.state = w.NumericDecimal, this.stateNumericDecimal(E, R));
        }, I.prototype.addToNumericResult = function(E, R, k, N) {
          if (R !== k) {
            var q = k - R;
            this.result = this.result * Math.pow(N, q) + parseInt(E.substr(R, q), N), this.consumed += q;
          }
        }, I.prototype.stateNumericHex = function(E, R) {
          for (var k = R; R < E.length; ) {
            var N = E.charCodeAt(R);
            if (r(N) || i(N))
              R += 1;
            else
              return this.addToNumericResult(E, k, R, 16), this.emitNumericEntity(N, 3);
          }
          return this.addToNumericResult(E, k, R, 16), -1;
        }, I.prototype.stateNumericDecimal = function(E, R) {
          for (var k = R; R < E.length; ) {
            var N = E.charCodeAt(R);
            if (r(N))
              R += 1;
            else
              return this.addToNumericResult(E, k, R, 10), this.emitNumericEntity(N, 2);
          }
          return this.addToNumericResult(E, k, R, 10), -1;
        }, I.prototype.emitNumericEntity = function(E, R) {
          var k;
          if (this.consumed <= R)
            return (k = this.errors) === null || k === void 0 || k.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          if (E === e.SEMI)
            this.consumed += 1;
          else if (this.decodeMode === s.Strict)
            return 0;
          return this.emitCodePoint((0, a.replaceCodePoint)(this.result), this.consumed), this.errors && (E !== e.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
        }, I.prototype.stateNamedEntity = function(E, R) {
          for (var k = this.decodeTree, N = k[this.treeIndex], q = (N & n.VALUE_LENGTH) >> 14; R < E.length; R++, this.excess++) {
            var M = E.charCodeAt(R);
            if (this.treeIndex = m(k, N, this.treeIndex + Math.max(1, q), M), this.treeIndex < 0)
              return this.result === 0 || // If we are parsing an attribute
              this.decodeMode === s.Attribute && // We shouldn't have consumed any characters after the entity,
              (q === 0 || // And there should be no invalid characters.
              y(M)) ? 0 : this.emitNotTerminatedNamedEntity();
            if (N = k[this.treeIndex], q = (N & n.VALUE_LENGTH) >> 14, q !== 0) {
              if (M === e.SEMI)
                return this.emitNamedEntityData(this.treeIndex, q, this.consumed + this.excess);
              this.decodeMode !== s.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
            }
          }
          return -1;
        }, I.prototype.emitNotTerminatedNamedEntity = function() {
          var E, R = this, k = R.result, N = R.decodeTree, q = (N[k] & n.VALUE_LENGTH) >> 14;
          return this.emitNamedEntityData(k, q, this.consumed), (E = this.errors) === null || E === void 0 || E.missingSemicolonAfterCharacterReference(), this.consumed;
        }, I.prototype.emitNamedEntityData = function(E, R, k) {
          var N = this.decodeTree;
          return this.emitCodePoint(R === 1 ? N[E] & ~n.VALUE_LENGTH : N[E + 1], k), R === 3 && this.emitCodePoint(N[E + 2], k), k;
        }, I.prototype.end = function() {
          var E;
          switch (this.state) {
            case w.NamedEntity:
              return this.result !== 0 && (this.decodeMode !== s.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case w.NumericDecimal:
              return this.emitNumericEntity(0, 2);
            case w.NumericHex:
              return this.emitNumericEntity(0, 3);
            case w.NumericStart:
              return (E = this.errors) === null || E === void 0 || E.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
            case w.EntityStart:
              return 0;
          }
        }, I;
      })()
    );
    u.EntityDecoder = f;
    function h(I) {
      var E = "", R = new f(I, function(k) {
        return E += (0, a.fromCodePoint)(k);
      });
      return function(N, q) {
        for (var M = 0, G = 0; (G = N.indexOf("&", G)) >= 0; ) {
          E += N.slice(M, G), R.startEntity(q);
          var J = R.write(
            N,
            // Skip the "&"
            G + 1
          );
          if (J < 0) {
            M = G + R.end();
            break;
          }
          M = G + J, G = J === 0 ? M + 1 : M;
        }
        var Z = E + N.slice(M);
        return E = "", Z;
      };
    }
    function m(I, E, R, k) {
      var N = (E & n.BRANCH_LENGTH) >> 7, q = E & n.JUMP_TABLE;
      if (N === 0)
        return q !== 0 && k === q ? R : -1;
      if (q) {
        var M = k - q;
        return M < 0 || M >= N ? -1 : I[R + M] - 1;
      }
      for (var G = R, J = G + N - 1; G <= J; ) {
        var Z = G + J >>> 1, z = I[Z];
        if (z < k)
          G = Z + 1;
        else if (z > k)
          J = Z - 1;
        else
          return I[Z + N];
      }
      return -1;
    }
    u.determineBranch = m;
    var o = h(b.default), p = h(g.default);
    function C(I, E) {
      return E === void 0 && (E = s.Legacy), o(I, E);
    }
    u.decodeHTML = C;
    function D(I) {
      return o(I, s.Attribute);
    }
    u.decodeHTMLAttribute = D;
    function B(I) {
      return o(I, s.Strict);
    }
    u.decodeHTMLStrict = B;
    function S(I) {
      return p(I, s.Strict);
    }
    u.decodeXML = S;
  })(re)), re;
}
var oe = {}, Me = {}, wu;
function Kr() {
  if (wu) return Me;
  wu = 1, Object.defineProperty(Me, "__esModule", { value: !0 });
  function u(d) {
    for (var l = 1; l < d.length; l++)
      d[l][0] += d[l - 1][0] + 1;
    return d;
  }
  return Me.default = new Map(/* @__PURE__ */ u([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ u([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ u([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ u([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]])), Me;
}
var nt = {}, vu;
function Ht() {
  return vu || (vu = 1, (function(u) {
    Object.defineProperty(u, "__esModule", { value: !0 }), u.escapeText = u.escapeAttribute = u.escapeUTF8 = u.escape = u.encodeXML = u.getCodePoint = u.xmlReplacer = void 0, u.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
    var d = /* @__PURE__ */ new Map([
      [34, "&quot;"],
      [38, "&amp;"],
      [39, "&apos;"],
      [60, "&lt;"],
      [62, "&gt;"]
    ]);
    u.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.prototype.codePointAt != null ? function(v, b) {
      return v.codePointAt(b);
    } : (
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      function(v, b) {
        return (v.charCodeAt(b) & 64512) === 55296 ? (v.charCodeAt(b) - 55296) * 1024 + v.charCodeAt(b + 1) - 56320 + 65536 : v.charCodeAt(b);
      }
    );
    function l(v) {
      for (var b = "", g = 0, a; (a = u.xmlReplacer.exec(v)) !== null; ) {
        var c = a.index, e = v.charCodeAt(c), t = d.get(e);
        t !== void 0 ? (b += v.substring(g, c) + t, g = c + 1) : (b += "".concat(v.substring(g, c), "&#x").concat((0, u.getCodePoint)(v, c).toString(16), ";"), g = u.xmlReplacer.lastIndex += +((e & 64512) === 55296));
      }
      return b + v.substr(g);
    }
    u.encodeXML = l, u.escape = l;
    function x(v, b) {
      return function(a) {
        for (var c, e = 0, t = ""; c = v.exec(a); )
          e !== c.index && (t += a.substring(e, c.index)), t += b.get(c[0].charCodeAt(0)), e = c.index + 1;
        return t + a.substring(e);
      };
    }
    u.escapeUTF8 = x(/[&<>'"]/g, d), u.escapeAttribute = x(/["&\u00A0]/g, /* @__PURE__ */ new Map([
      [34, "&quot;"],
      [38, "&amp;"],
      [160, "&nbsp;"]
    ])), u.escapeText = x(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
      [38, "&amp;"],
      [60, "&lt;"],
      [62, "&gt;"],
      [160, "&nbsp;"]
    ]));
  })(nt)), nt;
}
var xu;
function Iu() {
  if (xu) return oe;
  xu = 1;
  var u = oe && oe.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Object.defineProperty(oe, "__esModule", { value: !0 }), oe.encodeNonAsciiHTML = oe.encodeHTML = void 0;
  var d = u(/* @__PURE__ */ Kr()), l = /* @__PURE__ */ Ht(), x = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
  function v(a) {
    return g(x, a);
  }
  oe.encodeHTML = v;
  function b(a) {
    return g(l.xmlReplacer, a);
  }
  oe.encodeNonAsciiHTML = b;
  function g(a, c) {
    for (var e = "", t = 0, n; (n = a.exec(c)) !== null; ) {
      var r = n.index;
      e += c.substring(t, r);
      var i = c.charCodeAt(r), A = d.default.get(i);
      if (typeof A == "object") {
        if (r + 1 < c.length) {
          var y = c.charCodeAt(r + 1), w = typeof A.n == "number" ? A.n === y ? A.o : void 0 : A.n.get(y);
          if (w !== void 0) {
            e += w, t = a.lastIndex += 1;
            continue;
          }
        }
        A = A.v;
      }
      if (A !== void 0)
        e += A, t = r + 1;
      else {
        var s = (0, l.getCodePoint)(c, r);
        e += "&#x".concat(s.toString(16), ";"), t = a.lastIndex += +(s !== i);
      }
    }
    return e + c.substr(t);
  }
  return oe;
}
var Cu;
function Pr() {
  return Cu || (Cu = 1, (function(u) {
    Object.defineProperty(u, "__esModule", { value: !0 }), u.decodeXMLStrict = u.decodeHTML5Strict = u.decodeHTML4Strict = u.decodeHTML5 = u.decodeHTML4 = u.decodeHTMLAttribute = u.decodeHTMLStrict = u.decodeHTML = u.decodeXML = u.DecodingMode = u.EntityDecoder = u.encodeHTML5 = u.encodeHTML4 = u.encodeNonAsciiHTML = u.encodeHTML = u.escapeText = u.escapeAttribute = u.escapeUTF8 = u.escape = u.encodeXML = u.encode = u.decodeStrict = u.decode = u.EncodingMode = u.EntityLevel = void 0;
    var d = /* @__PURE__ */ yu(), l = /* @__PURE__ */ Iu(), x = /* @__PURE__ */ Ht(), v;
    (function(r) {
      r[r.XML = 0] = "XML", r[r.HTML = 1] = "HTML";
    })(v = u.EntityLevel || (u.EntityLevel = {}));
    var b;
    (function(r) {
      r[r.UTF8 = 0] = "UTF8", r[r.ASCII = 1] = "ASCII", r[r.Extensive = 2] = "Extensive", r[r.Attribute = 3] = "Attribute", r[r.Text = 4] = "Text";
    })(b = u.EncodingMode || (u.EncodingMode = {}));
    function g(r, i) {
      i === void 0 && (i = v.XML);
      var A = typeof i == "number" ? i : i.level;
      if (A === v.HTML) {
        var y = typeof i == "object" ? i.mode : void 0;
        return (0, d.decodeHTML)(r, y);
      }
      return (0, d.decodeXML)(r);
    }
    u.decode = g;
    function a(r, i) {
      var A;
      i === void 0 && (i = v.XML);
      var y = typeof i == "number" ? { level: i } : i;
      return (A = y.mode) !== null && A !== void 0 || (y.mode = d.DecodingMode.Strict), g(r, y);
    }
    u.decodeStrict = a;
    function c(r, i) {
      i === void 0 && (i = v.XML);
      var A = typeof i == "number" ? { level: i } : i;
      return A.mode === b.UTF8 ? (0, x.escapeUTF8)(r) : A.mode === b.Attribute ? (0, x.escapeAttribute)(r) : A.mode === b.Text ? (0, x.escapeText)(r) : A.level === v.HTML ? A.mode === b.ASCII ? (0, l.encodeNonAsciiHTML)(r) : (0, l.encodeHTML)(r) : (0, x.encodeXML)(r);
    }
    u.encode = c;
    var e = /* @__PURE__ */ Ht();
    Object.defineProperty(u, "encodeXML", { enumerable: !0, get: function() {
      return e.encodeXML;
    } }), Object.defineProperty(u, "escape", { enumerable: !0, get: function() {
      return e.escape;
    } }), Object.defineProperty(u, "escapeUTF8", { enumerable: !0, get: function() {
      return e.escapeUTF8;
    } }), Object.defineProperty(u, "escapeAttribute", { enumerable: !0, get: function() {
      return e.escapeAttribute;
    } }), Object.defineProperty(u, "escapeText", { enumerable: !0, get: function() {
      return e.escapeText;
    } });
    var t = /* @__PURE__ */ Iu();
    Object.defineProperty(u, "encodeHTML", { enumerable: !0, get: function() {
      return t.encodeHTML;
    } }), Object.defineProperty(u, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
      return t.encodeNonAsciiHTML;
    } }), Object.defineProperty(u, "encodeHTML4", { enumerable: !0, get: function() {
      return t.encodeHTML;
    } }), Object.defineProperty(u, "encodeHTML5", { enumerable: !0, get: function() {
      return t.encodeHTML;
    } });
    var n = /* @__PURE__ */ yu();
    Object.defineProperty(u, "EntityDecoder", { enumerable: !0, get: function() {
      return n.EntityDecoder;
    } }), Object.defineProperty(u, "DecodingMode", { enumerable: !0, get: function() {
      return n.DecodingMode;
    } }), Object.defineProperty(u, "decodeXML", { enumerable: !0, get: function() {
      return n.decodeXML;
    } }), Object.defineProperty(u, "decodeHTML", { enumerable: !0, get: function() {
      return n.decodeHTML;
    } }), Object.defineProperty(u, "decodeHTMLStrict", { enumerable: !0, get: function() {
      return n.decodeHTMLStrict;
    } }), Object.defineProperty(u, "decodeHTMLAttribute", { enumerable: !0, get: function() {
      return n.decodeHTMLAttribute;
    } }), Object.defineProperty(u, "decodeHTML4", { enumerable: !0, get: function() {
      return n.decodeHTML;
    } }), Object.defineProperty(u, "decodeHTML5", { enumerable: !0, get: function() {
      return n.decodeHTML;
    } }), Object.defineProperty(u, "decodeHTML4Strict", { enumerable: !0, get: function() {
      return n.decodeHTMLStrict;
    } }), Object.defineProperty(u, "decodeHTML5Strict", { enumerable: !0, get: function() {
      return n.decodeHTMLStrict;
    } }), Object.defineProperty(u, "decodeXMLStrict", { enumerable: !0, get: function() {
      return n.decodeXML;
    } });
  })(rt)), rt;
}
var ye = {}, Bu;
function Yr() {
  return Bu || (Bu = 1, Object.defineProperty(ye, "__esModule", { value: !0 }), ye.attributeNames = ye.elementNames = void 0, ye.elementNames = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
  ].map(function(u) {
    return [u.toLowerCase(), u];
  })), ye.attributeNames = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
  ].map(function(u) {
    return [u.toLowerCase(), u];
  }))), ye;
}
var Eu;
function Jr() {
  if (Eu) return X;
  Eu = 1;
  var u = X && X.__assign || function() {
    return u = Object.assign || function(m) {
      for (var o, p = 1, C = arguments.length; p < C; p++) {
        o = arguments[p];
        for (var D in o) Object.prototype.hasOwnProperty.call(o, D) && (m[D] = o[D]);
      }
      return m;
    }, u.apply(this, arguments);
  }, d = X && X.__createBinding || (Object.create ? (function(m, o, p, C) {
    C === void 0 && (C = p);
    var D = Object.getOwnPropertyDescriptor(o, p);
    (!D || ("get" in D ? !o.__esModule : D.writable || D.configurable)) && (D = { enumerable: !0, get: function() {
      return o[p];
    } }), Object.defineProperty(m, C, D);
  }) : (function(m, o, p, C) {
    C === void 0 && (C = p), m[C] = o[p];
  })), l = X && X.__setModuleDefault || (Object.create ? (function(m, o) {
    Object.defineProperty(m, "default", { enumerable: !0, value: o });
  }) : function(m, o) {
    m.default = o;
  }), x = X && X.__importStar || function(m) {
    if (m && m.__esModule) return m;
    var o = {};
    if (m != null) for (var p in m) p !== "default" && Object.prototype.hasOwnProperty.call(m, p) && d(o, m, p);
    return l(o, m), o;
  };
  Object.defineProperty(X, "__esModule", { value: !0 }), X.render = void 0;
  var v = x(/* @__PURE__ */ Fe()), b = /* @__PURE__ */ Pr(), g = /* @__PURE__ */ Yr(), a = /* @__PURE__ */ new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
  ]);
  function c(m) {
    return m.replace(/"/g, "&quot;");
  }
  function e(m, o) {
    var p;
    if (m) {
      var C = ((p = o.encodeEntities) !== null && p !== void 0 ? p : o.decodeEntities) === !1 ? c : o.xmlMode || o.encodeEntities !== "utf8" ? b.encodeXML : b.escapeAttribute;
      return Object.keys(m).map(function(D) {
        var B, S, I = (B = m[D]) !== null && B !== void 0 ? B : "";
        return o.xmlMode === "foreign" && (D = (S = g.attributeNames.get(D)) !== null && S !== void 0 ? S : D), !o.emptyAttrs && !o.xmlMode && I === "" ? D : "".concat(D, '="').concat(C(I), '"');
      }).join(" ");
    }
  }
  var t = /* @__PURE__ */ new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
  ]);
  function n(m, o) {
    o === void 0 && (o = {});
    for (var p = ("length" in m) ? m : [m], C = "", D = 0; D < p.length; D++)
      C += r(p[D], o);
    return C;
  }
  X.render = n, X.default = n;
  function r(m, o) {
    switch (m.type) {
      case v.Root:
        return n(m.children, o);
      // @ts-expect-error We don't use `Doctype` yet
      case v.Doctype:
      case v.Directive:
        return w(m);
      case v.Comment:
        return h(m);
      case v.CDATA:
        return f(m);
      case v.Script:
      case v.Style:
      case v.Tag:
        return y(m, o);
      case v.Text:
        return s(m, o);
    }
  }
  var i = /* @__PURE__ */ new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
  ]), A = /* @__PURE__ */ new Set(["svg", "math"]);
  function y(m, o) {
    var p;
    o.xmlMode === "foreign" && (m.name = (p = g.elementNames.get(m.name)) !== null && p !== void 0 ? p : m.name, m.parent && i.has(m.parent.name) && (o = u(u({}, o), { xmlMode: !1 }))), !o.xmlMode && A.has(m.name) && (o = u(u({}, o), { xmlMode: "foreign" }));
    var C = "<".concat(m.name), D = e(m.attribs, o);
    return D && (C += " ".concat(D)), m.children.length === 0 && (o.xmlMode ? (
      // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
      o.selfClosingTags !== !1
    ) : (
      // User explicitly asked for self-closing tags, even in HTML mode
      o.selfClosingTags && t.has(m.name)
    )) ? (o.xmlMode || (C += " "), C += "/>") : (C += ">", m.children.length > 0 && (C += n(m.children, o)), (o.xmlMode || !t.has(m.name)) && (C += "</".concat(m.name, ">"))), C;
  }
  function w(m) {
    return "<".concat(m.data, ">");
  }
  function s(m, o) {
    var p, C = m.data || "";
    return ((p = o.encodeEntities) !== null && p !== void 0 ? p : o.decodeEntities) !== !1 && !(!o.xmlMode && m.parent && a.has(m.parent.name)) && (C = o.xmlMode || o.encodeEntities !== "utf8" ? (0, b.encodeXML)(C) : (0, b.escapeText)(C)), C;
  }
  function f(m) {
    return "<![CDATA[".concat(m.children[0].data, "]]>");
  }
  function h(m) {
    return "<!--".concat(m.data, "-->");
  }
  return X;
}
var Du;
function wr() {
  if (Du) return ae;
  Du = 1;
  var u = ae && ae.__importDefault || function(e) {
    return e && e.__esModule ? e : { default: e };
  };
  Object.defineProperty(ae, "__esModule", { value: !0 }), ae.getOuterHTML = v, ae.getInnerHTML = b, ae.getText = g, ae.textContent = a, ae.innerText = c;
  var d = /* @__PURE__ */ fe(), l = u(/* @__PURE__ */ Jr()), x = /* @__PURE__ */ Fe();
  function v(e, t) {
    return (0, l.default)(e, t);
  }
  function b(e, t) {
    return (0, d.hasChildren)(e) ? e.children.map(function(n) {
      return v(n, t);
    }).join("") : "";
  }
  function g(e) {
    return Array.isArray(e) ? e.map(g).join("") : (0, d.isTag)(e) ? e.name === "br" ? `
` : g(e.children) : (0, d.isCDATA)(e) ? g(e.children) : (0, d.isText)(e) ? e.data : "";
  }
  function a(e) {
    return Array.isArray(e) ? e.map(a).join("") : (0, d.hasChildren)(e) && !(0, d.isComment)(e) ? a(e.children) : (0, d.isText)(e) ? e.data : "";
  }
  function c(e) {
    return Array.isArray(e) ? e.map(c).join("") : (0, d.hasChildren)(e) && (e.type === x.ElementType.Tag || (0, d.isCDATA)(e)) ? c(e.children) : (0, d.isText)(e) ? e.data : "";
  }
  return ae;
}
var ie = {}, Su;
function Zr() {
  if (Su) return ie;
  Su = 1, Object.defineProperty(ie, "__esModule", { value: !0 }), ie.getChildren = d, ie.getParent = l, ie.getSiblings = x, ie.getAttributeValue = v, ie.hasAttrib = b, ie.getName = g, ie.nextElementSibling = a, ie.prevElementSibling = c;
  var u = /* @__PURE__ */ fe();
  function d(e) {
    return (0, u.hasChildren)(e) ? e.children : [];
  }
  function l(e) {
    return e.parent || null;
  }
  function x(e) {
    var t, n, r = l(e);
    if (r != null)
      return d(r);
    for (var i = [e], A = e.prev, y = e.next; A != null; )
      i.unshift(A), t = A, A = t.prev;
    for (; y != null; )
      i.push(y), n = y, y = n.next;
    return i;
  }
  function v(e, t) {
    var n;
    return (n = e.attribs) === null || n === void 0 ? void 0 : n[t];
  }
  function b(e, t) {
    return e.attribs != null && Object.prototype.hasOwnProperty.call(e.attribs, t) && e.attribs[t] != null;
  }
  function g(e) {
    return e.name;
  }
  function a(e) {
    for (var t, n = e.next; n !== null && !(0, u.isTag)(n); )
      t = n, n = t.next;
    return n;
  }
  function c(e) {
    for (var t, n = e.prev; n !== null && !(0, u.isTag)(n); )
      t = n, n = t.prev;
    return n;
  }
  return ie;
}
var ce = {}, Nu;
function jr() {
  if (Nu) return ce;
  Nu = 1, Object.defineProperty(ce, "__esModule", { value: !0 }), ce.removeElement = u, ce.replaceElement = d, ce.appendChild = l, ce.append = x, ce.prependChild = v, ce.prepend = b;
  function u(g) {
    if (g.prev && (g.prev.next = g.next), g.next && (g.next.prev = g.prev), g.parent) {
      var a = g.parent.children, c = a.lastIndexOf(g);
      c >= 0 && a.splice(c, 1);
    }
    g.next = null, g.prev = null, g.parent = null;
  }
  function d(g, a) {
    var c = a.prev = g.prev;
    c && (c.next = a);
    var e = a.next = g.next;
    e && (e.prev = a);
    var t = a.parent = g.parent;
    if (t) {
      var n = t.children;
      n[n.lastIndexOf(g)] = a, g.parent = null;
    }
  }
  function l(g, a) {
    if (u(a), a.next = null, a.parent = g, g.children.push(a) > 1) {
      var c = g.children[g.children.length - 2];
      c.next = a, a.prev = c;
    } else
      a.prev = null;
  }
  function x(g, a) {
    u(a);
    var c = g.parent, e = g.next;
    if (a.next = e, a.prev = g, g.next = a, a.parent = c, e) {
      if (e.prev = a, c) {
        var t = c.children;
        t.splice(t.lastIndexOf(e), 0, a);
      }
    } else c && c.children.push(a);
  }
  function v(g, a) {
    if (u(a), a.parent = g, a.prev = null, g.children.unshift(a) !== 1) {
      var c = g.children[1];
      c.prev = a, a.next = c;
    } else
      a.next = null;
  }
  function b(g, a) {
    u(a);
    var c = g.parent;
    if (c) {
      var e = c.children;
      e.splice(e.indexOf(g), 0, a);
    }
    g.prev && (g.prev.next = a), a.parent = c, a.prev = g.prev, a.next = g, g.prev = a;
  }
  return ce;
}
var le = {}, Ru;
function vr() {
  if (Ru) return le;
  Ru = 1, Object.defineProperty(le, "__esModule", { value: !0 }), le.filter = d, le.find = l, le.findOneChild = x, le.findOne = v, le.existsOne = b, le.findAll = g;
  var u = /* @__PURE__ */ fe();
  function d(a, c, e, t) {
    return e === void 0 && (e = !0), t === void 0 && (t = 1 / 0), l(a, Array.isArray(c) ? c : [c], e, t);
  }
  function l(a, c, e, t) {
    for (var n = [], r = [Array.isArray(c) ? c : [c]], i = [0]; ; ) {
      if (i[0] >= r[0].length) {
        if (i.length === 1)
          return n;
        r.shift(), i.shift();
        continue;
      }
      var A = r[0][i[0]++];
      if (a(A) && (n.push(A), --t <= 0))
        return n;
      e && (0, u.hasChildren)(A) && A.children.length > 0 && (i.unshift(0), r.unshift(A.children));
    }
  }
  function x(a, c) {
    return c.find(a);
  }
  function v(a, c, e) {
    e === void 0 && (e = !0);
    for (var t = Array.isArray(c) ? c : [c], n = 0; n < t.length; n++) {
      var r = t[n];
      if ((0, u.isTag)(r) && a(r))
        return r;
      if (e && (0, u.hasChildren)(r) && r.children.length > 0) {
        var i = v(a, r.children, !0);
        if (i)
          return i;
      }
    }
    return null;
  }
  function b(a, c) {
    return (Array.isArray(c) ? c : [c]).some(function(e) {
      return (0, u.isTag)(e) && a(e) || (0, u.hasChildren)(e) && b(a, e.children);
    });
  }
  function g(a, c) {
    for (var e = [], t = [Array.isArray(c) ? c : [c]], n = [0]; ; ) {
      if (n[0] >= t[0].length) {
        if (t.length === 1)
          return e;
        t.shift(), n.shift();
        continue;
      }
      var r = t[0][n[0]++];
      (0, u.isTag)(r) && a(r) && e.push(r), (0, u.hasChildren)(r) && r.children.length > 0 && (n.unshift(0), t.unshift(r.children));
    }
  }
  return le;
}
var Ae = {}, Fu;
function xr() {
  if (Fu) return Ae;
  Fu = 1, Object.defineProperty(Ae, "__esModule", { value: !0 }), Ae.testElement = g, Ae.getElements = a, Ae.getElementById = c, Ae.getElementsByTagName = e, Ae.getElementsByClassName = t, Ae.getElementsByTagType = n;
  var u = /* @__PURE__ */ fe(), d = /* @__PURE__ */ vr(), l = {
    tag_name: function(r) {
      return typeof r == "function" ? function(i) {
        return (0, u.isTag)(i) && r(i.name);
      } : r === "*" ? u.isTag : function(i) {
        return (0, u.isTag)(i) && i.name === r;
      };
    },
    tag_type: function(r) {
      return typeof r == "function" ? function(i) {
        return r(i.type);
      } : function(i) {
        return i.type === r;
      };
    },
    tag_contains: function(r) {
      return typeof r == "function" ? function(i) {
        return (0, u.isText)(i) && r(i.data);
      } : function(i) {
        return (0, u.isText)(i) && i.data === r;
      };
    }
  };
  function x(r, i) {
    return typeof i == "function" ? function(A) {
      return (0, u.isTag)(A) && i(A.attribs[r]);
    } : function(A) {
      return (0, u.isTag)(A) && A.attribs[r] === i;
    };
  }
  function v(r, i) {
    return function(A) {
      return r(A) || i(A);
    };
  }
  function b(r) {
    var i = Object.keys(r).map(function(A) {
      var y = r[A];
      return Object.prototype.hasOwnProperty.call(l, A) ? l[A](y) : x(A, y);
    });
    return i.length === 0 ? null : i.reduce(v);
  }
  function g(r, i) {
    var A = b(r);
    return A ? A(i) : !0;
  }
  function a(r, i, A, y) {
    y === void 0 && (y = 1 / 0);
    var w = b(r);
    return w ? (0, d.filter)(w, i, A, y) : [];
  }
  function c(r, i, A) {
    return A === void 0 && (A = !0), Array.isArray(i) || (i = [i]), (0, d.findOne)(x("id", r), i, A);
  }
  function e(r, i, A, y) {
    return A === void 0 && (A = !0), y === void 0 && (y = 1 / 0), (0, d.filter)(l.tag_name(r), i, A, y);
  }
  function t(r, i, A, y) {
    return A === void 0 && (A = !0), y === void 0 && (y = 1 / 0), (0, d.filter)(x("class", r), i, A, y);
  }
  function n(r, i, A, y) {
    return A === void 0 && (A = !0), y === void 0 && (y = 1 / 0), (0, d.filter)(l.tag_type(r), i, A, y);
  }
  return Ae;
}
var de = {}, Tu;
function _r() {
  if (Tu) return de;
  Tu = 1, Object.defineProperty(de, "__esModule", { value: !0 }), de.DocumentPosition = void 0, de.removeSubsets = d, de.compareDocumentPosition = x, de.uniqueSort = v;
  var u = /* @__PURE__ */ fe();
  function d(b) {
    for (var g = b.length; --g >= 0; ) {
      var a = b[g];
      if (g > 0 && b.lastIndexOf(a, g - 1) >= 0) {
        b.splice(g, 1);
        continue;
      }
      for (var c = a.parent; c; c = c.parent)
        if (b.includes(c)) {
          b.splice(g, 1);
          break;
        }
    }
    return b;
  }
  var l;
  (function(b) {
    b[b.DISCONNECTED = 1] = "DISCONNECTED", b[b.PRECEDING = 2] = "PRECEDING", b[b.FOLLOWING = 4] = "FOLLOWING", b[b.CONTAINS = 8] = "CONTAINS", b[b.CONTAINED_BY = 16] = "CONTAINED_BY";
  })(l || (de.DocumentPosition = l = {}));
  function x(b, g) {
    var a = [], c = [];
    if (b === g)
      return 0;
    for (var e = (0, u.hasChildren)(b) ? b : b.parent; e; )
      a.unshift(e), e = e.parent;
    for (e = (0, u.hasChildren)(g) ? g : g.parent; e; )
      c.unshift(e), e = e.parent;
    for (var t = Math.min(a.length, c.length), n = 0; n < t && a[n] === c[n]; )
      n++;
    if (n === 0)
      return l.DISCONNECTED;
    var r = a[n - 1], i = r.children, A = a[n], y = c[n];
    return i.indexOf(A) > i.indexOf(y) ? r === g ? l.FOLLOWING | l.CONTAINED_BY : l.FOLLOWING : r === b ? l.PRECEDING | l.CONTAINS : l.PRECEDING;
  }
  function v(b) {
    return b = b.filter(function(g, a, c) {
      return !c.includes(g, a + 1);
    }), b.sort(function(g, a) {
      var c = x(g, a);
      return c & l.PRECEDING ? -1 : c & l.FOLLOWING ? 1 : 0;
    }), b;
  }
  return de;
}
var Ge = {}, ku;
function Vr() {
  if (ku) return Ge;
  ku = 1, Object.defineProperty(Ge, "__esModule", { value: !0 }), Ge.getFeed = l;
  var u = /* @__PURE__ */ wr(), d = /* @__PURE__ */ xr();
  function l(r) {
    var i = c(n, r);
    return i ? i.name === "feed" ? x(i) : v(i) : null;
  }
  function x(r) {
    var i, A = r.children, y = {
      type: "atom",
      items: (0, d.getElementsByTagName)("entry", A).map(function(f) {
        var h, m = f.children, o = { media: a(m) };
        t(o, "id", "id", m), t(o, "title", "title", m);
        var p = (h = c("link", m)) === null || h === void 0 ? void 0 : h.attribs.href;
        p && (o.link = p);
        var C = e("summary", m) || e("content", m);
        C && (o.description = C);
        var D = e("updated", m);
        return D && (o.pubDate = new Date(D)), o;
      })
    };
    t(y, "id", "id", A), t(y, "title", "title", A);
    var w = (i = c("link", A)) === null || i === void 0 ? void 0 : i.attribs.href;
    w && (y.link = w), t(y, "description", "subtitle", A);
    var s = e("updated", A);
    return s && (y.updated = new Date(s)), t(y, "author", "email", A, !0), y;
  }
  function v(r) {
    var i, A, y = (A = (i = c("channel", r.children)) === null || i === void 0 ? void 0 : i.children) !== null && A !== void 0 ? A : [], w = {
      type: r.name.substr(0, 3),
      id: "",
      items: (0, d.getElementsByTagName)("item", r.children).map(function(f) {
        var h = f.children, m = { media: a(h) };
        t(m, "id", "guid", h), t(m, "title", "title", h), t(m, "link", "link", h), t(m, "description", "description", h);
        var o = e("pubDate", h) || e("dc:date", h);
        return o && (m.pubDate = new Date(o)), m;
      })
    };
    t(w, "title", "title", y), t(w, "link", "link", y), t(w, "description", "description", y);
    var s = e("lastBuildDate", y);
    return s && (w.updated = new Date(s)), t(w, "author", "managingEditor", y, !0), w;
  }
  var b = ["url", "type", "lang"], g = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
  ];
  function a(r) {
    return (0, d.getElementsByTagName)("media:content", r).map(function(i) {
      for (var A = i.attribs, y = {
        medium: A.medium,
        isDefault: !!A.isDefault
      }, w = 0, s = b; w < s.length; w++) {
        var f = s[w];
        A[f] && (y[f] = A[f]);
      }
      for (var h = 0, m = g; h < m.length; h++) {
        var f = m[h];
        A[f] && (y[f] = parseInt(A[f], 10));
      }
      return A.expression && (y.expression = A.expression), y;
    });
  }
  function c(r, i) {
    return (0, d.getElementsByTagName)(r, i, !0, 1)[0];
  }
  function e(r, i, A) {
    return A === void 0 && (A = !1), (0, u.textContent)((0, d.getElementsByTagName)(r, i, A, 1)).trim();
  }
  function t(r, i, A, y, w) {
    w === void 0 && (w = !1);
    var s = e(A, y, w);
    s && (r[i] = s);
  }
  function n(r) {
    return r === "rss" || r === "feed" || r === "rdf:RDF";
  }
  return Ge;
}
var Ou;
function at() {
  return Ou || (Ou = 1, (function(u) {
    var d = me && me.__createBinding || (Object.create ? (function(v, b, g, a) {
      a === void 0 && (a = g);
      var c = Object.getOwnPropertyDescriptor(b, g);
      (!c || ("get" in c ? !b.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
        return b[g];
      } }), Object.defineProperty(v, a, c);
    }) : (function(v, b, g, a) {
      a === void 0 && (a = g), v[a] = b[g];
    })), l = me && me.__exportStar || function(v, b) {
      for (var g in v) g !== "default" && !Object.prototype.hasOwnProperty.call(b, g) && d(b, v, g);
    };
    Object.defineProperty(u, "__esModule", { value: !0 }), u.hasChildren = u.isDocument = u.isComment = u.isText = u.isCDATA = u.isTag = void 0, l(/* @__PURE__ */ wr(), u), l(/* @__PURE__ */ Zr(), u), l(/* @__PURE__ */ jr(), u), l(/* @__PURE__ */ vr(), u), l(/* @__PURE__ */ xr(), u), l(/* @__PURE__ */ _r(), u), l(/* @__PURE__ */ Vr(), u);
    var x = /* @__PURE__ */ fe();
    Object.defineProperty(u, "isTag", { enumerable: !0, get: function() {
      return x.isTag;
    } }), Object.defineProperty(u, "isCDATA", { enumerable: !0, get: function() {
      return x.isCDATA;
    } }), Object.defineProperty(u, "isText", { enumerable: !0, get: function() {
      return x.isText;
    } }), Object.defineProperty(u, "isComment", { enumerable: !0, get: function() {
      return x.isComment;
    } }), Object.defineProperty(u, "isDocument", { enumerable: !0, get: function() {
      return x.isDocument;
    } }), Object.defineProperty(u, "hasChildren", { enumerable: !0, get: function() {
      return x.hasChildren;
    } });
  })(me)), me;
}
var qu;
function Xr() {
  return qu || (qu = 1, (function(u) {
    var d = te && te.__createBinding || (Object.create ? (function(f, h, m, o) {
      o === void 0 && (o = m);
      var p = Object.getOwnPropertyDescriptor(h, m);
      (!p || ("get" in p ? !h.__esModule : p.writable || p.configurable)) && (p = { enumerable: !0, get: function() {
        return h[m];
      } }), Object.defineProperty(f, o, p);
    }) : (function(f, h, m, o) {
      o === void 0 && (o = m), f[o] = h[m];
    })), l = te && te.__setModuleDefault || (Object.create ? (function(f, h) {
      Object.defineProperty(f, "default", { enumerable: !0, value: h });
    }) : function(f, h) {
      f.default = h;
    }), x = te && te.__importStar || /* @__PURE__ */ (function() {
      var f = function(h) {
        return f = Object.getOwnPropertyNames || function(m) {
          var o = [];
          for (var p in m) Object.prototype.hasOwnProperty.call(m, p) && (o[o.length] = p);
          return o;
        }, f(h);
      };
      return function(h) {
        if (h && h.__esModule) return h;
        var m = {};
        if (h != null) for (var o = f(h), p = 0; p < o.length; p++) o[p] !== "default" && d(m, h, o[p]);
        return l(m, h), m;
      };
    })(), v = te && te.__importDefault || function(f) {
      return f && f.__esModule ? f : { default: f };
    };
    Object.defineProperty(u, "__esModule", { value: !0 }), u.DomUtils = u.getFeed = u.ElementType = u.QuoteType = u.Tokenizer = u.DefaultHandler = u.DomHandler = u.Parser = void 0, u.parseDocument = e, u.parseDOM = t, u.createDocumentStream = n, u.createDomStream = r, u.parseFeed = s;
    const b = cu();
    var g = cu();
    Object.defineProperty(u, "Parser", { enumerable: !0, get: function() {
      return g.Parser;
    } });
    const a = /* @__PURE__ */ fe();
    var c = /* @__PURE__ */ fe();
    Object.defineProperty(u, "DomHandler", { enumerable: !0, get: function() {
      return c.DomHandler;
    } }), Object.defineProperty(u, "DefaultHandler", { enumerable: !0, get: function() {
      return c.DomHandler;
    } });
    function e(f, h) {
      const m = new a.DomHandler(void 0, h);
      return new b.Parser(m, h).end(f), m.root;
    }
    function t(f, h) {
      return e(f, h).children;
    }
    function n(f, h, m) {
      const o = new a.DomHandler((p) => f(p, o.root), h, m);
      return new b.Parser(o, h);
    }
    function r(f, h, m) {
      const o = new a.DomHandler(f, h, m);
      return new b.Parser(o, h);
    }
    var i = yr();
    Object.defineProperty(u, "Tokenizer", { enumerable: !0, get: function() {
      return v(i).default;
    } }), Object.defineProperty(u, "QuoteType", { enumerable: !0, get: function() {
      return i.QuoteType;
    } }), u.ElementType = x(/* @__PURE__ */ Fe());
    const A = /* @__PURE__ */ at();
    var y = /* @__PURE__ */ at();
    Object.defineProperty(u, "getFeed", { enumerable: !0, get: function() {
      return y.getFeed;
    } });
    const w = { xmlMode: !0 };
    function s(f, h = w) {
      return (0, A.getFeed)(t(f, h));
    }
    u.DomUtils = x(/* @__PURE__ */ at());
  })(te)), te;
}
var st, Qu;
function zr() {
  return Qu || (Qu = 1, st = (u) => {
    if (typeof u != "string")
      throw new TypeError("Expected a string");
    return u.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
  }), st;
}
var He = {}, Lu;
function $r() {
  if (Lu) return He;
  Lu = 1, Object.defineProperty(He, "__esModule", { value: !0 });
  function u(l) {
    return Object.prototype.toString.call(l) === "[object Object]";
  }
  function d(l) {
    var x, v;
    return u(l) === !1 ? !1 : (x = l.constructor, x === void 0 ? !0 : (v = x.prototype, !(u(v) === !1 || v.hasOwnProperty("isPrototypeOf") === !1)));
  }
  return He.isPlainObject = d, He;
}
var ot, Mu;
function ei() {
  if (Mu) return ot;
  Mu = 1;
  var u = function(f) {
    return d(f) && !l(f);
  };
  function d(s) {
    return !!s && typeof s == "object";
  }
  function l(s) {
    var f = Object.prototype.toString.call(s);
    return f === "[object RegExp]" || f === "[object Date]" || b(s);
  }
  var x = typeof Symbol == "function" && Symbol.for, v = x ? /* @__PURE__ */ Symbol.for("react.element") : 60103;
  function b(s) {
    return s.$$typeof === v;
  }
  function g(s) {
    return Array.isArray(s) ? [] : {};
  }
  function a(s, f) {
    return f.clone !== !1 && f.isMergeableObject(s) ? y(g(s), s, f) : s;
  }
  function c(s, f, h) {
    return s.concat(f).map(function(m) {
      return a(m, h);
    });
  }
  function e(s, f) {
    if (!f.customMerge)
      return y;
    var h = f.customMerge(s);
    return typeof h == "function" ? h : y;
  }
  function t(s) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(s).filter(function(f) {
      return Object.propertyIsEnumerable.call(s, f);
    }) : [];
  }
  function n(s) {
    return Object.keys(s).concat(t(s));
  }
  function r(s, f) {
    try {
      return f in s;
    } catch {
      return !1;
    }
  }
  function i(s, f) {
    return r(s, f) && !(Object.hasOwnProperty.call(s, f) && Object.propertyIsEnumerable.call(s, f));
  }
  function A(s, f, h) {
    var m = {};
    return h.isMergeableObject(s) && n(s).forEach(function(o) {
      m[o] = a(s[o], h);
    }), n(f).forEach(function(o) {
      i(s, o) || (r(s, o) && h.isMergeableObject(f[o]) ? m[o] = e(o, h)(s[o], f[o], h) : m[o] = a(f[o], h));
    }), m;
  }
  function y(s, f, h) {
    h = h || {}, h.arrayMerge = h.arrayMerge || c, h.isMergeableObject = h.isMergeableObject || u, h.cloneUnlessOtherwiseSpecified = a;
    var m = Array.isArray(f), o = Array.isArray(s), p = m === o;
    return p ? m ? h.arrayMerge(s, f, h) : A(s, f, h) : a(f, h);
  }
  y.all = function(f, h) {
    if (!Array.isArray(f))
      throw new Error("first argument should be an array");
    return f.reduce(function(m, o) {
      return y(m, o, h);
    }, {});
  };
  var w = y;
  return ot = w, ot;
}
var Ke = { exports: {} }, ti = Ke.exports, Gu;
function ui() {
  return Gu || (Gu = 1, (function(u) {
    (function(d, l) {
      u.exports ? u.exports = l() : d.parseSrcset = l();
    })(ti, function() {
      return function(d) {
        function l(m) {
          return m === " " || // space
          m === "	" || // horizontal tab
          m === `
` || // new line
          m === "\f" || // form feed
          m === "\r";
        }
        function x(m) {
          var o, p = m.exec(d.substring(w));
          if (p)
            return o = p[0], w += o.length, o;
        }
        for (var v = d.length, b = /^[ \t\n\r\u000c]+/, g = /^[, \t\n\r\u000c]+/, a = /^[^ \t\n\r\u000c]+/, c = /[,]+$/, e = /^\d+$/, t = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, n, r, i, A, y, w = 0, s = []; ; ) {
          if (x(g), w >= v)
            return s;
          n = x(a), r = [], n.slice(-1) === "," ? (n = n.replace(c, ""), h()) : f();
        }
        function f() {
          for (x(b), i = "", A = "in descriptor"; ; ) {
            if (y = d.charAt(w), A === "in descriptor")
              if (l(y))
                i && (r.push(i), i = "", A = "after descriptor");
              else if (y === ",") {
                w += 1, i && r.push(i), h();
                return;
              } else if (y === "(")
                i = i + y, A = "in parens";
              else if (y === "") {
                i && r.push(i), h();
                return;
              } else
                i = i + y;
            else if (A === "in parens")
              if (y === ")")
                i = i + y, A = "in descriptor";
              else if (y === "") {
                r.push(i), h();
                return;
              } else
                i = i + y;
            else if (A === "after descriptor" && !l(y))
              if (y === "") {
                h();
                return;
              } else
                A = "in descriptor", w -= 1;
            w += 1;
          }
        }
        function h() {
          var m = !1, o, p, C, D, B = {}, S, I, E, R, k;
          for (D = 0; D < r.length; D++)
            S = r[D], I = S[S.length - 1], E = S.substring(0, S.length - 1), R = parseInt(E, 10), k = parseFloat(E), e.test(E) && I === "w" ? ((o || p) && (m = !0), R === 0 ? m = !0 : o = R) : t.test(E) && I === "x" ? ((o || p || C) && (m = !0), k < 0 ? m = !0 : p = k) : e.test(E) && I === "h" ? ((C || p) && (m = !0), R === 0 ? m = !0 : C = R) : m = !0;
          m ? console && console.log && console.log("Invalid srcset descriptor found in '" + d + "' at '" + S + "'.") : (B.url = n, o && (B.w = o), p && (B.d = p), C && (B.h = C), s.push(B));
        }
      };
    });
  })(Ke)), Ke.exports;
}
var Ue = { exports: {} }, Hu;
function ri() {
  if (Hu) return Ue.exports;
  Hu = 1;
  var u = String, d = function() {
    return { isColorSupported: !1, reset: u, bold: u, dim: u, italic: u, underline: u, inverse: u, hidden: u, strikethrough: u, black: u, red: u, green: u, yellow: u, blue: u, magenta: u, cyan: u, white: u, gray: u, bgBlack: u, bgRed: u, bgGreen: u, bgYellow: u, bgBlue: u, bgMagenta: u, bgCyan: u, bgWhite: u, blackBright: u, redBright: u, greenBright: u, yellowBright: u, blueBright: u, magentaBright: u, cyanBright: u, whiteBright: u, bgBlackBright: u, bgRedBright: u, bgGreenBright: u, bgYellowBright: u, bgBlueBright: u, bgMagentaBright: u, bgCyanBright: u, bgWhiteBright: u };
  };
  return Ue.exports = d(), Ue.exports.createColors = d, Ue.exports;
}
const ii = {}, ni = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ii
}, Symbol.toStringTag, { value: "Module" })), ne = /* @__PURE__ */ Gr(ni);
var ct, Uu;
function Ut() {
  if (Uu) return ct;
  Uu = 1;
  let u = /* @__PURE__ */ ri(), d = ne;
  class l extends Error {
    constructor(v, b, g, a, c, e) {
      super(v), this.name = "CssSyntaxError", this.reason = v, c && (this.file = c), a && (this.source = a), e && (this.plugin = e), typeof b < "u" && typeof g < "u" && (typeof b == "number" ? (this.line = b, this.column = g) : (this.line = b.line, this.column = b.column, this.endLine = g.line, this.endColumn = g.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, l);
    }
    setMessage() {
      this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
    }
    showSourceCode(v) {
      if (!this.source) return "";
      let b = this.source;
      v == null && (v = u.isColorSupported);
      let g = (i) => i, a = (i) => i, c = (i) => i;
      if (v) {
        let { bold: i, gray: A, red: y } = u.createColors(!0);
        a = (w) => i(y(w)), g = (w) => A(w), d && (c = (w) => d(w));
      }
      let e = b.split(/\r?\n/), t = Math.max(this.line - 3, 0), n = Math.min(this.line + 2, e.length), r = String(n).length;
      return e.slice(t, n).map((i, A) => {
        let y = t + 1 + A, w = " " + (" " + y).slice(-r) + " | ";
        if (y === this.line) {
          if (i.length > 160) {
            let f = 20, h = Math.max(0, this.column - f), m = Math.max(
              this.column + f,
              this.endColumn + f
            ), o = i.slice(h, m), p = g(w.replace(/\d/g, " ")) + i.slice(0, Math.min(this.column - 1, f - 1)).replace(/[^\t]/g, " ");
            return a(">") + g(w) + c(o) + `
 ` + p + a("^");
          }
          let s = g(w.replace(/\d/g, " ")) + i.slice(0, this.column - 1).replace(/[^\t]/g, " ");
          return a(">") + g(w) + c(i) + `
 ` + s + a("^");
        }
        return " " + g(w) + c(i);
      }).join(`
`);
    }
    toString() {
      let v = this.showSourceCode();
      return v && (v = `

` + v + `
`), this.name + ": " + this.message + v;
    }
  }
  return ct = l, l.default = l, ct;
}
var lt, Wu;
function Ir() {
  if (Wu) return lt;
  Wu = 1;
  const u = /(<)(\/?style\b)/gi, d = /(<)(!--)/g;
  function l(g) {
    return typeof g != "string" || !g.includes("<") ? g : g.replace(u, "\\3c $2").replace(d, "\\3c $2");
  }
  const x = {
    after: `
`,
    beforeClose: `
`,
    beforeComment: `
`,
    beforeDecl: `
`,
    beforeOpen: " ",
    beforeRule: `
`,
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: !1
  };
  function v(g) {
    return g[0].toUpperCase() + g.slice(1);
  }
  class b {
    constructor(a) {
      this.builder = a;
    }
    atrule(a, c) {
      let e = a.raws, t = "@" + a.name, n = a.params ? this.rawValue(a, "params") : "";
      if (typeof e.afterName < "u" ? t += e.afterName : n && (t += " "), a.nodes)
        this.block(a, t + n);
      else {
        let r = (e.between || "") + (c ? ";" : "");
        this.builder(l(t + n + r), a);
      }
    }
    beforeAfter(a, c) {
      let e;
      a.type === "decl" ? e = this.raw(a, null, "beforeDecl") : a.type === "comment" ? e = this.raw(a, null, "beforeComment") : c === "before" ? e = this.raw(a, null, "beforeRule") : e = this.raw(a, null, "beforeClose");
      let t = a.parent, n = 0;
      for (; t && t.type !== "root"; )
        n += 1, t = t.parent;
      if (e.includes(`
`)) {
        let r = this.raw(a, null, "indent");
        if (r.length)
          for (let i = 0; i < n; i++) e += r;
      }
      return e;
    }
    block(a, c) {
      let e = this.raw(a, "between", "beforeOpen");
      this.builder(l(c + e) + "{", a, "start");
      let t;
      a.nodes && a.nodes.length ? (this.body(a), t = this.raw(a, "after")) : t = this.raw(a, "after", "emptyBody"), t && this.builder(l(t)), this.builder("}", a, "end");
    }
    body(a) {
      let c = a.nodes, e = c.length - 1;
      for (; e > 0 && c[e].type === "comment"; )
        e -= 1;
      let t = this.raw(a, "semicolon"), n = a.type === "document";
      for (let r = 0; r < c.length; r++) {
        let i = c[r], A = this.raw(i, "before");
        A && this.builder(n ? A : l(A)), this.stringify(i, e !== r || t);
      }
    }
    comment(a) {
      let c = this.raw(a, "left", "commentLeft"), e = this.raw(a, "right", "commentRight");
      this.builder(l("/*" + c + a.text + e + "*/"), a);
    }
    decl(a, c) {
      let e = a.raws, t = this.raw(a, "between", "colon"), n = a.prop + t + this.rawValue(a, "value");
      a.important && (n += e.important || " !important"), c && (n += ";"), this.builder(l(n), a);
    }
    document(a) {
      this.body(a);
    }
    raw(a, c, e) {
      let t;
      if (e || (e = c), c && (t = a.raws[c], typeof t < "u"))
        return t;
      let n = a.parent;
      if (e === "before" && (!n || n.type === "root" && n.first === a || n && n.type === "document"))
        return "";
      if (!n) return x[e];
      let r = a.root(), i = r.rawCache || (r.rawCache = {});
      if (typeof i[e] < "u")
        return i[e];
      if (e === "before" || e === "after")
        return this.beforeAfter(a, e);
      {
        let A = "raw" + v(e);
        this[A] ? t = this[A](r, a) : r.walk((y) => {
          if (t = y.raws[c], typeof t < "u") return !1;
        });
      }
      return typeof t > "u" && (t = x[e]), i[e] = t, t;
    }
    rawBeforeClose(a) {
      let c;
      return a.walk((e) => {
        if (e.nodes && e.nodes.length > 0 && typeof e.raws.after < "u")
          return c = e.raws.after, c.includes(`
`) && (c = c.replace(/[^\n]+$/, "")), !1;
      }), c && (c = c.replace(/\S/g, "")), c;
    }
    rawBeforeComment(a, c) {
      let e;
      return a.walkComments((t) => {
        if (typeof t.raws.before < "u")
          return e = t.raws.before, e.includes(`
`) && (e = e.replace(/[^\n]+$/, "")), !1;
      }), typeof e > "u" ? e = this.raw(c, null, "beforeDecl") : e && (e = e.replace(/\S/g, "")), e;
    }
    rawBeforeDecl(a, c) {
      let e;
      return a.walkDecls((t) => {
        if (typeof t.raws.before < "u")
          return e = t.raws.before, e.includes(`
`) && (e = e.replace(/[^\n]+$/, "")), !1;
      }), typeof e > "u" ? e = this.raw(c, null, "beforeRule") : e && (e = e.replace(/\S/g, "")), e;
    }
    rawBeforeOpen(a) {
      let c;
      return a.walk((e) => {
        if (e.type !== "decl" && (c = e.raws.between, typeof c < "u"))
          return !1;
      }), c;
    }
    rawBeforeRule(a) {
      let c;
      return a.walk((e) => {
        if (e.nodes && (e.parent !== a || a.first !== e) && typeof e.raws.before < "u")
          return c = e.raws.before, c.includes(`
`) && (c = c.replace(/[^\n]+$/, "")), !1;
      }), c && (c = c.replace(/\S/g, "")), c;
    }
    rawColon(a) {
      let c;
      return a.walkDecls((e) => {
        if (typeof e.raws.between < "u")
          return c = e.raws.between.replace(/[^\s:]/g, ""), !1;
      }), c;
    }
    rawEmptyBody(a) {
      let c;
      return a.walk((e) => {
        if (e.nodes && e.nodes.length === 0 && (c = e.raws.after, typeof c < "u"))
          return !1;
      }), c;
    }
    rawIndent(a) {
      if (a.raws.indent) return a.raws.indent;
      let c;
      return a.walk((e) => {
        let t = e.parent;
        if (t && t !== a && t.parent && t.parent === a && typeof e.raws.before < "u") {
          let n = e.raws.before.split(`
`);
          return c = n[n.length - 1], c = c.replace(/\S/g, ""), !1;
        }
      }), c;
    }
    rawSemicolon(a) {
      let c;
      return a.walk((e) => {
        if (e.nodes && e.nodes.length && e.last.type === "decl" && (c = e.raws.semicolon, typeof c < "u"))
          return !1;
      }), c;
    }
    rawValue(a, c) {
      let e = a[c], t = a.raws[c];
      return t && t.value === e ? t.raw : e;
    }
    root(a) {
      if (this.body(a), a.raws.after) {
        let c = a.raws.after, e = a.parent && a.parent.type === "document";
        this.builder(e ? c : l(c));
      }
    }
    rule(a) {
      this.block(a, this.rawValue(a, "selector")), a.raws.ownSemicolon && this.builder(l(a.raws.ownSemicolon), a, "end");
    }
    stringify(a, c) {
      if (!this[a.type])
        throw new Error(
          "Unknown AST node type " + a.type + ". Maybe you need to change PostCSS stringifier."
        );
      this[a.type](a, c);
    }
  }
  return lt = b, b.default = b, lt;
}
var At, Ku;
function Je() {
  if (Ku) return At;
  Ku = 1;
  let u = Ir();
  function d(l, x) {
    new u(x).stringify(l);
  }
  return At = d, d.default = d, At;
}
var We = {}, Pu;
function Wt() {
  return Pu || (Pu = 1, We.isClean = /* @__PURE__ */ Symbol("isClean"), We.my = /* @__PURE__ */ Symbol("my")), We;
}
var dt, Yu;
function Ze() {
  if (Yu) return dt;
  Yu = 1;
  let u = Ut(), d = Ir(), l = Je(), { isClean: x, my: v } = Wt();
  function b(c, e) {
    let t = new c.constructor();
    for (let n in c) {
      if (!Object.prototype.hasOwnProperty.call(c, n) || n === "proxyCache") continue;
      let r = c[n], i = typeof r;
      n === "parent" && i === "object" ? e && (t[n] = e) : n === "source" ? t[n] = r : Array.isArray(r) ? t[n] = r.map((A) => b(A, t)) : (i === "object" && r !== null && (r = b(r)), t[n] = r);
    }
    return t;
  }
  function g(c, e) {
    if (e && typeof e.offset < "u")
      return e.offset;
    let t = 1, n = 1, r = 0;
    for (let i = 0; i < c.length; i++) {
      if (n === e.line && t === e.column) {
        r = i;
        break;
      }
      c[i] === `
` ? (t = 1, n += 1) : t += 1;
    }
    return r;
  }
  class a {
    get proxyOf() {
      return this;
    }
    constructor(e = {}) {
      this.raws = {}, this[x] = !1, this[v] = !0;
      for (let t in e)
        if (t === "nodes") {
          this.nodes = [];
          for (let n of e[t])
            typeof n.clone == "function" ? this.append(n.clone()) : this.append(n);
        } else
          this[t] = e[t];
    }
    addToError(e) {
      if (e.postcssNode = this, e.stack && this.source && /\n\s{4}at /.test(e.stack)) {
        let t = this.source;
        e.stack = e.stack.replace(
          /\n\s{4}at /,
          `$&${t.input.from}:${t.start.line}:${t.start.column}$&`
        );
      }
      return e;
    }
    after(e) {
      return this.parent.insertAfter(this, e), this;
    }
    assign(e = {}) {
      for (let t in e)
        this[t] = e[t];
      return this;
    }
    before(e) {
      return this.parent.insertBefore(this, e), this;
    }
    cleanRaws(e) {
      delete this.raws.before, delete this.raws.after, e || delete this.raws.between;
    }
    clone(e = {}) {
      let t = b(this);
      for (let n in e)
        t[n] = e[n];
      return t;
    }
    cloneAfter(e = {}) {
      let t = this.clone(e);
      return this.parent.insertAfter(this, t), t;
    }
    cloneBefore(e = {}) {
      let t = this.clone(e);
      return this.parent.insertBefore(this, t), t;
    }
    error(e, t = {}) {
      if (this.source) {
        let { end: n, start: r } = this.rangeBy(t);
        return this.source.input.error(
          e,
          { column: r.column, line: r.line },
          { column: n.column, line: n.line },
          t
        );
      }
      return new u(e);
    }
    getProxyProcessor() {
      return {
        get(e, t) {
          return t === "proxyOf" ? e : t === "root" ? () => e.root().toProxy() : e[t];
        },
        set(e, t, n) {
          return e[t] === n || (e[t] = n, (t === "prop" || t === "value" || t === "name" || t === "params" || t === "important" || /* c8 ignore next */
          t === "text") && e.markDirty()), !0;
        }
      };
    }
    /* c8 ignore next 3 */
    markClean() {
      this[x] = !0;
    }
    markDirty() {
      if (this[x]) {
        this[x] = !1;
        let e = this;
        for (; e = e.parent; )
          e[x] = !1;
      }
    }
    next() {
      if (!this.parent) return;
      let e = this.parent.index(this);
      return this.parent.nodes[e + 1];
    }
    positionBy(e = {}) {
      let t = this.source.start;
      if (e.index)
        t = this.positionInside(e.index);
      else if (e.word) {
        let n = "document" in this.source.input ? this.source.input.document : this.source.input.css, i = n.slice(
          g(n, this.source.start),
          g(n, this.source.end)
        ).indexOf(e.word);
        i !== -1 && (t = this.positionInside(i));
      }
      return t;
    }
    positionInside(e) {
      let t = this.source.start.column, n = this.source.start.line, r = "document" in this.source.input ? this.source.input.document : this.source.input.css, i = g(r, this.source.start), A = i + e;
      for (let y = i; y < A; y++)
        r[y] === `
` ? (t = 1, n += 1) : t += 1;
      return { column: t, line: n, offset: A };
    }
    prev() {
      if (!this.parent) return;
      let e = this.parent.index(this);
      return this.parent.nodes[e - 1];
    }
    rangeBy(e = {}) {
      let t = "document" in this.source.input ? this.source.input.document : this.source.input.css, n = {
        column: this.source.start.column,
        line: this.source.start.line,
        offset: g(t, this.source.start)
      }, r = this.source.end ? {
        column: this.source.end.column + 1,
        line: this.source.end.line,
        offset: typeof this.source.end.offset == "number" ? (
          // `source.end.offset` is exclusive, so we don't need to add 1
          this.source.end.offset
        ) : (
          // Since line/column in this.source.end is inclusive,
          // the `sourceOffset(... , this.source.end)` returns an inclusive offset.
          // So, we add 1 to convert it to exclusive.
          g(t, this.source.end) + 1
        )
      } : {
        column: n.column + 1,
        line: n.line,
        offset: n.offset + 1
      };
      if (e.word) {
        let A = t.slice(
          g(t, this.source.start),
          g(t, this.source.end)
        ).indexOf(e.word);
        A !== -1 && (n = this.positionInside(A), r = this.positionInside(A + e.word.length));
      } else
        e.start ? n = {
          column: e.start.column,
          line: e.start.line,
          offset: g(t, e.start)
        } : e.index && (n = this.positionInside(e.index)), e.end ? r = {
          column: e.end.column,
          line: e.end.line,
          offset: g(t, e.end)
        } : typeof e.endIndex == "number" ? r = this.positionInside(e.endIndex) : e.index && (r = this.positionInside(e.index + 1));
      return (r.line < n.line || r.line === n.line && r.column <= n.column) && (r = {
        column: n.column + 1,
        line: n.line,
        offset: n.offset + 1
      }), { end: r, start: n };
    }
    raw(e, t) {
      return new d().raw(this, e, t);
    }
    remove() {
      return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
    }
    replaceWith(...e) {
      if (this.parent) {
        let t = this, n = !1;
        for (let r of e)
          r === this ? n = !0 : n ? (this.parent.insertAfter(t, r), t = r) : this.parent.insertBefore(t, r);
        n || this.remove();
      }
      return this;
    }
    root() {
      let e = this;
      for (; e.parent && e.parent.type !== "document"; )
        e = e.parent;
      return e;
    }
    toJSON(e, t) {
      let n = {}, r = t == null;
      t = t || /* @__PURE__ */ new Map();
      let i = 0;
      for (let A in this) {
        if (!Object.prototype.hasOwnProperty.call(this, A) || A === "parent" || A === "proxyCache") continue;
        let y = this[A];
        if (Array.isArray(y))
          n[A] = y.map((w) => typeof w == "object" && w.toJSON ? w.toJSON(null, t) : w);
        else if (typeof y == "object" && y.toJSON)
          n[A] = y.toJSON(null, t);
        else if (A === "source") {
          if (y == null) continue;
          let w = t.get(y.input);
          w == null && (w = i, t.set(y.input, i), i++), n[A] = {
            end: y.end,
            inputId: w,
            start: y.start
          };
        } else
          n[A] = y;
      }
      return r && (n.inputs = [...t.keys()].map((A) => A.toJSON())), n;
    }
    toProxy() {
      return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
    }
    toString(e = l) {
      e.stringify && (e = e.stringify);
      let t = "";
      return e(this, (n) => {
        t += n;
      }), t;
    }
    warn(e, t, n = {}) {
      let r = { node: this };
      for (let i in n) r[i] = n[i];
      return e.warn(t, r);
    }
  }
  return dt = a, a.default = a, dt;
}
var ft, Ju;
function je() {
  if (Ju) return ft;
  Ju = 1;
  let u = Ze();
  class d extends u {
    constructor(x) {
      super(x), this.type = "comment";
    }
  }
  return ft = d, d.default = d, ft;
}
var ht, Zu;
function _e() {
  if (Zu) return ht;
  Zu = 1;
  let u = Ze();
  class d extends u {
    get variable() {
      return this.prop.startsWith("--") || this.prop[0] === "$";
    }
    constructor(x) {
      x && typeof x.value < "u" && typeof x.value != "string" && (x = { ...x, value: String(x.value) }), super(x), this.type = "decl";
    }
  }
  return ht = d, d.default = d, ht;
}
var gt, ju;
function we() {
  if (ju) return gt;
  ju = 1;
  let u = je(), d = _e(), l = Ze(), { isClean: x, my: v } = Wt(), b, g, a, c;
  function e(r) {
    return r.map((i) => (i.nodes && (i.nodes = e(i.nodes)), delete i.source, i));
  }
  function t(r) {
    if (r[x] = !1, r.proxyOf.nodes)
      for (let i of r.proxyOf.nodes)
        t(i);
  }
  class n extends l {
    get first() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[0];
    }
    get last() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
    append(...i) {
      for (let A of i) {
        let y = this.normalize(A, this.last);
        for (let w of y) this.proxyOf.nodes.push(w);
      }
      return this.markDirty(), this;
    }
    cleanRaws(i) {
      if (super.cleanRaws(i), this.nodes)
        for (let A of this.nodes) A.cleanRaws(i);
    }
    each(i) {
      if (!this.proxyOf.nodes) return;
      let A = this.getIterator(), y, w;
      for (; this.indexes[A] < this.proxyOf.nodes.length && (y = this.indexes[A], w = i(this.proxyOf.nodes[y], y), w !== !1); )
        this.indexes[A] += 1;
      return delete this.indexes[A], w;
    }
    every(i) {
      return this.nodes.every(i);
    }
    getIterator() {
      this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
      let i = this.lastEach;
      return this.indexes[i] = 0, i;
    }
    getProxyProcessor() {
      return {
        get(i, A) {
          return A === "proxyOf" ? i : i[A] ? A === "each" || typeof A == "string" && A.startsWith("walk") ? (...y) => i[A](
            ...y.map((w) => typeof w == "function" ? (s, f) => w(s.toProxy(), f) : w)
          ) : A === "every" || A === "some" ? (y) => i[A](
            (w, ...s) => y(w.toProxy(), ...s)
          ) : A === "root" ? () => i.root().toProxy() : A === "nodes" ? i.nodes.map((y) => y.toProxy()) : A === "first" || A === "last" ? i[A].toProxy() : i[A] : i[A];
        },
        set(i, A, y) {
          return i[A] === y || (i[A] = y, (A === "name" || A === "params" || A === "selector") && i.markDirty()), !0;
        }
      };
    }
    index(i) {
      return typeof i == "number" ? i : (i.proxyOf && (i = i.proxyOf), this.proxyOf.nodes.indexOf(i));
    }
    insertAfter(i, A) {
      let y = this.index(i), w = this.normalize(A, this.proxyOf.nodes[y]).reverse();
      y = this.index(i);
      for (let f of w) this.proxyOf.nodes.splice(y + 1, 0, f);
      let s;
      for (let f in this.indexes)
        s = this.indexes[f], y < s && (this.indexes[f] = s + w.length);
      return this.markDirty(), this;
    }
    insertBefore(i, A) {
      let y = this.index(i), w = y === 0 ? "prepend" : !1, s = this.normalize(
        A,
        this.proxyOf.nodes[y],
        w
      ).reverse();
      y = this.index(i);
      for (let h of s) this.proxyOf.nodes.splice(y, 0, h);
      let f;
      for (let h in this.indexes)
        f = this.indexes[h], y <= f && (this.indexes[h] = f + s.length);
      return this.markDirty(), this;
    }
    normalize(i, A) {
      if (typeof i == "string")
        i = e(g(i).nodes);
      else if (typeof i > "u")
        i = [];
      else if (Array.isArray(i)) {
        i = i.slice(0);
        for (let w of i)
          w.parent && w.parent.removeChild(w, "ignore");
      } else if (i.type === "root" && this.type !== "document") {
        i = i.nodes.slice(0);
        for (let w of i)
          w.parent && w.parent.removeChild(w, "ignore");
      } else if (i.type)
        i = [i];
      else if (i.prop) {
        if (typeof i.value > "u")
          throw new Error("Value field is missed in node creation");
        typeof i.value != "string" && (i.value = String(i.value)), i = [new d(i)];
      } else if (i.selector || i.selectors)
        i = [new c(i)];
      else if (i.name)
        i = [new b(i)];
      else if (i.text)
        i = [new u(i)];
      else
        throw new Error("Unknown node type in node creation");
      return i.map((w) => (w[v] || n.rebuild(w), w = w.proxyOf, w.parent && w.parent.removeChild(w), w[x] && t(w), w.raws || (w.raws = {}), typeof w.raws.before > "u" && A && typeof A.raws.before < "u" && (w.raws.before = A.raws.before.replace(/\S/g, "")), w.parent = this.proxyOf, w));
    }
    prepend(...i) {
      i = i.reverse();
      for (let A of i) {
        let y = this.normalize(A, this.first, "prepend").reverse();
        for (let w of y) this.proxyOf.nodes.unshift(w);
        for (let w in this.indexes)
          this.indexes[w] = this.indexes[w] + y.length;
      }
      return this.markDirty(), this;
    }
    push(i) {
      return i.parent = this, this.proxyOf.nodes.push(i), this;
    }
    removeAll() {
      for (let i of this.proxyOf.nodes) i.parent = void 0;
      return this.proxyOf.nodes = [], this.markDirty(), this;
    }
    removeChild(i) {
      i = this.index(i), this.proxyOf.nodes[i].parent = void 0, this.proxyOf.nodes.splice(i, 1);
      let A;
      for (let y in this.indexes)
        A = this.indexes[y], A >= i && (this.indexes[y] = A - 1);
      return this.markDirty(), this;
    }
    replaceValues(i, A, y) {
      return y || (y = A, A = {}), this.walkDecls((w) => {
        A.props && !A.props.includes(w.prop) || A.fast && !w.value.includes(A.fast) || (w.value = w.value.replace(i, y));
      }), this.markDirty(), this;
    }
    some(i) {
      return this.nodes.some(i);
    }
    walk(i) {
      return this.each((A, y) => {
        let w;
        try {
          w = i(A, y);
        } catch (s) {
          throw A.addToError(s);
        }
        return w !== !1 && A.walk && (w = A.walk(i)), w;
      });
    }
    walkAtRules(i, A) {
      return A ? i instanceof RegExp ? this.walk((y, w) => {
        if (y.type === "atrule" && i.test(y.name))
          return A(y, w);
      }) : this.walk((y, w) => {
        if (y.type === "atrule" && y.name === i)
          return A(y, w);
      }) : (A = i, this.walk((y, w) => {
        if (y.type === "atrule")
          return A(y, w);
      }));
    }
    walkComments(i) {
      return this.walk((A, y) => {
        if (A.type === "comment")
          return i(A, y);
      });
    }
    walkDecls(i, A) {
      return A ? i instanceof RegExp ? this.walk((y, w) => {
        if (y.type === "decl" && i.test(y.prop))
          return A(y, w);
      }) : this.walk((y, w) => {
        if (y.type === "decl" && y.prop === i)
          return A(y, w);
      }) : (A = i, this.walk((y, w) => {
        if (y.type === "decl")
          return A(y, w);
      }));
    }
    walkRules(i, A) {
      return A ? i instanceof RegExp ? this.walk((y, w) => {
        if (y.type === "rule" && i.test(y.selector))
          return A(y, w);
      }) : this.walk((y, w) => {
        if (y.type === "rule" && y.selector === i)
          return A(y, w);
      }) : (A = i, this.walk((y, w) => {
        if (y.type === "rule")
          return A(y, w);
      }));
    }
  }
  return n.registerParse = (r) => {
    g = r;
  }, n.registerRule = (r) => {
    c = r;
  }, n.registerAtRule = (r) => {
    b = r;
  }, n.registerRoot = (r) => {
    a = r;
  }, gt = n, n.default = n, n.rebuild = (r) => {
    r.type === "atrule" ? Object.setPrototypeOf(r, b.prototype) : r.type === "rule" ? Object.setPrototypeOf(r, c.prototype) : r.type === "decl" ? Object.setPrototypeOf(r, d.prototype) : r.type === "comment" ? Object.setPrototypeOf(r, u.prototype) : r.type === "root" && Object.setPrototypeOf(r, a.prototype), r[v] = !0, r.nodes && r.nodes.forEach((i) => {
      n.rebuild(i);
    });
  }, gt;
}
var bt, _u;
function Kt() {
  if (_u) return bt;
  _u = 1;
  let u = we();
  class d extends u {
    constructor(x) {
      super(x), this.type = "atrule";
    }
    append(...x) {
      return this.proxyOf.nodes || (this.nodes = []), super.append(...x);
    }
    prepend(...x) {
      return this.proxyOf.nodes || (this.nodes = []), super.prepend(...x);
    }
  }
  return bt = d, d.default = d, u.registerAtRule(d), bt;
}
var pt, Vu;
function Pt() {
  if (Vu) return pt;
  Vu = 1;
  let u = we(), d, l;
  class x extends u {
    constructor(b) {
      super({ type: "document", ...b }), this.nodes || (this.nodes = []);
    }
    toResult(b = {}) {
      return new d(new l(), this, b).stringify();
    }
  }
  return x.registerLazyResult = (v) => {
    d = v;
  }, x.registerProcessor = (v) => {
    l = v;
  }, pt = x, x.default = x, pt;
}
var mt, Xu;
function ai() {
  if (Xu) return mt;
  Xu = 1;
  let u = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
  return mt = { nanoid: (x = 21) => {
    let v = "", b = x | 0;
    for (; b--; )
      v += u[Math.random() * 64 | 0];
    return v;
  }, customAlphabet: (x, v = 21) => (b = v) => {
    let g = "", a = b | 0;
    for (; a--; )
      g += x[Math.random() * x.length | 0];
    return g;
  } }, mt;
}
var yt, zu;
function Cr() {
  if (zu) return yt;
  zu = 1;
  let { existsSync: u, readFileSync: d } = ne, { dirname: l, join: x } = ne, { SourceMapConsumer: v, SourceMapGenerator: b } = ne;
  function g(c) {
    return Buffer ? Buffer.from(c, "base64").toString() : window.atob(c);
  }
  class a {
    constructor(e, t) {
      if (t.map === !1) return;
      t.unsafeMap && (this.unsafeMap = !0), this.loadAnnotation(e), this.inline = this.startWith(this.annotation, "data:");
      let n = t.map ? t.map.prev : void 0, r = this.loadMap(t.from, n);
      !this.mapFile && t.from && (this.mapFile = t.from), this.mapFile && (this.root = l(this.mapFile)), r && (this.text = r);
    }
    consumer() {
      return this.consumerCache || (this.consumerCache = new v(this.json || this.text)), this.consumerCache;
    }
    decodeInline(e) {
      let t = /^data:application\/json;charset=utf-?8;base64,/, n = /^data:application\/json;base64,/, r = /^data:application\/json;charset=utf-?8,/, i = /^data:application\/json,/, A = e.match(r) || e.match(i);
      if (A)
        return decodeURIComponent(e.substr(A[0].length));
      let y = e.match(t) || e.match(n);
      if (y)
        return g(e.substr(y[0].length));
      let w = e.slice(22);
      throw w = w.slice(0, w.indexOf(",")), new Error("Unsupported source map encoding " + w);
    }
    getAnnotationURL(e) {
      return e.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(e) {
      return typeof e != "object" ? !1 : typeof e.mappings == "string" || typeof e._mappings == "string" || Array.isArray(e.sections);
    }
    loadAnnotation(e) {
      let t = e.match(/\/\*\s*# sourceMappingURL=/g);
      if (!t) return;
      let n = e.lastIndexOf(t.pop()), r = e.indexOf("*/", n);
      n > -1 && r > -1 && (this.annotation = this.getAnnotationURL(e.substring(n, r)));
    }
    loadFile(e, t, n) {
      if (!(!n && !this.unsafeMap && !/\.map$/i.test(e)) && (this.root = l(e), u(e)))
        return this.mapFile = e, d(e, "utf-8").toString().trim();
    }
    loadMap(e, t) {
      if (t === !1) return !1;
      if (t) {
        if (typeof t == "string")
          return t;
        if (typeof t == "function") {
          let n = t(e);
          if (n) {
            let r = this.loadFile(n, e, !0);
            if (!r)
              throw new Error(
                "Unable to load previous source map: " + n.toString()
              );
            return r;
          }
        } else {
          if (t instanceof v)
            return b.fromSourceMap(t).toString();
          if (t instanceof b)
            return t.toString();
          if (this.isMap(t))
            return JSON.stringify(t);
          throw new Error(
            "Unsupported previous source map format: " + t.toString()
          );
        }
      } else {
        if (this.inline)
          return this.decodeInline(this.annotation);
        if (this.annotation) {
          let n = this.annotation;
          e && (n = x(l(e), n));
          let r = this.loadFile(n, e, !1);
          if (r)
            try {
              this.json = JSON.parse(r.replace(/^\)]}'[^\n]*\n/, ""));
            } catch {
              return;
            }
          return r;
        }
      }
    }
    startWith(e, t) {
      return e ? e.substr(0, t.length) === t : !1;
    }
    withContent() {
      return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
  }
  return yt = a, a.default = a, yt;
}
var wt, $u;
function Ve() {
  if ($u) return wt;
  $u = 1;
  let { nanoid: u } = /* @__PURE__ */ ai(), { isAbsolute: d, resolve: l } = ne, { SourceMapConsumer: x, SourceMapGenerator: v } = ne, { fileURLToPath: b, pathToFileURL: g } = ne, a = Ut(), c = Cr(), e = ne, t = /* @__PURE__ */ Symbol("lineToIndexCache"), n = !!(x && v), r = !!(l && d);
  function i(y) {
    if (y[t]) return y[t];
    let w = y.css.split(`
`), s = new Array(w.length), f = 0;
    for (let h = 0, m = w.length; h < m; h++)
      s[h] = f, f += w[h].length + 1;
    return y[t] = s, s;
  }
  class A {
    get from() {
      return this.file || this.id;
    }
    constructor(w, s = {}) {
      if (w === null || typeof w > "u" || typeof w == "object" && !w.toString)
        throw new Error(`PostCSS received ${w} instead of CSS string`);
      if (this.css = w.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, s.document && (this.document = s.document.toString()), s.from && (!r || /^\w+:\/\//.test(s.from) || d(s.from) ? this.file = s.from : this.file = l(s.from)), r && n) {
        let f = new c(this.css, s);
        if (f.text) {
          this.map = f;
          let h = f.consumer().file;
          !this.file && h && (this.file = this.mapResolve(h));
        }
      }
      this.file || (this.id = "<input css " + u(6) + ">"), this.map && (this.map.file = this.from);
    }
    error(w, s, f, h = {}) {
      let m, o, p, C, D;
      if (s && typeof s == "object") {
        let S = s, I = f;
        if (typeof S.offset == "number") {
          C = S.offset;
          let E = this.fromOffset(C);
          s = E.line, f = E.col;
        } else
          s = S.line, f = S.column, C = this.fromLineAndColumn(s, f);
        if (typeof I.offset == "number") {
          p = I.offset;
          let E = this.fromOffset(p);
          o = E.line, m = E.col;
        } else
          o = I.line, m = I.column, p = this.fromLineAndColumn(I.line, I.column);
      } else if (f)
        C = this.fromLineAndColumn(s, f);
      else {
        C = s;
        let S = this.fromOffset(C);
        s = S.line, f = S.col;
      }
      let B = this.origin(s, f, o, m);
      return B ? D = new a(
        w,
        B.endLine === void 0 ? B.line : { column: B.column, line: B.line },
        B.endLine === void 0 ? B.column : { column: B.endColumn, line: B.endLine },
        B.source,
        B.file,
        h.plugin
      ) : D = new a(
        w,
        o === void 0 ? s : { column: f, line: s },
        o === void 0 ? f : { column: m, line: o },
        this.css,
        this.file,
        h.plugin
      ), D.input = {
        column: f,
        endColumn: m,
        endLine: o,
        endOffset: p,
        line: s,
        offset: C,
        source: this.css
      }, this.file && (g && (D.input.url = g(this.file).toString()), D.input.file = this.file), D;
    }
    fromLineAndColumn(w, s) {
      return i(this)[w - 1] + s - 1;
    }
    fromOffset(w) {
      let s = i(this), f = s[s.length - 1], h = 0;
      if (w >= f)
        h = s.length - 1;
      else {
        let m = s.length - 2, o;
        for (; h < m; )
          if (o = h + (m - h >> 1), w < s[o])
            m = o - 1;
          else if (w >= s[o + 1])
            h = o + 1;
          else {
            h = o;
            break;
          }
      }
      return {
        col: w - s[h] + 1,
        line: h + 1
      };
    }
    mapResolve(w) {
      return /^\w+:\/\//.test(w) ? w : l(this.map.consumer().sourceRoot || this.map.root || ".", w);
    }
    origin(w, s, f, h) {
      if (!this.map) return !1;
      let m = this.map.consumer(), o = m.originalPositionFor({ column: s, line: w });
      if (!o.source) return !1;
      let p;
      typeof f == "number" && (p = m.originalPositionFor({ column: h, line: f }));
      let C;
      d(o.source) ? C = g(o.source) : C = new URL(
        o.source,
        this.map.consumer().sourceRoot || g(this.map.mapFile)
      );
      let D = {
        column: o.column,
        endColumn: p && p.column,
        endLine: p && p.line,
        line: o.line,
        url: C.toString()
      };
      if (C.protocol === "file:")
        if (b)
          D.file = b(C);
        else
          throw new Error("file: protocol is not available in this PostCSS build");
      let B = m.sourceContentFor(o.source);
      return B && (D.source = B), D;
    }
    toJSON() {
      let w = {};
      for (let s of ["hasBOM", "css", "file", "id"])
        this[s] != null && (w[s] = this[s]);
      return this.map && (w.map = { ...this.map }, w.map.consumerCache && (w.map.consumerCache = void 0)), w;
    }
  }
  return wt = A, A.default = A, e && e.registerInput && e.registerInput(A), wt;
}
var vt, er;
function Te() {
  if (er) return vt;
  er = 1;
  let u = we(), d, l;
  class x extends u {
    constructor(b) {
      super(b), this.type = "root", this.nodes || (this.nodes = []);
    }
    normalize(b, g, a) {
      let c = super.normalize(b);
      if (g) {
        if (a === "prepend")
          this.nodes.length > 1 ? g.raws.before = this.nodes[1].raws.before : delete g.raws.before;
        else if (this.first !== g)
          for (let e of c)
            e.raws.before = g.raws.before;
      }
      return c;
    }
    removeChild(b, g) {
      let a = this.index(b);
      return !g && a === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[a].raws.before), super.removeChild(b);
    }
    toResult(b = {}) {
      return new d(new l(), this, b).stringify();
    }
  }
  return x.registerLazyResult = (v) => {
    d = v;
  }, x.registerProcessor = (v) => {
    l = v;
  }, vt = x, x.default = x, u.registerRoot(x), vt;
}
var xt, tr;
function Br() {
  if (tr) return xt;
  tr = 1;
  let u = {
    comma(d) {
      return u.split(d, [","], !0);
    },
    space(d) {
      let l = [" ", `
`, "	"];
      return u.split(d, l);
    },
    split(d, l, x) {
      let v = [], b = "", g = !1, a = 0, c = !1, e = "", t = !1;
      for (let n of d)
        t ? t = !1 : n === "\\" ? t = !0 : c ? n === e && (c = !1) : n === '"' || n === "'" ? (c = !0, e = n) : n === "(" ? a += 1 : n === ")" ? a > 0 && (a -= 1) : a === 0 && l.includes(n) && (g = !0), g ? (b !== "" && v.push(b.trim()), b = "", g = !1) : b += n;
      return (x || b !== "") && v.push(b.trim()), v;
    }
  };
  return xt = u, u.default = u, xt;
}
var It, ur;
function Yt() {
  if (ur) return It;
  ur = 1;
  let u = we(), d = Br();
  class l extends u {
    get selectors() {
      return d.comma(this.selector);
    }
    set selectors(v) {
      let b = this.selector ? this.selector.match(/,\s*/) : null, g = b ? b[0] : "," + this.raw("between", "beforeOpen");
      this.selector = v.join(g);
    }
    constructor(v) {
      super(v), this.type = "rule", this.nodes || (this.nodes = []);
    }
  }
  return It = l, l.default = l, u.registerRule(l), It;
}
var Ct, rr;
function si() {
  if (rr) return Ct;
  rr = 1;
  let u = Kt(), d = je(), l = _e(), x = Ve(), v = Cr(), b = Te(), g = Yt();
  function a(c, e) {
    if (Array.isArray(c)) return c.map((r) => a(r));
    let { inputs: t, ...n } = c;
    if (t) {
      e = [];
      for (let r of t) {
        let i = { ...r, __proto__: x.prototype };
        i.map && (i.map = {
          ...i.map,
          __proto__: v.prototype
        }), e.push(i);
      }
    }
    if (n.nodes && (n.nodes = c.nodes.map((r) => a(r, e))), n.source) {
      let { inputId: r, ...i } = n.source;
      n.source = i, r != null && (n.source.input = e[r]);
    }
    if (n.type === "root")
      return new b(n);
    if (n.type === "decl")
      return new l(n);
    if (n.type === "rule")
      return new g(n);
    if (n.type === "comment")
      return new d(n);
    if (n.type === "atrule")
      return new u(n);
    throw new Error("Unknown node type: " + c.type);
  }
  return Ct = a, a.default = a, Ct;
}
var Bt, ir;
function Er() {
  if (ir) return Bt;
  ir = 1;
  let { dirname: u, relative: d, resolve: l, sep: x } = ne, { SourceMapConsumer: v, SourceMapGenerator: b } = ne, { pathToFileURL: g } = ne, a = Ve(), c = !!(v && b), e = !!(u && l && d && x);
  class t {
    constructor(r, i, A, y) {
      this.stringify = r, this.mapOpts = A.map || {}, this.root = i, this.opts = A, this.css = y, this.originalCSS = y, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    addAnnotation() {
      let r;
      this.isInline() ? r = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? r = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? r = this.mapOpts.annotation(this.opts.to, this.root) : r = this.outputFile() + ".map";
      let i = `
`;
      this.css.includes(`\r
`) && (i = `\r
`), this.css += i + "/*# sourceMappingURL=" + r + " */";
    }
    applyPrevMaps() {
      for (let r of this.previous()) {
        let i = this.toUrl(this.path(r.file)), A = r.root || u(r.file), y;
        this.mapOpts.sourcesContent === !1 ? (y = new v(r.text), y.sourcesContent && (y.sourcesContent = null)) : y = r.consumer(), this.map.applySourceMap(y, i, this.toUrl(this.path(A)));
      }
    }
    clearAnnotation() {
      if (this.mapOpts.annotation !== !1) {
        if (this.root) {
          let r;
          for (let i = this.root.nodes.length - 1; i >= 0; i--)
            r = this.root.nodes[i], r.type === "comment" && r.text.startsWith("# sourceMappingURL=") && this.root.removeChild(i);
        } else if (this.css) {
          let r;
          for (; (r = this.css.lastIndexOf("/*#")) !== -1; ) {
            let i = this.css.indexOf("*/", r + 3);
            if (i === -1) break;
            for (; r > 0 && this.css[r - 1] === `
`; )
              r--;
            this.css = this.css.slice(0, r) + this.css.slice(i + 2);
          }
        }
      }
    }
    generate() {
      if (this.clearAnnotation(), e && c && this.isMap())
        return this.generateMap();
      {
        let r = "";
        return this.stringify(this.root, (i) => {
          r += i;
        }), [r];
      }
    }
    generateMap() {
      if (this.root)
        this.generateString();
      else if (this.previous().length === 1) {
        let r = this.previous()[0].consumer();
        r.file = this.outputFile(), this.map = b.fromSourceMap(r, {
          ignoreInvalidMapping: !0
        });
      } else
        this.map = new b({
          file: this.outputFile(),
          ignoreInvalidMapping: !0
        }), this.map.addMapping({
          generated: { column: 0, line: 1 },
          original: { column: 0, line: 1 },
          source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
        });
      return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
    }
    generateString() {
      this.css = "", this.map = new b({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      });
      let r = 1, i = 1, A = "<no source>", y = {
        generated: { column: 0, line: 0 },
        original: { column: 0, line: 0 },
        source: ""
      }, w, s;
      this.stringify(this.root, (f, h, m) => {
        if (this.css += f, h && m !== "end" && (y.generated.line = r, y.generated.column = i - 1, h.source && h.source.start ? (y.source = this.sourcePath(h), y.original.line = h.source.start.line, y.original.column = h.source.start.column - 1, this.map.addMapping(y)) : (y.source = A, y.original.line = 1, y.original.column = 0, this.map.addMapping(y))), s = f.match(/\n/g), s ? (r += s.length, w = f.lastIndexOf(`
`), i = f.length - w) : i += f.length, h && m !== "start") {
          let o = h.parent || { raws: {} };
          (!(h.type === "decl" || h.type === "atrule" && !h.nodes) || h !== o.last || o.raws.semicolon) && (h.source && h.source.end ? (y.source = this.sourcePath(h), y.original.line = h.source.end.line, y.original.column = h.source.end.column - 1, y.generated.line = r, y.generated.column = i - 2, this.map.addMapping(y)) : (y.source = A, y.original.line = 1, y.original.column = 0, y.generated.line = r, y.generated.column = i - 1, this.map.addMapping(y)));
        }
      });
    }
    isAnnotation() {
      return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((r) => r.annotation) : !0;
    }
    isInline() {
      if (typeof this.mapOpts.inline < "u")
        return this.mapOpts.inline;
      let r = this.mapOpts.annotation;
      return typeof r < "u" && r !== !0 ? !1 : this.previous().length ? this.previous().some((i) => i.inline) : !0;
    }
    isMap() {
      return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
    }
    isSourcesContent() {
      return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((r) => r.withContent()) : !0;
    }
    outputFile() {
      return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
    }
    path(r) {
      if (this.mapOpts.absolute || r.charCodeAt(0) === 60 || /^\w+:\/\//.test(r)) return r;
      let i = this.memoizedPaths.get(r);
      if (i) return i;
      let A = this.opts.to ? u(this.opts.to) : ".";
      typeof this.mapOpts.annotation == "string" && (A = u(l(A, this.mapOpts.annotation)));
      let y = d(A, r);
      return this.memoizedPaths.set(r, y), y;
    }
    previous() {
      if (!this.previousMaps)
        if (this.previousMaps = [], this.root)
          this.root.walk((r) => {
            if (r.source && r.source.input.map) {
              let i = r.source.input.map;
              this.previousMaps.includes(i) || this.previousMaps.push(i);
            }
          });
        else {
          let r = new a(this.originalCSS, this.opts);
          r.map && this.previousMaps.push(r.map);
        }
      return this.previousMaps;
    }
    setSourcesContent() {
      let r = {};
      if (this.root)
        this.root.walk((i) => {
          if (i.source) {
            let A = i.source.input.from;
            if (A && !r[A]) {
              r[A] = !0;
              let y = this.usesFileUrls ? this.toFileUrl(A) : this.toUrl(this.path(A));
              this.map.setSourceContent(y, i.source.input.css);
            }
          }
        });
      else if (this.css) {
        let i = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
        this.map.setSourceContent(i, this.css);
      }
    }
    sourcePath(r) {
      return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(r.source.input.from) : this.toUrl(this.path(r.source.input.from));
    }
    toBase64(r) {
      return Buffer ? Buffer.from(r).toString("base64") : window.btoa(unescape(encodeURIComponent(r)));
    }
    toFileUrl(r) {
      let i = this.memoizedFileURLs.get(r);
      if (i) return i;
      if (g) {
        let A = g(r).toString();
        return this.memoizedFileURLs.set(r, A), A;
      } else
        throw new Error(
          "`map.absolute` option is not available in this PostCSS build"
        );
    }
    toUrl(r) {
      let i = this.memoizedURLs.get(r);
      if (i) return i;
      x === "\\" && (r = r.replace(/\\/g, "/"));
      let A = encodeURI(r).replace(/[#?]/g, encodeURIComponent);
      return this.memoizedURLs.set(r, A), A;
    }
  }
  return Bt = t, Bt;
}
var Et, nr;
function oi() {
  if (nr) return Et;
  nr = 1;
  const u = 39, d = 34, l = 92, x = 47, v = 10, b = 32, g = 12, a = 9, c = 13, e = 91, t = 93, n = 40, r = 41, i = 123, A = 125, y = 59, w = 42, s = 58, f = 64, h = /[\t\n\f\r "#'()/;[\\\]{}]/g, m = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, o = /.[\r\n"'(/\\]/, p = /[\da-f]/i;
  return Et = function(D, B = {}) {
    let S = D.css.valueOf(), I = B.ignoreErrors, E, R, k, N, q, M, G, J, Z, z, he = S.length, Q = 0, $ = [], ge = [], Ee = -1;
    function Xe() {
      return Q;
    }
    function De(O) {
      throw D.error("Unclosed " + O, Q);
    }
    function ze() {
      return ge.length === 0 && Q >= he;
    }
    function Oe(O) {
      if (ge.length) return ge.pop();
      if (Q >= he) return;
      let T = O ? O.ignoreUnclosed : !1;
      switch (E = S.charCodeAt(Q), E) {
        case v:
        case b:
        case a:
        case c:
        case g: {
          N = Q;
          do
            N += 1, E = S.charCodeAt(N);
          while (E === b || E === v || E === a || E === c || E === g);
          M = ["space", S.slice(Q, N)], Q = N - 1;
          break;
        }
        case e:
        case t:
        case i:
        case A:
        case s:
        case y:
        case r: {
          let H = String.fromCharCode(E);
          M = [H, H, Q];
          break;
        }
        case n: {
          if (z = $.length ? $.pop()[1] : "", Z = S.charCodeAt(Q + 1), z === "url" && Z !== u && Z !== d && Z !== b && Z !== v && Z !== a && Z !== g && Z !== c) {
            N = Q;
            do {
              if (G = !1, N = S.indexOf(")", N + 1), N === -1)
                if (I || T) {
                  N = Q;
                  break;
                } else
                  De("bracket");
              for (J = N; S.charCodeAt(J - 1) === l; )
                J -= 1, G = !G;
            } while (G);
            M = ["brackets", S.slice(Q, N + 1), Q, N], Q = N;
          } else Q <= Ee ? M = ["(", "(", Q] : (N = S.indexOf(")", Q + 1), R = S.slice(Q, N + 1), N === -1 || o.test(R) ? (Ee = N === -1 ? he : N, M = ["(", "(", Q]) : (M = ["brackets", R, Q, N], Q = N));
          break;
        }
        case u:
        case d: {
          q = E === u ? "'" : '"', N = Q;
          do {
            if (G = !1, N = S.indexOf(q, N + 1), N === -1)
              if (I || T) {
                N = Q + 1;
                break;
              } else
                De("string");
            for (J = N; S.charCodeAt(J - 1) === l; )
              J -= 1, G = !G;
          } while (G);
          M = ["string", S.slice(Q, N + 1), Q, N], Q = N;
          break;
        }
        case f: {
          h.lastIndex = Q + 1, h.test(S), h.lastIndex === 0 ? N = S.length - 1 : N = h.lastIndex - 2, M = ["at-word", S.slice(Q, N + 1), Q, N], Q = N;
          break;
        }
        case l: {
          for (N = Q, k = !0; S.charCodeAt(N + 1) === l; )
            N += 1, k = !k;
          if (E = S.charCodeAt(N + 1), k && E !== x && E !== b && E !== v && E !== a && E !== c && E !== g && (N += 1, p.test(S.charAt(N)))) {
            for (; p.test(S.charAt(N + 1)); )
              N += 1;
            S.charCodeAt(N + 1) === b && (N += 1);
          }
          M = ["word", S.slice(Q, N + 1), Q, N], Q = N;
          break;
        }
        default: {
          E === x && S.charCodeAt(Q + 1) === w ? (N = S.indexOf("*/", Q + 2) + 1, N === 0 && (I || T ? N = S.length : De("comment")), M = ["comment", S.slice(Q, N + 1), Q, N], Q = N) : (m.lastIndex = Q + 1, m.test(S), m.lastIndex === 0 ? N = S.length - 1 : N = m.lastIndex - 2, M = ["word", S.slice(Q, N + 1), Q, N], $.push(M), Q = N);
          break;
        }
      }
      return Q++, M;
    }
    function F(O) {
      ge.push(O);
    }
    return {
      back: F,
      endOfFile: ze,
      nextToken: Oe,
      position: Xe
    };
  }, Et;
}
var Dt, ar;
function ci() {
  if (ar) return Dt;
  ar = 1;
  let u = Kt(), d = je(), l = _e(), x = Te(), v = Yt(), b = oi();
  const g = {
    empty: !0,
    space: !0
  };
  function a(e) {
    for (let t = e.length - 1; t >= 0; t--) {
      let n = e[t], r = n[3] || n[2];
      if (r) return r;
    }
  }
  class c {
    constructor(t) {
      this.input = t, this.root = new x(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: t, start: { column: 1, line: 1, offset: 0 } };
    }
    atrule(t) {
      let n = new u();
      n.name = t[1].slice(1), n.name === "" && this.unnamedAtrule(n, t), this.init(n, t[2]);
      let r, i, A, y = !1, w = !1, s = [], f = [];
      for (; !this.tokenizer.endOfFile(); ) {
        if (t = this.tokenizer.nextToken(), r = t[0], r === "(" || r === "[" ? f.push(r === "(" ? ")" : "]") : r === "{" && f.length > 0 ? f.push("}") : r === f[f.length - 1] && f.pop(), f.length === 0)
          if (r === ";") {
            n.source.end = this.getPosition(t[2]), n.source.end.offset++, this.semicolon = !0;
            break;
          } else if (r === "{") {
            w = !0;
            break;
          } else if (r === "}") {
            if (s.length > 0) {
              for (A = s.length - 1, i = s[A]; i && i[0] === "space"; )
                i = s[--A];
              i && (n.source.end = this.getPosition(i[3] || i[2]), n.source.end.offset++);
            }
            this.end(t);
            break;
          } else
            s.push(t);
        else
          s.push(t);
        if (this.tokenizer.endOfFile()) {
          y = !0;
          break;
        }
      }
      n.raws.between = this.spacesAndCommentsFromEnd(s), s.length ? (n.raws.afterName = this.spacesAndCommentsFromStart(s), this.raw(n, "params", s), y && (t = s[s.length - 1], n.source.end = this.getPosition(t[3] || t[2]), n.source.end.offset++, this.spaces = n.raws.between, n.raws.between = "")) : (n.raws.afterName = "", n.params = ""), w && (n.nodes = [], this.current = n);
    }
    checkMissedSemicolon(t) {
      let n = this.colon(t);
      if (n === !1) return;
      let r = 0, i;
      for (let A = n - 1; A >= 0 && (i = t[A], !(i[0] !== "space" && (r += 1, r === 2))); A--)
        ;
      throw this.input.error(
        "Missed semicolon",
        i[0] === "word" ? i[3] + 1 : i[2]
      );
    }
    colon(t) {
      let n = 0, r, i, A;
      for (let [y, w] of t.entries()) {
        if (i = w, A = i[0], A === "(" && (n += 1), A === ")" && (n -= 1), n === 0 && A === ":")
          if (!r)
            this.doubleColon(i);
          else {
            if (r[0] === "word" && r[1] === "progid")
              continue;
            return y;
          }
        r = i;
      }
      return !1;
    }
    comment(t) {
      let n = new d();
      this.init(n, t[2]), n.source.end = this.getPosition(t[3] || t[2]), n.source.end.offset++;
      let r = t[1].slice(2, -2);
      if (!r.trim())
        n.text = "", n.raws.left = r, n.raws.right = "";
      else {
        let i = r.match(/^(\s*)([^]*\S)(\s*)$/);
        n.text = i[2], n.raws.left = i[1], n.raws.right = i[3];
      }
    }
    createTokenizer() {
      this.tokenizer = b(this.input);
    }
    decl(t, n) {
      let r = new l();
      this.init(r, t[0][2]);
      let i = t[t.length - 1];
      for (i[0] === ";" && (this.semicolon = !0, t.pop()), r.source.end = this.getPosition(
        i[3] || i[2] || a(t)
      ), r.source.end.offset++; t[0][0] !== "word"; )
        t.length === 1 && this.unknownWord(t), r.raws.before += t.shift()[1];
      for (r.source.start = this.getPosition(t[0][2]), r.prop = ""; t.length; ) {
        let f = t[0][0];
        if (f === ":" || f === "space" || f === "comment")
          break;
        r.prop += t.shift()[1];
      }
      r.raws.between = "";
      let A;
      for (; t.length; )
        if (A = t.shift(), A[0] === ":") {
          r.raws.between += A[1];
          break;
        } else
          A[0] === "word" && /\w/.test(A[1]) && this.unknownWord([A]), r.raws.between += A[1];
      (r.prop[0] === "_" || r.prop[0] === "*") && (r.raws.before += r.prop[0], r.prop = r.prop.slice(1));
      let y = [], w;
      for (; t.length && (w = t[0][0], !(w !== "space" && w !== "comment")); )
        y.push(t.shift());
      this.precheckMissedSemicolon(t);
      for (let f = t.length - 1; f >= 0; f--) {
        if (A = t[f], A[1].toLowerCase() === "!important") {
          r.important = !0;
          let h = this.stringFrom(t, f);
          h = this.spacesFromEnd(t) + h, h !== " !important" && (r.raws.important = h);
          break;
        } else if (A[1].toLowerCase() === "important") {
          let h = t.slice(0), m = "";
          for (let o = f; o > 0; o--) {
            let p = h[o][0];
            if (m.trim().startsWith("!") && p !== "space")
              break;
            m = h.pop()[1] + m;
          }
          m.trim().startsWith("!") && (r.important = !0, r.raws.important = m, t = h);
        }
        if (A[0] !== "space" && A[0] !== "comment")
          break;
      }
      t.some((f) => f[0] !== "space" && f[0] !== "comment") && (r.raws.between += y.map((f) => f[1]).join(""), y = []), this.raw(r, "value", y.concat(t), n), r.value.includes(":") && !n && this.checkMissedSemicolon(t);
    }
    doubleColon(t) {
      throw this.input.error(
        "Double colon",
        { offset: t[2] },
        { offset: t[2] + t[1].length }
      );
    }
    emptyRule(t) {
      let n = new v();
      this.init(n, t[2]), n.selector = "", n.raws.between = "", this.current = n;
    }
    end(t) {
      this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(t[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(t);
    }
    endFile() {
      this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(t) {
      if (this.spaces += t[1], this.current.nodes) {
        let n = this.current.nodes[this.current.nodes.length - 1];
        n && n.type === "rule" && !n.raws.ownSemicolon && (n.raws.ownSemicolon = this.spaces, this.spaces = "", n.source.end = this.getPosition(t[2]), n.source.end.offset += n.raws.ownSemicolon.length);
      }
    }
    // Helpers
    getPosition(t) {
      let n = this.input.fromOffset(t);
      return {
        column: n.col,
        line: n.line,
        offset: t
      };
    }
    init(t, n) {
      this.current.push(t), t.source = {
        input: this.input,
        start: this.getPosition(n)
      }, t.raws.before = this.spaces, this.spaces = "", t.type !== "comment" && (this.semicolon = !1);
    }
    other(t) {
      let n = !1, r = null, i = !1, A = null, y = [], w = t[1].startsWith("--"), s = [], f = t;
      for (; f; ) {
        if (r = f[0], s.push(f), r === "(" || r === "[")
          A || (A = f), y.push(r === "(" ? ")" : "]");
        else if (w && i && r === "{")
          A || (A = f), y.push("}");
        else if (y.length === 0)
          if (r === ";")
            if (i) {
              this.decl(s, w);
              return;
            } else
              break;
          else if (r === "{") {
            this.rule(s);
            return;
          } else if (r === "}") {
            this.tokenizer.back(s.pop()), n = !0;
            break;
          } else r === ":" && (i = !0);
        else r === y[y.length - 1] && (y.pop(), y.length === 0 && (A = null));
        f = this.tokenizer.nextToken();
      }
      if (this.tokenizer.endOfFile() && (n = !0), y.length > 0 && this.unclosedBracket(A), n && i) {
        if (!w)
          for (; s.length && (f = s[s.length - 1][0], !(f !== "space" && f !== "comment")); )
            this.tokenizer.back(s.pop());
        this.decl(s, w);
      } else
        this.unknownWord(s);
    }
    parse() {
      let t;
      for (; !this.tokenizer.endOfFile(); )
        switch (t = this.tokenizer.nextToken(), t[0]) {
          case "space":
            this.spaces += t[1];
            break;
          case ";":
            this.freeSemicolon(t);
            break;
          case "}":
            this.end(t);
            break;
          case "comment":
            this.comment(t);
            break;
          case "at-word":
            this.atrule(t);
            break;
          case "{":
            this.emptyRule(t);
            break;
          default:
            this.other(t);
            break;
        }
      this.endFile();
    }
    precheckMissedSemicolon() {
    }
    raw(t, n, r, i) {
      let A, y, w = r.length, s = "", f = !0, h, m;
      for (let o = 0; o < w; o += 1)
        A = r[o], y = A[0], y === "space" && o === w - 1 && !i ? f = !1 : y === "comment" ? (m = r[o - 1] ? r[o - 1][0] : "empty", h = r[o + 1] ? r[o + 1][0] : "empty", !g[m] && !g[h] ? s.slice(-1) === "," ? f = !1 : s += A[1] : f = !1) : s += A[1];
      if (!f) {
        let o = r.reduce((p, C) => p + C[1], "");
        t.raws[n] = { raw: o, value: s };
      }
      t[n] = s;
    }
    rule(t) {
      t.pop();
      let n = new v();
      this.init(n, t[0][2]), n.raws.between = this.spacesAndCommentsFromEnd(t), this.raw(n, "selector", t), this.current = n;
    }
    spacesAndCommentsFromEnd(t) {
      let n, r = "";
      for (; t.length && (n = t[t.length - 1][0], !(n !== "space" && n !== "comment")); )
        r = t.pop()[1] + r;
      return r;
    }
    // Errors
    spacesAndCommentsFromStart(t) {
      let n, r = "";
      for (; t.length && (n = t[0][0], !(n !== "space" && n !== "comment")); )
        r += t.shift()[1];
      return r;
    }
    spacesFromEnd(t) {
      let n, r = "";
      for (; t.length && (n = t[t.length - 1][0], n === "space"); )
        r = t.pop()[1] + r;
      return r;
    }
    stringFrom(t, n) {
      let r = "";
      for (let i = n; i < t.length; i++)
        r += t[i][1];
      return t.splice(n, t.length - n), r;
    }
    unclosedBlock() {
      let t = this.current.source.start;
      throw this.input.error("Unclosed block", t.line, t.column);
    }
    unclosedBracket(t) {
      throw this.input.error(
        "Unclosed bracket",
        { offset: t[2] },
        { offset: t[2] + 1 }
      );
    }
    unexpectedClose(t) {
      throw this.input.error(
        "Unexpected }",
        { offset: t[2] },
        { offset: t[2] + 1 }
      );
    }
    unknownWord(t) {
      throw this.input.error(
        "Unknown word " + t[0][1],
        { offset: t[0][2] },
        { offset: t[0][2] + t[0][1].length }
      );
    }
    unnamedAtrule(t, n) {
      throw this.input.error(
        "At-rule without name",
        { offset: n[2] },
        { offset: n[2] + n[1].length }
      );
    }
  }
  return Dt = c, Dt;
}
var St, sr;
function Jt() {
  if (sr) return St;
  sr = 1;
  let u = we(), d = Ve(), l = ci();
  function x(v, b) {
    let g = new d(v, b), a = new l(g);
    try {
      a.parse();
    } catch (c) {
      throw process.env.NODE_ENV !== "production" && c.name === "CssSyntaxError" && b && b.from && (/\.scss$/i.test(b.from) ? c.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(b.from) ? c.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(b.from) && (c.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), c;
    }
    return a.root;
  }
  return St = x, x.default = x, u.registerParse(x), St;
}
var Nt, or;
function Dr() {
  if (or) return Nt;
  or = 1;
  class u {
    constructor(l, x = {}) {
      if (this.type = "warning", this.text = l, x.node && x.node.source) {
        let v = x.node.rangeBy(x);
        this.line = v.start.line, this.column = v.start.column, this.endLine = v.end.line, this.endColumn = v.end.column;
      }
      for (let v in x) this[v] = x[v];
    }
    toString() {
      return this.node ? this.node.error(this.text, {
        index: this.index,
        plugin: this.plugin,
        word: this.word
      }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
    }
  }
  return Nt = u, u.default = u, Nt;
}
var Rt, cr;
function Zt() {
  if (cr) return Rt;
  cr = 1;
  let u = Dr();
  class d {
    get content() {
      return this.css;
    }
    constructor(x, v, b) {
      this.processor = x, this.messages = [], this.root = v, this.opts = b, this.css = "", this.map = void 0;
    }
    toString() {
      return this.css;
    }
    warn(x, v = {}) {
      v.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (v.plugin = this.lastPlugin.postcssPlugin);
      let b = new u(x, v);
      return this.messages.push(b), b;
    }
    warnings() {
      return this.messages.filter((x) => x.type === "warning");
    }
  }
  return Rt = d, d.default = d, Rt;
}
var Ft, lr;
function Sr() {
  if (lr) return Ft;
  lr = 1;
  let u = {};
  return Ft = function(l) {
    u[l] || (u[l] = !0, typeof console < "u" && console.warn && console.warn(l));
  }, Ft;
}
var Tt, Ar;
function Nr() {
  if (Ar) return Tt;
  Ar = 1;
  let u = we(), d = Pt(), l = Er(), x = Jt(), v = Zt(), b = Te(), g = Je(), { isClean: a, my: c } = Wt(), e = Sr();
  const t = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
  }, n = {
    AtRule: !0,
    AtRuleExit: !0,
    Comment: !0,
    CommentExit: !0,
    Declaration: !0,
    DeclarationExit: !0,
    Document: !0,
    DocumentExit: !0,
    Once: !0,
    OnceExit: !0,
    postcssPlugin: !0,
    prepare: !0,
    Root: !0,
    RootExit: !0,
    Rule: !0,
    RuleExit: !0
  }, r = {
    Once: !0,
    postcssPlugin: !0,
    prepare: !0
  }, i = 0;
  function A(m) {
    return typeof m == "object" && typeof m.then == "function";
  }
  function y(m) {
    let o = !1, p = t[m.type];
    return m.type === "decl" ? o = m.prop.toLowerCase() : m.type === "atrule" && (o = m.name.toLowerCase()), o && m.append ? [
      p,
      p + "-" + o,
      i,
      p + "Exit",
      p + "Exit-" + o
    ] : o ? [p, p + "-" + o, p + "Exit", p + "Exit-" + o] : m.append ? [p, i, p + "Exit"] : [p, p + "Exit"];
  }
  function w(m) {
    let o;
    return m.type === "document" ? o = ["Document", i, "DocumentExit"] : m.type === "root" ? o = ["Root", i, "RootExit"] : o = y(m), {
      eventIndex: 0,
      events: o,
      iterator: 0,
      node: m,
      visitorIndex: 0,
      visitors: []
    };
  }
  function s(m) {
    return m[a] = !1, m.nodes && m.nodes.forEach((o) => s(o)), m;
  }
  let f = {};
  class h {
    get content() {
      return this.stringify().content;
    }
    get css() {
      return this.stringify().css;
    }
    get map() {
      return this.stringify().map;
    }
    get messages() {
      return this.sync().messages;
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      return this.sync().root;
    }
    get [Symbol.toStringTag]() {
      return "LazyResult";
    }
    constructor(o, p, C) {
      this.stringified = !1, this.processed = !1;
      let D;
      if (typeof p == "object" && p !== null && (p.type === "root" || p.type === "document"))
        D = s(p);
      else if (p instanceof h || p instanceof v)
        D = s(p.root), p.map && (typeof C.map > "u" && (C.map = {}), C.map.inline || (C.map.inline = !1), C.map.prev = p.map);
      else {
        let B = x;
        C.syntax && (B = C.syntax.parse), C.parser && (B = C.parser), B.parse && (B = B.parse);
        try {
          D = B(p, C);
        } catch (S) {
          this.processed = !0, this.error = S;
        }
        D && !D[c] && u.rebuild(D);
      }
      this.result = new v(o, D, C), this.helpers = { ...f, postcss: f, result: this.result }, this.plugins = this.processor.plugins.map((B) => typeof B == "object" && B.prepare ? { ...B, ...B.prepare(this.result) } : B);
    }
    async() {
      return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
    }
    catch(o) {
      return this.async().catch(o);
    }
    finally(o) {
      return this.async().then(o, o);
    }
    getAsyncError() {
      throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(o, p) {
      let C = this.result.lastPlugin;
      try {
        if (p && p.addToError(o), this.error = o, o.name === "CssSyntaxError" && !o.plugin)
          o.plugin = C.postcssPlugin, o.setMessage();
        else if (C.postcssVersion && process.env.NODE_ENV !== "production") {
          let D = C.postcssPlugin, B = C.postcssVersion, S = this.result.processor.version, I = B.split("."), E = S.split(".");
          (I[0] !== E[0] || parseInt(I[1]) > parseInt(E[1])) && console.error(
            "Unknown error from PostCSS plugin. Your current PostCSS version is " + S + ", but " + D + " uses " + B + ". Perhaps this is the source of the error below."
          );
        }
      } catch (D) {
        console && console.error && console.error(D);
      }
      return o;
    }
    prepareVisitors() {
      this.listeners = {};
      let o = (p, C, D) => {
        this.listeners[C] || (this.listeners[C] = []), this.listeners[C].push([p, D]);
      };
      for (let p of this.plugins)
        if (typeof p == "object")
          for (let C in p) {
            if (!n[C] && /^[A-Z]/.test(C))
              throw new Error(
                `Unknown event ${C} in ${p.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
              );
            if (!r[C])
              if (typeof p[C] == "object")
                for (let D in p[C])
                  D === "*" ? o(p, C, p[C][D]) : o(
                    p,
                    C + "-" + D.toLowerCase(),
                    p[C][D]
                  );
              else typeof p[C] == "function" && o(p, C, p[C]);
          }
      this.hasListener = Object.keys(this.listeners).length > 0;
    }
    async runAsync() {
      this.plugin = 0;
      for (let o = 0; o < this.plugins.length; o++) {
        let p = this.plugins[o], C = this.runOnRoot(p);
        if (A(C))
          try {
            await C;
          } catch (D) {
            throw this.handleError(D);
          }
      }
      if (this.prepareVisitors(), this.hasListener) {
        let o = this.result.root;
        for (; !o[a]; ) {
          o[a] = !0;
          let p = [w(o)];
          for (; p.length > 0; ) {
            let C = this.visitTick(p);
            if (A(C))
              try {
                await C;
              } catch (D) {
                let B = p[p.length - 1].node;
                throw this.handleError(D, B);
              }
          }
        }
        if (this.listeners.OnceExit)
          for (let [p, C] of this.listeners.OnceExit) {
            this.result.lastPlugin = p;
            try {
              if (o.type === "document") {
                let D = o.nodes.map(
                  (B) => C(B, this.helpers)
                );
                await Promise.all(D);
              } else
                await C(o, this.helpers);
            } catch (D) {
              throw this.handleError(D);
            }
          }
      }
      return this.processed = !0, this.stringify();
    }
    runOnRoot(o) {
      this.result.lastPlugin = o;
      try {
        if (typeof o == "object" && o.Once) {
          if (this.result.root.type === "document") {
            let p = this.result.root.nodes.map(
              (C) => o.Once(C, this.helpers)
            );
            return A(p[0]) ? Promise.all(p) : p;
          }
          return o.Once(this.result.root, this.helpers);
        } else if (typeof o == "function")
          return o(this.result.root, this.result);
      } catch (p) {
        throw this.handleError(p);
      }
    }
    stringify() {
      if (this.error) throw this.error;
      if (this.stringified) return this.result;
      this.stringified = !0, this.sync();
      let o = this.result.opts, p = g;
      o.syntax && (p = o.syntax.stringify), o.stringifier && (p = o.stringifier), p.stringify && (p = p.stringify);
      let C = this.result.root.source;
      if (o.map === void 0 && !(C && C.input && C.input.map)) {
        let S = "";
        return p(this.result.root, (I) => {
          S += I;
        }), this.result.css = S, this.result;
      }
      let B = new l(p, this.result.root, this.result.opts).generate();
      return this.result.css = B[0], this.result.map = B[1], this.result;
    }
    sync() {
      if (this.error) throw this.error;
      if (this.processed) return this.result;
      if (this.processed = !0, this.processing)
        throw this.getAsyncError();
      for (let o of this.plugins) {
        let p = this.runOnRoot(o);
        if (A(p))
          throw this.getAsyncError();
      }
      if (this.prepareVisitors(), this.hasListener) {
        let o = this.result.root;
        for (; !o[a]; )
          o[a] = !0, this.walkSync(o);
        if (this.listeners.OnceExit)
          if (o.type === "document")
            for (let p of o.nodes)
              this.visitSync(this.listeners.OnceExit, p);
          else
            this.visitSync(this.listeners.OnceExit, o);
      }
      return this.result;
    }
    then(o, p) {
      return process.env.NODE_ENV !== "production" && ("from" in this.opts || e(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(o, p);
    }
    toString() {
      return this.css;
    }
    visitSync(o, p) {
      for (let [C, D] of o) {
        this.result.lastPlugin = C;
        let B;
        try {
          B = D(p, this.helpers);
        } catch (S) {
          throw this.handleError(S, p.proxyOf);
        }
        if (p.type !== "root" && p.type !== "document" && !p.parent)
          return !0;
        if (A(B))
          throw this.getAsyncError();
      }
    }
    visitTick(o) {
      let p = o[o.length - 1], { node: C, visitors: D } = p;
      if (C.type !== "root" && C.type !== "document" && !C.parent) {
        o.pop();
        return;
      }
      if (D.length > 0 && p.visitorIndex < D.length) {
        let [S, I] = D[p.visitorIndex];
        p.visitorIndex += 1, p.visitorIndex === D.length && (p.visitors = [], p.visitorIndex = 0), this.result.lastPlugin = S;
        try {
          return I(C.toProxy(), this.helpers);
        } catch (E) {
          throw this.handleError(E, C);
        }
      }
      if (p.iterator !== 0) {
        let S = p.iterator, I;
        for (; I = C.nodes[C.indexes[S]]; )
          if (C.indexes[S] += 1, !I[a]) {
            I[a] = !0, o.push(w(I));
            return;
          }
        p.iterator = 0, delete C.indexes[S];
      }
      let B = p.events;
      for (; p.eventIndex < B.length; ) {
        let S = B[p.eventIndex];
        if (p.eventIndex += 1, S === i) {
          C.nodes && C.nodes.length && (C[a] = !0, p.iterator = C.getIterator());
          return;
        } else if (this.listeners[S]) {
          p.visitors = this.listeners[S];
          return;
        }
      }
      o.pop();
    }
    walkSync(o) {
      o[a] = !0;
      let p = y(o);
      for (let C of p)
        if (C === i)
          o.nodes && o.each((D) => {
            D[a] || this.walkSync(D);
          });
        else {
          let D = this.listeners[C];
          if (D && this.visitSync(D, o.toProxy()))
            return;
        }
    }
    warnings() {
      return this.sync().warnings();
    }
  }
  return h.registerPostcss = (m) => {
    f = m;
  }, Tt = h, h.default = h, b.registerLazyResult(h), d.registerLazyResult(h), Tt;
}
var kt, dr;
function li() {
  if (dr) return kt;
  dr = 1;
  let u = Er(), d = Jt(), l = Zt(), x = Je(), v = Sr();
  class b {
    get content() {
      return this.result.css;
    }
    get css() {
      return this.result.css;
    }
    get map() {
      return this.result.map;
    }
    get messages() {
      return [];
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      if (this._root)
        return this._root;
      let a, c = d;
      try {
        a = c(this._css, this._opts);
      } catch (e) {
        this.error = e;
      }
      if (this.error)
        throw this.error;
      return this._root = a, a;
    }
    get [Symbol.toStringTag]() {
      return "NoWorkResult";
    }
    constructor(a, c, e) {
      c = c.toString(), this.stringified = !1, this._processor = a, this._css = c, this._opts = e, this._map = void 0;
      let t = x;
      this.result = new l(this._processor, void 0, this._opts), this.result.css = c;
      let n = this;
      Object.defineProperty(this.result, "root", {
        get() {
          return n.root;
        }
      });
      let r = new u(t, void 0, this._opts, c);
      if (r.isMap()) {
        let [i, A] = r.generate();
        i && (this.result.css = i), A && (this.result.map = A);
      } else
        r.clearAnnotation(), this.result.css = r.css;
    }
    async() {
      return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
    }
    catch(a) {
      return this.async().catch(a);
    }
    finally(a) {
      return this.async().then(a, a);
    }
    sync() {
      if (this.error) throw this.error;
      return this.result;
    }
    then(a, c) {
      return process.env.NODE_ENV !== "production" && ("from" in this._opts || v(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(a, c);
    }
    toString() {
      return this._css;
    }
    warnings() {
      return [];
    }
  }
  return kt = b, b.default = b, kt;
}
var Ot, fr;
function Ai() {
  if (fr) return Ot;
  fr = 1;
  let u = Pt(), d = Nr(), l = li(), x = Te();
  class v {
    constructor(g = []) {
      this.version = "8.5.14", this.plugins = this.normalize(g);
    }
    normalize(g) {
      let a = [];
      for (let c of g)
        if (c.postcss === !0 ? c = c() : c.postcss && (c = c.postcss), typeof c == "object" && Array.isArray(c.plugins))
          a = a.concat(c.plugins);
        else if (typeof c == "object" && c.postcssPlugin)
          a.push(c);
        else if (typeof c == "function")
          a.push(c);
        else if (typeof c == "object" && (c.parse || c.stringify)) {
          if (process.env.NODE_ENV !== "production")
            throw new Error(
              "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
            );
        } else
          throw new Error(c + " is not a PostCSS plugin");
      return a;
    }
    process(g, a = {}) {
      return !this.plugins.length && !a.parser && !a.stringifier && !a.syntax ? new l(this, g, a) : new d(this, g, a);
    }
    use(g) {
      return this.plugins = this.plugins.concat(this.normalize([g])), this;
    }
  }
  return Ot = v, v.default = v, x.registerProcessor(v), u.registerProcessor(v), Ot;
}
var qt, hr;
function di() {
  if (hr) return qt;
  hr = 1;
  let u = Kt(), d = je(), l = we(), x = Ut(), v = _e(), b = Pt(), g = si(), a = Ve(), c = Nr(), e = Br(), t = Ze(), n = Jt(), r = Ai(), i = Zt(), A = Te(), y = Yt(), w = Je(), s = Dr();
  function f(...h) {
    return h.length === 1 && Array.isArray(h[0]) && (h = h[0]), new r(h);
  }
  return f.plugin = function(m, o) {
    let p = !1;
    function C(...B) {
      console && console.warn && !p && (p = !0, console.warn(
        m + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
      ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
        m + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
      ));
      let S = o(...B);
      return S.postcssPlugin = m, S.postcssVersion = new r().version, S;
    }
    let D;
    return Object.defineProperty(C, "postcss", {
      get() {
        return D || (D = C()), D;
      }
    }), C.process = function(B, S, I) {
      return f([C(I)]).process(B, S);
    }, C;
  }, f.stringify = w, f.parse = n, f.fromJSON = g, f.list = e, f.comment = (h) => new d(h), f.atRule = (h) => new u(h), f.decl = (h) => new v(h), f.rule = (h) => new y(h), f.root = (h) => new A(h), f.document = (h) => new b(h), f.CssSyntaxError = x, f.Declaration = v, f.Container = l, f.Processor = r, f.Document = b, f.Comment = d, f.Warning = s, f.AtRule = u, f.Result = i, f.Input = a, f.Rule = y, f.Root = A, f.Node = t, c.registerPostcss(f), qt = f, f.default = f, qt;
}
var Qt, gr;
function fi() {
  if (gr) return Qt;
  gr = 1;
  const u = /* @__PURE__ */ Xr(), d = zr(), { isPlainObject: l } = $r(), x = ei(), v = ui(), { parse: b } = di(), g = [
    "img",
    "audio",
    "video",
    "picture",
    "svg",
    "object",
    "map",
    "iframe",
    "embed"
  ], a = ["script", "style"];
  function c(w, s) {
    w && Object.keys(w).forEach(function(f) {
      s(w[f], f);
    });
  }
  function e(w, s) {
    return {}.hasOwnProperty.call(w, s);
  }
  function t(w, s) {
    const f = [];
    return c(w, function(h) {
      s(h) && f.push(h);
    }), f;
  }
  function n(w) {
    for (const s in w)
      if (e(w, s))
        return !1;
    return !0;
  }
  function r(w) {
    return w.map(function(s) {
      if (!s.url)
        throw new Error("URL missing");
      return s.url + (s.w ? ` ${s.w}w` : "") + (s.h ? ` ${s.h}h` : "") + (s.d ? ` ${s.d}x` : "");
    }).join(", ");
  }
  Qt = A;
  const i = /^[^\0\t\n\f\r /<=>]+$/;
  function A(w, s, f) {
    if (w == null)
      return "";
    typeof w == "number" && (w = w.toString());
    let h = "", m = "";
    function o(F, O) {
      const T = this;
      this.tag = F, this.attribs = O || {}, this.tagPosition = h.length, this.text = "", this.openingTagLength = 0, this.mediaChildren = [], this.updateParentNodeText = function() {
        if (q.length) {
          const H = q[q.length - 1];
          H.text += T.text;
        }
      }, this.updateParentNodeMediaChildren = function() {
        q.length && g.includes(this.tag) && q[q.length - 1].mediaChildren.push(this.tag);
      };
    }
    s = Object.assign({}, A.defaults, s), s.parser = Object.assign({}, y, s.parser);
    const p = function(F) {
      return s.allowedTags === !1 || (s.allowedTags || []).indexOf(F) > -1;
    };
    a.forEach(function(F) {
      p(F) && !s.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${F}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
    });
    const C = s.nonTextTags || [
      "script",
      "style",
      "textarea",
      "option"
    ];
    let D, B;
    s.allowedAttributes && (D = {}, B = {}, c(s.allowedAttributes, function(F, O) {
      D[O] = [];
      const T = [];
      F.forEach(function(H) {
        typeof H == "string" && H.indexOf("*") >= 0 ? T.push(d(H).replace(/\\\*/g, ".*")) : D[O].push(H);
      }), T.length && (B[O] = new RegExp("^(" + T.join("|") + ")$"));
    }));
    const S = {}, I = {}, E = {};
    c(s.allowedClasses, function(F, O) {
      if (D && (e(D, O) || (D[O] = []), D[O].push("class")), S[O] = F, Array.isArray(F)) {
        const T = [];
        S[O] = [], E[O] = [], F.forEach(function(H) {
          typeof H == "string" && H.indexOf("*") >= 0 ? T.push(d(H).replace(/\\\*/g, ".*")) : H instanceof RegExp ? E[O].push(H) : S[O].push(H);
        }), T.length && (I[O] = new RegExp("^(" + T.join("|") + ")$"));
      }
    });
    const R = {};
    let k;
    c(s.transformTags, function(F, O) {
      let T;
      typeof F == "function" ? T = F : typeof F == "string" && (T = A.simpleTransform(F)), O === "*" ? k = T : R[O] = T;
    });
    let N, q, M, G, J, Z, z = !1;
    Q();
    const he = new u.Parser({
      onopentag: function(F, O) {
        if (s.onOpenTag && s.onOpenTag(F, O), s.enforceHtmlBoundary && F === "html" && Q(), J) {
          Z++;
          return;
        }
        const T = new o(F, O);
        q.push(T);
        let H = !1;
        const j = !!T.text;
        let V;
        if (e(R, F) && (V = R[F](F, O), T.attribs = O = V.attribs, V.text !== void 0 && (T.innerText = V.text), F !== V.tagName && (T.name = F = V.tagName, G[N] = V.tagName)), k && (V = k(F, O), T.attribs = O = V.attribs, F !== V.tagName && (T.name = F = V.tagName, G[N] = V.tagName)), (!p(F) || s.disallowedTagsMode === "recursiveEscape" && !n(M) || s.nestingLimit != null && N >= s.nestingLimit) && (H = !0, M[N] = !0, (s.disallowedTagsMode === "discard" || s.disallowedTagsMode === "completelyDiscard") && C.indexOf(F) !== -1 && (J = !0, Z = 1)), N++, H) {
          if (s.disallowedTagsMode === "discard" || s.disallowedTagsMode === "completelyDiscard") {
            if (T.innerText && !j) {
              const Y = $(T.innerText);
              s.textFilter ? h += s.textFilter(Y, F) : h += Y, z = !0;
            }
            return;
          }
          m = h, h = "";
        }
        h += "<" + F, F === "script" && (s.allowedScriptHostnames || s.allowedScriptDomains) && (T.innerText = ""), H && (s.disallowedTagsMode === "escape" || s.disallowedTagsMode === "recursiveEscape") && s.preserveEscapedAttributes ? c(O, function(Y, W) {
          h += " " + W + '="' + $(Y || "", !0) + '"';
        }) : (!D || e(D, F) || D["*"]) && c(O, function(Y, W) {
          if (!i.test(W)) {
            delete T.attribs[W];
            return;
          }
          if (Y === "" && !s.allowedEmptyAttributes.includes(W) && (s.nonBooleanAttributes.includes(W) || s.nonBooleanAttributes.includes("*"))) {
            delete T.attribs[W];
            return;
          }
          let $e = !1;
          if (!D || e(D, F) && D[F].indexOf(W) !== -1 || D["*"] && D["*"].indexOf(W) !== -1 || e(B, F) && B[F].test(W) || B["*"] && B["*"].test(W))
            $e = !0;
          else if (D && D[F]) {
            for (const K of D[F])
              if (l(K) && K.name && K.name === W) {
                $e = !0;
                let P = "";
                if (K.multiple === !0) {
                  const be = Y.split(" ");
                  for (const se of be)
                    K.values.indexOf(se) !== -1 && (P === "" ? P = se : P += " " + se);
                } else K.values.indexOf(Y) >= 0 && (P = Y);
                Y = P;
              }
          }
          if ($e) {
            if (s.allowedSchemesAppliedToAttributes.indexOf(W) !== -1 && ge(F, Y)) {
              delete T.attribs[W];
              return;
            }
            if (F === "script" && W === "src") {
              let K = !0;
              try {
                const P = Ee(Y);
                if (s.allowedScriptHostnames || s.allowedScriptDomains) {
                  const be = (s.allowedScriptHostnames || []).find(function(ee) {
                    return ee === P.url.hostname;
                  }), se = (s.allowedScriptDomains || []).find(function(ee) {
                    return P.url.hostname === ee || P.url.hostname.endsWith(`.${ee}`);
                  });
                  K = be || se;
                }
              } catch {
                K = !1;
              }
              if (!K) {
                delete T.attribs[W];
                return;
              }
            }
            if (F === "iframe" && W === "src") {
              let K = !0;
              try {
                const P = Ee(Y);
                if (P.isRelativeUrl)
                  K = e(s, "allowIframeRelativeUrls") ? s.allowIframeRelativeUrls : !s.allowedIframeHostnames && !s.allowedIframeDomains;
                else if (s.allowedIframeHostnames || s.allowedIframeDomains) {
                  const be = (s.allowedIframeHostnames || []).find(function(ee) {
                    return ee === P.url.hostname;
                  }), se = (s.allowedIframeDomains || []).find(function(ee) {
                    return P.url.hostname === ee || P.url.hostname.endsWith(`.${ee}`);
                  });
                  K = be || se;
                }
              } catch {
                K = !1;
              }
              if (!K) {
                delete T.attribs[W];
                return;
              }
            }
            if (W === "srcset")
              try {
                let K = v(Y);
                if (K.forEach(function(P) {
                  ge("srcset", P.url) && (P.evil = !0);
                }), K = t(K, function(P) {
                  return !P.evil;
                }), K.length)
                  Y = r(t(K, function(P) {
                    return !P.evil;
                  })), T.attribs[W] = Y;
                else {
                  delete T.attribs[W];
                  return;
                }
              } catch {
                delete T.attribs[W];
                return;
              }
            if (W === "class") {
              const K = S[F], P = S["*"], be = I[F], se = E[F], ee = E["*"], qr = I["*"], Vt = [
                be,
                qr
              ].concat(se, ee).filter(function(Qr) {
                return Qr;
              });
              if (K && P ? Y = Oe(
                Y,
                x(K, P),
                Vt
              ) : Y = Oe(
                Y,
                K || P,
                Vt
              ), !Y.length) {
                delete T.attribs[W];
                return;
              }
            }
            if (W === "style") {
              if (s.parseStyleAttributes)
                try {
                  const K = b(F + " {" + Y + "}", { map: !1 }), P = Xe(
                    K,
                    s.allowedStyles
                  );
                  if (Y = De(P), Y.length === 0) {
                    delete T.attribs[W];
                    return;
                  }
                } catch {
                  typeof window < "u" && console.warn('Failed to parse "' + F + " {" + Y + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), delete T.attribs[W];
                  return;
                }
              else if (s.allowedStyles)
                throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
            }
            h += " " + W, Y && Y.length ? h += '="' + $(Y, !0) + '"' : s.allowedEmptyAttributes.includes(W) && (h += '=""');
          } else
            delete T.attribs[W];
        }), s.selfClosing.indexOf(F) !== -1 ? h += " />" : (h += ">", T.innerText && !j && !s.textFilter && (h += $(T.innerText), z = !0)), H && (h = m + $(h), m = ""), T.openingTagLength = h.length - T.tagPosition;
      },
      ontext: function(F) {
        if (J)
          return;
        const O = q[q.length - 1];
        let T;
        if (O && (T = O.tag, F = O.innerText !== void 0 ? O.innerText : F), s.disallowedTagsMode === "completelyDiscard" && !p(T))
          F = "";
        else if ((s.disallowedTagsMode === "discard" || s.disallowedTagsMode === "completelyDiscard") && (T === "script" || T === "style"))
          h += F;
        else if ((s.disallowedTagsMode === "discard" || s.disallowedTagsMode === "completelyDiscard") && (T === "textarea" || T === "xmp"))
          h += F;
        else if (!z) {
          const H = $(F, !1);
          s.textFilter ? h += s.textFilter(H, T) : h += H;
        }
        if (q.length) {
          const H = q[q.length - 1];
          H.text += F;
        }
      },
      onclosetag: function(F, O) {
        if (s.onCloseTag && s.onCloseTag(F, O), J)
          if (Z--, !Z)
            J = !1;
          else
            return;
        const T = q.pop();
        if (!T)
          return;
        if (T.tag !== F) {
          q.push(T);
          return;
        }
        J = s.enforceHtmlBoundary ? F === "html" : !1, N--;
        const H = M[N];
        if (H) {
          if (delete M[N], s.disallowedTagsMode === "discard" || s.disallowedTagsMode === "completelyDiscard") {
            T.updateParentNodeText();
            return;
          }
          m = h, h = "";
        }
        if (G[N] && (F = G[N], delete G[N]), s.exclusiveFilter) {
          const j = s.exclusiveFilter(T);
          if (j === "excludeTag") {
            H && (h = m, m = ""), h = h.substring(0, T.tagPosition) + h.substring(T.tagPosition + T.openingTagLength);
            return;
          } else if (j) {
            h = h.substring(0, T.tagPosition);
            return;
          }
        }
        if (T.updateParentNodeMediaChildren(), T.updateParentNodeText(), // Already output />
        s.selfClosing.indexOf(F) !== -1 || // Escaped tag, closing tag is implied
        O && !p(F) && ["escape", "recursiveEscape"].indexOf(s.disallowedTagsMode) >= 0) {
          H && (h = m, m = "");
          return;
        }
        h += "</" + F + ">", H && (h = m + $(h), m = ""), z = !1;
      }
    }, s.parser);
    if (he.write(w), he.end(), s.disallowedTagsMode === "escape" || s.disallowedTagsMode === "recursiveEscape") {
      const F = he.endIndex;
      if (F != null && F >= 0 && F < w.length) {
        const O = w.substring(F);
        h += $(O);
      } else (F == null || F < 0) && w.length > 0 && h === "" && (h = $(w));
    }
    return h;
    function Q() {
      h = "", N = 0, q = [], M = {}, G = {}, J = !1, Z = 0;
    }
    function $(F, O) {
      return typeof F != "string" && (F = F + ""), s.parser.decodeEntities && (F = F.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), O && (F = F.replace(/"/g, "&quot;"))), F = F.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), O && (F = F.replace(/"/g, "&quot;")), F;
    }
    function ge(F, O) {
      for (O = O.replace(/[\x00-\x20]+/g, ""); ; ) {
        const j = O.indexOf("<!--");
        if (j === -1)
          break;
        const V = O.indexOf("-->", j + 4);
        if (V === -1)
          break;
        O = O.substring(0, j) + O.substring(V + 3);
      }
      const T = O.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
      if (!T)
        return O.match(/^[/\\]{2}/) ? !s.allowProtocolRelative : !1;
      const H = T[1].toLowerCase();
      return e(s.allowedSchemesByTag, F) ? s.allowedSchemesByTag[F].indexOf(H) === -1 : !s.allowedSchemes || s.allowedSchemes.indexOf(H) === -1;
    }
    function Ee(F) {
      if (F = F.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), F.startsWith("relative:"))
        throw new Error("relative: exploit attempt");
      let O = "relative://relative-site";
      for (let j = 0; j < 100; j++)
        O += `/${j}`;
      const T = new URL(F, O);
      return {
        isRelativeUrl: T && T.hostname === "relative-site" && T.protocol === "relative:",
        url: T
      };
    }
    function Xe(F, O) {
      if (!O)
        return F;
      const T = F.nodes[0];
      let H;
      return O[T.selector] && O["*"] ? H = x(
        O[T.selector],
        O["*"]
      ) : H = O[T.selector] || O["*"], H && (F.nodes[0].nodes = T.nodes.reduce(ze(H), [])), F;
    }
    function De(F) {
      return F.nodes[0].nodes.reduce(function(O, T) {
        return O.push(
          `${T.prop}:${T.value}${T.important ? " !important" : ""}`
        ), O;
      }, []).join(";");
    }
    function ze(F) {
      return function(O, T) {
        return e(F, T.prop) && F[T.prop].some(function(j) {
          return j.test(T.value);
        }) && O.push(T), O;
      };
    }
    function Oe(F, O, T) {
      return O ? (F = F.split(/\s+/), F.filter(function(H) {
        return O.indexOf(H) !== -1 || T.some(function(j) {
          return j.test(H);
        });
      }).join(" ")) : F;
    }
  }
  const y = {
    decodeEntities: !0
  };
  return A.defaults = {
    allowedTags: [
      // Sections derived from MDN element categories and limited to the more
      // benign categories.
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
      // Content sectioning
      "address",
      "article",
      "aside",
      "footer",
      "header",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "hgroup",
      "main",
      "nav",
      "section",
      // Text content
      "blockquote",
      "dd",
      "div",
      "dl",
      "dt",
      "figcaption",
      "figure",
      "hr",
      "li",
      "menu",
      "ol",
      "p",
      "pre",
      "ul",
      // Inline text semantics
      "a",
      "abbr",
      "b",
      "bdi",
      "bdo",
      "br",
      "cite",
      "code",
      "data",
      "dfn",
      "em",
      "i",
      "kbd",
      "mark",
      "q",
      "rb",
      "rp",
      "rt",
      "rtc",
      "ruby",
      "s",
      "samp",
      "small",
      "span",
      "strong",
      "sub",
      "sup",
      "time",
      "u",
      "var",
      "wbr",
      // Table content
      "caption",
      "col",
      "colgroup",
      "table",
      "tbody",
      "td",
      "tfoot",
      "th",
      "thead",
      "tr"
    ],
    // Tags that cannot be boolean
    nonBooleanAttributes: [
      "abbr",
      "accept",
      "accept-charset",
      "accesskey",
      "action",
      "allow",
      "alt",
      "as",
      "autocapitalize",
      "autocomplete",
      "blocking",
      "charset",
      "cite",
      "class",
      "color",
      "cols",
      "colspan",
      "content",
      "contenteditable",
      "coords",
      "crossorigin",
      "data",
      "datetime",
      "decoding",
      "dir",
      "dirname",
      "download",
      "draggable",
      "enctype",
      "enterkeyhint",
      "fetchpriority",
      "for",
      "form",
      "formaction",
      "formenctype",
      "formmethod",
      "formtarget",
      "headers",
      "height",
      "hidden",
      "high",
      "href",
      "hreflang",
      "http-equiv",
      "id",
      "imagesizes",
      "imagesrcset",
      "inputmode",
      "integrity",
      "is",
      "itemid",
      "itemprop",
      "itemref",
      "itemtype",
      "kind",
      "label",
      "lang",
      "list",
      "loading",
      "low",
      "max",
      "maxlength",
      "media",
      "method",
      "min",
      "minlength",
      "name",
      "nonce",
      "optimum",
      "pattern",
      "ping",
      "placeholder",
      "popover",
      "popovertarget",
      "popovertargetaction",
      "poster",
      "preload",
      "referrerpolicy",
      "rel",
      "rows",
      "rowspan",
      "sandbox",
      "scope",
      "shape",
      "size",
      "sizes",
      "slot",
      "span",
      "spellcheck",
      "src",
      "srcdoc",
      "srclang",
      "srcset",
      "start",
      "step",
      "style",
      "tabindex",
      "target",
      "title",
      "translate",
      "type",
      "usemap",
      "value",
      "width",
      "wrap",
      // Event handlers
      "onauxclick",
      "onafterprint",
      "onbeforematch",
      "onbeforeprint",
      "onbeforeunload",
      "onbeforetoggle",
      "onblur",
      "oncancel",
      "oncanplay",
      "oncanplaythrough",
      "onchange",
      "onclick",
      "onclose",
      "oncontextlost",
      "oncontextmenu",
      "oncontextrestored",
      "oncopy",
      "oncuechange",
      "oncut",
      "ondblclick",
      "ondrag",
      "ondragend",
      "ondragenter",
      "ondragleave",
      "ondragover",
      "ondragstart",
      "ondrop",
      "ondurationchange",
      "onemptied",
      "onended",
      "onerror",
      "onfocus",
      "onformdata",
      "onhashchange",
      "oninput",
      "oninvalid",
      "onkeydown",
      "onkeypress",
      "onkeyup",
      "onlanguagechange",
      "onload",
      "onloadeddata",
      "onloadedmetadata",
      "onloadstart",
      "onmessage",
      "onmessageerror",
      "onmousedown",
      "onmouseenter",
      "onmouseleave",
      "onmousemove",
      "onmouseout",
      "onmouseover",
      "onmouseup",
      "onoffline",
      "ononline",
      "onpagehide",
      "onpageshow",
      "onpaste",
      "onpause",
      "onplay",
      "onplaying",
      "onpopstate",
      "onprogress",
      "onratechange",
      "onreset",
      "onresize",
      "onrejectionhandled",
      "onscroll",
      "onscrollend",
      "onsecuritypolicyviolation",
      "onseeked",
      "onseeking",
      "onselect",
      "onslotchange",
      "onstalled",
      "onstorage",
      "onsubmit",
      "onsuspend",
      "ontimeupdate",
      "ontoggle",
      "onunhandledrejection",
      "onunload",
      "onvolumechange",
      "onwaiting",
      "onwheel"
    ],
    disallowedTagsMode: "discard",
    allowedAttributes: {
      a: ["href", "name", "target"],
      // We don't currently allow img itself by default, but
      // these attributes would make sense if we did.
      img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
    },
    allowedEmptyAttributes: [
      "alt"
    ],
    // Lots of these won't come up by default because we don't allow them
    selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
    // URL schemes we permit
    allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
    allowProtocolRelative: !0,
    enforceHtmlBoundary: !1,
    parseStyleAttributes: !0,
    preserveEscapedAttributes: !1
  }, A.simpleTransform = function(w, s, f) {
    return f = f === void 0 ? !0 : f, s = s || {}, function(h, m) {
      let o;
      if (f)
        for (o in s)
          m[o] = s[o];
      else
        m = s;
      return {
        tagName: w,
        attribs: m
      };
    };
  }, Qt;
}
var hi = /* @__PURE__ */ fi();
const gi = /* @__PURE__ */ Mr(hi), Pe = ({ value: u, as: d = "span", ...l }) => {
  const x = d, v = Lr(() => u ? gi(u) : "", [u]);
  return /* @__PURE__ */ L(x, { dangerouslySetInnerHTML: { __html: v }, ...l });
};
var Ie = function() {
  return Ie = Object.assign || function(u) {
    for (var d, l = 1, x = arguments.length; l < x; l++) {
      d = arguments[l];
      for (var v in d) Object.prototype.hasOwnProperty.call(d, v) && (u[v] = d[v]);
    }
    return u;
  }, Ie.apply(this, arguments);
}, bi = "~", pi = "~~";
function jt(u, d) {
  for (var l = {}, x = {}, v = u.split(pi), b = !1, g = 0; v.length > g; g++) {
    for (var a = v[g].split(bi), c = 0; c < a.length; c += 2) {
      var e = a[c], t = a[c + 1], n = "&" + e + ";";
      l[n] = t, b && (l["&" + e] = t), x[t] = n;
    }
    b = !0;
  }
  return d ? { entities: Ie(Ie({}, l), d.entities), characters: Ie(Ie({}, x), d.characters) } : { entities: l, characters: x };
}
var Lt = {
  xml: /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,
  html4: /&notin;|&(?:nbsp|iexcl|cent|pound|curren|yen|brvbar|sect|uml|copy|ordf|laquo|not|shy|reg|macr|deg|plusmn|sup2|sup3|acute|micro|para|middot|cedil|sup1|ordm|raquo|frac14|frac12|frac34|iquest|Agrave|Aacute|Acirc|Atilde|Auml|Aring|AElig|Ccedil|Egrave|Eacute|Ecirc|Euml|Igrave|Iacute|Icirc|Iuml|ETH|Ntilde|Ograve|Oacute|Ocirc|Otilde|Ouml|times|Oslash|Ugrave|Uacute|Ucirc|Uuml|Yacute|THORN|szlig|agrave|aacute|acirc|atilde|auml|aring|aelig|ccedil|egrave|eacute|ecirc|euml|igrave|iacute|icirc|iuml|eth|ntilde|ograve|oacute|ocirc|otilde|ouml|divide|oslash|ugrave|uacute|ucirc|uuml|yacute|thorn|yuml|quot|amp|lt|gt|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,
  html5: /&centerdot;|&copysr;|&divideontimes;|&gtcc;|&gtcir;|&gtdot;|&gtlPar;|&gtquest;|&gtrapprox;|&gtrarr;|&gtrdot;|&gtreqless;|&gtreqqless;|&gtrless;|&gtrsim;|&ltcc;|&ltcir;|&ltdot;|&lthree;|&ltimes;|&ltlarr;|&ltquest;|&ltrPar;|&ltri;|&ltrie;|&ltrif;|&notin;|&notinE;|&notindot;|&notinva;|&notinvb;|&notinvc;|&notni;|&notniva;|&notnivb;|&notnivc;|&parallel;|&timesb;|&timesbar;|&timesd;|&(?:AElig|AMP|Aacute|Acirc|Agrave|Aring|Atilde|Auml|COPY|Ccedil|ETH|Eacute|Ecirc|Egrave|Euml|GT|Iacute|Icirc|Igrave|Iuml|LT|Ntilde|Oacute|Ocirc|Ograve|Oslash|Otilde|Ouml|QUOT|REG|THORN|Uacute|Ucirc|Ugrave|Uuml|Yacute|aacute|acirc|acute|aelig|agrave|amp|aring|atilde|auml|brvbar|ccedil|cedil|cent|copy|curren|deg|divide|eacute|ecirc|egrave|eth|euml|frac12|frac14|frac34|gt|iacute|icirc|iexcl|igrave|iquest|iuml|laquo|lt|macr|micro|middot|nbsp|not|ntilde|oacute|ocirc|ograve|ordf|ordm|oslash|otilde|ouml|para|plusmn|pound|quot|raquo|reg|sect|shy|sup1|sup2|sup3|szlig|thorn|times|uacute|ucirc|ugrave|uml|uuml|yacute|yen|yuml|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g
}, Ce = {};
Ce.xml = jt(`lt~<~gt~>~quot~"~apos~'~amp~&`);
Ce.html4 = jt(`apos~'~OElig~Œ~oelig~œ~Scaron~Š~scaron~š~Yuml~Ÿ~circ~ˆ~tilde~˜~ensp~ ~emsp~ ~thinsp~ ~zwnj~‌~zwj~‍~lrm~‎~rlm~‏~ndash~–~mdash~—~lsquo~‘~rsquo~’~sbquo~‚~ldquo~“~rdquo~”~bdquo~„~dagger~†~Dagger~‡~permil~‰~lsaquo~‹~rsaquo~›~euro~€~fnof~ƒ~Alpha~Α~Beta~Β~Gamma~Γ~Delta~Δ~Epsilon~Ε~Zeta~Ζ~Eta~Η~Theta~Θ~Iota~Ι~Kappa~Κ~Lambda~Λ~Mu~Μ~Nu~Ν~Xi~Ξ~Omicron~Ο~Pi~Π~Rho~Ρ~Sigma~Σ~Tau~Τ~Upsilon~Υ~Phi~Φ~Chi~Χ~Psi~Ψ~Omega~Ω~alpha~α~beta~β~gamma~γ~delta~δ~epsilon~ε~zeta~ζ~eta~η~theta~θ~iota~ι~kappa~κ~lambda~λ~mu~μ~nu~ν~xi~ξ~omicron~ο~pi~π~rho~ρ~sigmaf~ς~sigma~σ~tau~τ~upsilon~υ~phi~φ~chi~χ~psi~ψ~omega~ω~thetasym~ϑ~upsih~ϒ~piv~ϖ~bull~•~hellip~…~prime~′~Prime~″~oline~‾~frasl~⁄~weierp~℘~image~ℑ~real~ℜ~trade~™~alefsym~ℵ~larr~←~uarr~↑~rarr~→~darr~↓~harr~↔~crarr~↵~lArr~⇐~uArr~⇑~rArr~⇒~dArr~⇓~hArr~⇔~forall~∀~part~∂~exist~∃~empty~∅~nabla~∇~isin~∈~notin~∉~ni~∋~prod~∏~sum~∑~minus~−~lowast~∗~radic~√~prop~∝~infin~∞~ang~∠~and~∧~or~∨~cap~∩~cup~∪~int~∫~there4~∴~sim~∼~cong~≅~asymp~≈~ne~≠~equiv~≡~le~≤~ge~≥~sub~⊂~sup~⊃~nsub~⊄~sube~⊆~supe~⊇~oplus~⊕~otimes~⊗~perp~⊥~sdot~⋅~lceil~⌈~rceil~⌉~lfloor~⌊~rfloor~⌋~lang~〈~rang~〉~loz~◊~spades~♠~clubs~♣~hearts~♥~diams~♦~~nbsp~ ~iexcl~¡~cent~¢~pound~£~curren~¤~yen~¥~brvbar~¦~sect~§~uml~¨~copy~©~ordf~ª~laquo~«~not~¬~shy~­~reg~®~macr~¯~deg~°~plusmn~±~sup2~²~sup3~³~acute~´~micro~µ~para~¶~middot~·~cedil~¸~sup1~¹~ordm~º~raquo~»~frac14~¼~frac12~½~frac34~¾~iquest~¿~Agrave~À~Aacute~Á~Acirc~Â~Atilde~Ã~Auml~Ä~Aring~Å~AElig~Æ~Ccedil~Ç~Egrave~È~Eacute~É~Ecirc~Ê~Euml~Ë~Igrave~Ì~Iacute~Í~Icirc~Î~Iuml~Ï~ETH~Ð~Ntilde~Ñ~Ograve~Ò~Oacute~Ó~Ocirc~Ô~Otilde~Õ~Ouml~Ö~times~×~Oslash~Ø~Ugrave~Ù~Uacute~Ú~Ucirc~Û~Uuml~Ü~Yacute~Ý~THORN~Þ~szlig~ß~agrave~à~aacute~á~acirc~â~atilde~ã~auml~ä~aring~å~aelig~æ~ccedil~ç~egrave~è~eacute~é~ecirc~ê~euml~ë~igrave~ì~iacute~í~icirc~î~iuml~ï~eth~ð~ntilde~ñ~ograve~ò~oacute~ó~ocirc~ô~otilde~õ~ouml~ö~divide~÷~oslash~ø~ugrave~ù~uacute~ú~ucirc~û~uuml~ü~yacute~ý~thorn~þ~yuml~ÿ~quot~"~amp~&~lt~<~gt~>`);
Ce.html5 = jt('Abreve~Ă~Acy~А~Afr~𝔄~Amacr~Ā~And~⩓~Aogon~Ą~Aopf~𝔸~ApplyFunction~⁡~Ascr~𝒜~Assign~≔~Backslash~∖~Barv~⫧~Barwed~⌆~Bcy~Б~Because~∵~Bernoullis~ℬ~Bfr~𝔅~Bopf~𝔹~Breve~˘~Bscr~ℬ~Bumpeq~≎~CHcy~Ч~Cacute~Ć~Cap~⋒~CapitalDifferentialD~ⅅ~Cayleys~ℭ~Ccaron~Č~Ccirc~Ĉ~Cconint~∰~Cdot~Ċ~Cedilla~¸~CenterDot~·~Cfr~ℭ~CircleDot~⊙~CircleMinus~⊖~CirclePlus~⊕~CircleTimes~⊗~ClockwiseContourIntegral~∲~CloseCurlyDoubleQuote~”~CloseCurlyQuote~’~Colon~∷~Colone~⩴~Congruent~≡~Conint~∯~ContourIntegral~∮~Copf~ℂ~Coproduct~∐~CounterClockwiseContourIntegral~∳~Cross~⨯~Cscr~𝒞~Cup~⋓~CupCap~≍~DD~ⅅ~DDotrahd~⤑~DJcy~Ђ~DScy~Ѕ~DZcy~Џ~Darr~↡~Dashv~⫤~Dcaron~Ď~Dcy~Д~Del~∇~Dfr~𝔇~DiacriticalAcute~´~DiacriticalDot~˙~DiacriticalDoubleAcute~˝~DiacriticalGrave~`~DiacriticalTilde~˜~Diamond~⋄~DifferentialD~ⅆ~Dopf~𝔻~Dot~¨~DotDot~⃜~DotEqual~≐~DoubleContourIntegral~∯~DoubleDot~¨~DoubleDownArrow~⇓~DoubleLeftArrow~⇐~DoubleLeftRightArrow~⇔~DoubleLeftTee~⫤~DoubleLongLeftArrow~⟸~DoubleLongLeftRightArrow~⟺~DoubleLongRightArrow~⟹~DoubleRightArrow~⇒~DoubleRightTee~⊨~DoubleUpArrow~⇑~DoubleUpDownArrow~⇕~DoubleVerticalBar~∥~DownArrow~↓~DownArrowBar~⤓~DownArrowUpArrow~⇵~DownBreve~̑~DownLeftRightVector~⥐~DownLeftTeeVector~⥞~DownLeftVector~↽~DownLeftVectorBar~⥖~DownRightTeeVector~⥟~DownRightVector~⇁~DownRightVectorBar~⥗~DownTee~⊤~DownTeeArrow~↧~Downarrow~⇓~Dscr~𝒟~Dstrok~Đ~ENG~Ŋ~Ecaron~Ě~Ecy~Э~Edot~Ė~Efr~𝔈~Element~∈~Emacr~Ē~EmptySmallSquare~◻~EmptyVerySmallSquare~▫~Eogon~Ę~Eopf~𝔼~Equal~⩵~EqualTilde~≂~Equilibrium~⇌~Escr~ℰ~Esim~⩳~Exists~∃~ExponentialE~ⅇ~Fcy~Ф~Ffr~𝔉~FilledSmallSquare~◼~FilledVerySmallSquare~▪~Fopf~𝔽~ForAll~∀~Fouriertrf~ℱ~Fscr~ℱ~GJcy~Ѓ~Gammad~Ϝ~Gbreve~Ğ~Gcedil~Ģ~Gcirc~Ĝ~Gcy~Г~Gdot~Ġ~Gfr~𝔊~Gg~⋙~Gopf~𝔾~GreaterEqual~≥~GreaterEqualLess~⋛~GreaterFullEqual~≧~GreaterGreater~⪢~GreaterLess~≷~GreaterSlantEqual~⩾~GreaterTilde~≳~Gscr~𝒢~Gt~≫~HARDcy~Ъ~Hacek~ˇ~Hat~^~Hcirc~Ĥ~Hfr~ℌ~HilbertSpace~ℋ~Hopf~ℍ~HorizontalLine~─~Hscr~ℋ~Hstrok~Ħ~HumpDownHump~≎~HumpEqual~≏~IEcy~Е~IJlig~Ĳ~IOcy~Ё~Icy~И~Idot~İ~Ifr~ℑ~Im~ℑ~Imacr~Ī~ImaginaryI~ⅈ~Implies~⇒~Int~∬~Integral~∫~Intersection~⋂~InvisibleComma~⁣~InvisibleTimes~⁢~Iogon~Į~Iopf~𝕀~Iscr~ℐ~Itilde~Ĩ~Iukcy~І~Jcirc~Ĵ~Jcy~Й~Jfr~𝔍~Jopf~𝕁~Jscr~𝒥~Jsercy~Ј~Jukcy~Є~KHcy~Х~KJcy~Ќ~Kcedil~Ķ~Kcy~К~Kfr~𝔎~Kopf~𝕂~Kscr~𝒦~LJcy~Љ~Lacute~Ĺ~Lang~⟪~Laplacetrf~ℒ~Larr~↞~Lcaron~Ľ~Lcedil~Ļ~Lcy~Л~LeftAngleBracket~⟨~LeftArrow~←~LeftArrowBar~⇤~LeftArrowRightArrow~⇆~LeftCeiling~⌈~LeftDoubleBracket~⟦~LeftDownTeeVector~⥡~LeftDownVector~⇃~LeftDownVectorBar~⥙~LeftFloor~⌊~LeftRightArrow~↔~LeftRightVector~⥎~LeftTee~⊣~LeftTeeArrow~↤~LeftTeeVector~⥚~LeftTriangle~⊲~LeftTriangleBar~⧏~LeftTriangleEqual~⊴~LeftUpDownVector~⥑~LeftUpTeeVector~⥠~LeftUpVector~↿~LeftUpVectorBar~⥘~LeftVector~↼~LeftVectorBar~⥒~Leftarrow~⇐~Leftrightarrow~⇔~LessEqualGreater~⋚~LessFullEqual~≦~LessGreater~≶~LessLess~⪡~LessSlantEqual~⩽~LessTilde~≲~Lfr~𝔏~Ll~⋘~Lleftarrow~⇚~Lmidot~Ŀ~LongLeftArrow~⟵~LongLeftRightArrow~⟷~LongRightArrow~⟶~Longleftarrow~⟸~Longleftrightarrow~⟺~Longrightarrow~⟹~Lopf~𝕃~LowerLeftArrow~↙~LowerRightArrow~↘~Lscr~ℒ~Lsh~↰~Lstrok~Ł~Lt~≪~Map~⤅~Mcy~М~MediumSpace~ ~Mellintrf~ℳ~Mfr~𝔐~MinusPlus~∓~Mopf~𝕄~Mscr~ℳ~NJcy~Њ~Nacute~Ń~Ncaron~Ň~Ncedil~Ņ~Ncy~Н~NegativeMediumSpace~​~NegativeThickSpace~​~NegativeThinSpace~​~NegativeVeryThinSpace~​~NestedGreaterGreater~≫~NestedLessLess~≪~NewLine~\n~Nfr~𝔑~NoBreak~⁠~NonBreakingSpace~ ~Nopf~ℕ~Not~⫬~NotCongruent~≢~NotCupCap~≭~NotDoubleVerticalBar~∦~NotElement~∉~NotEqual~≠~NotEqualTilde~≂̸~NotExists~∄~NotGreater~≯~NotGreaterEqual~≱~NotGreaterFullEqual~≧̸~NotGreaterGreater~≫̸~NotGreaterLess~≹~NotGreaterSlantEqual~⩾̸~NotGreaterTilde~≵~NotHumpDownHump~≎̸~NotHumpEqual~≏̸~NotLeftTriangle~⋪~NotLeftTriangleBar~⧏̸~NotLeftTriangleEqual~⋬~NotLess~≮~NotLessEqual~≰~NotLessGreater~≸~NotLessLess~≪̸~NotLessSlantEqual~⩽̸~NotLessTilde~≴~NotNestedGreaterGreater~⪢̸~NotNestedLessLess~⪡̸~NotPrecedes~⊀~NotPrecedesEqual~⪯̸~NotPrecedesSlantEqual~⋠~NotReverseElement~∌~NotRightTriangle~⋫~NotRightTriangleBar~⧐̸~NotRightTriangleEqual~⋭~NotSquareSubset~⊏̸~NotSquareSubsetEqual~⋢~NotSquareSuperset~⊐̸~NotSquareSupersetEqual~⋣~NotSubset~⊂⃒~NotSubsetEqual~⊈~NotSucceeds~⊁~NotSucceedsEqual~⪰̸~NotSucceedsSlantEqual~⋡~NotSucceedsTilde~≿̸~NotSuperset~⊃⃒~NotSupersetEqual~⊉~NotTilde~≁~NotTildeEqual~≄~NotTildeFullEqual~≇~NotTildeTilde~≉~NotVerticalBar~∤~Nscr~𝒩~Ocy~О~Odblac~Ő~Ofr~𝔒~Omacr~Ō~Oopf~𝕆~OpenCurlyDoubleQuote~“~OpenCurlyQuote~‘~Or~⩔~Oscr~𝒪~Otimes~⨷~OverBar~‾~OverBrace~⏞~OverBracket~⎴~OverParenthesis~⏜~PartialD~∂~Pcy~П~Pfr~𝔓~PlusMinus~±~Poincareplane~ℌ~Popf~ℙ~Pr~⪻~Precedes~≺~PrecedesEqual~⪯~PrecedesSlantEqual~≼~PrecedesTilde~≾~Product~∏~Proportion~∷~Proportional~∝~Pscr~𝒫~Qfr~𝔔~Qopf~ℚ~Qscr~𝒬~RBarr~⤐~Racute~Ŕ~Rang~⟫~Rarr~↠~Rarrtl~⤖~Rcaron~Ř~Rcedil~Ŗ~Rcy~Р~Re~ℜ~ReverseElement~∋~ReverseEquilibrium~⇋~ReverseUpEquilibrium~⥯~Rfr~ℜ~RightAngleBracket~⟩~RightArrow~→~RightArrowBar~⇥~RightArrowLeftArrow~⇄~RightCeiling~⌉~RightDoubleBracket~⟧~RightDownTeeVector~⥝~RightDownVector~⇂~RightDownVectorBar~⥕~RightFloor~⌋~RightTee~⊢~RightTeeArrow~↦~RightTeeVector~⥛~RightTriangle~⊳~RightTriangleBar~⧐~RightTriangleEqual~⊵~RightUpDownVector~⥏~RightUpTeeVector~⥜~RightUpVector~↾~RightUpVectorBar~⥔~RightVector~⇀~RightVectorBar~⥓~Rightarrow~⇒~Ropf~ℝ~RoundImplies~⥰~Rrightarrow~⇛~Rscr~ℛ~Rsh~↱~RuleDelayed~⧴~SHCHcy~Щ~SHcy~Ш~SOFTcy~Ь~Sacute~Ś~Sc~⪼~Scedil~Ş~Scirc~Ŝ~Scy~С~Sfr~𝔖~ShortDownArrow~↓~ShortLeftArrow~←~ShortRightArrow~→~ShortUpArrow~↑~SmallCircle~∘~Sopf~𝕊~Sqrt~√~Square~□~SquareIntersection~⊓~SquareSubset~⊏~SquareSubsetEqual~⊑~SquareSuperset~⊐~SquareSupersetEqual~⊒~SquareUnion~⊔~Sscr~𝒮~Star~⋆~Sub~⋐~Subset~⋐~SubsetEqual~⊆~Succeeds~≻~SucceedsEqual~⪰~SucceedsSlantEqual~≽~SucceedsTilde~≿~SuchThat~∋~Sum~∑~Sup~⋑~Superset~⊃~SupersetEqual~⊇~Supset~⋑~TRADE~™~TSHcy~Ћ~TScy~Ц~Tab~	~Tcaron~Ť~Tcedil~Ţ~Tcy~Т~Tfr~𝔗~Therefore~∴~ThickSpace~  ~ThinSpace~ ~Tilde~∼~TildeEqual~≃~TildeFullEqual~≅~TildeTilde~≈~Topf~𝕋~TripleDot~⃛~Tscr~𝒯~Tstrok~Ŧ~Uarr~↟~Uarrocir~⥉~Ubrcy~Ў~Ubreve~Ŭ~Ucy~У~Udblac~Ű~Ufr~𝔘~Umacr~Ū~UnderBar~_~UnderBrace~⏟~UnderBracket~⎵~UnderParenthesis~⏝~Union~⋃~UnionPlus~⊎~Uogon~Ų~Uopf~𝕌~UpArrow~↑~UpArrowBar~⤒~UpArrowDownArrow~⇅~UpDownArrow~↕~UpEquilibrium~⥮~UpTee~⊥~UpTeeArrow~↥~Uparrow~⇑~Updownarrow~⇕~UpperLeftArrow~↖~UpperRightArrow~↗~Upsi~ϒ~Uring~Ů~Uscr~𝒰~Utilde~Ũ~VDash~⊫~Vbar~⫫~Vcy~В~Vdash~⊩~Vdashl~⫦~Vee~⋁~Verbar~‖~Vert~‖~VerticalBar~∣~VerticalLine~|~VerticalSeparator~❘~VerticalTilde~≀~VeryThinSpace~ ~Vfr~𝔙~Vopf~𝕍~Vscr~𝒱~Vvdash~⊪~Wcirc~Ŵ~Wedge~⋀~Wfr~𝔚~Wopf~𝕎~Wscr~𝒲~Xfr~𝔛~Xopf~𝕏~Xscr~𝒳~YAcy~Я~YIcy~Ї~YUcy~Ю~Ycirc~Ŷ~Ycy~Ы~Yfr~𝔜~Yopf~𝕐~Yscr~𝒴~ZHcy~Ж~Zacute~Ź~Zcaron~Ž~Zcy~З~Zdot~Ż~ZeroWidthSpace~​~Zfr~ℨ~Zopf~ℤ~Zscr~𝒵~abreve~ă~ac~∾~acE~∾̳~acd~∿~acy~а~af~⁡~afr~𝔞~aleph~ℵ~amacr~ā~amalg~⨿~andand~⩕~andd~⩜~andslope~⩘~andv~⩚~ange~⦤~angle~∠~angmsd~∡~angmsdaa~⦨~angmsdab~⦩~angmsdac~⦪~angmsdad~⦫~angmsdae~⦬~angmsdaf~⦭~angmsdag~⦮~angmsdah~⦯~angrt~∟~angrtvb~⊾~angrtvbd~⦝~angsph~∢~angst~Å~angzarr~⍼~aogon~ą~aopf~𝕒~ap~≈~apE~⩰~apacir~⩯~ape~≊~apid~≋~approx~≈~approxeq~≊~ascr~𝒶~ast~*~asympeq~≍~awconint~∳~awint~⨑~bNot~⫭~backcong~≌~backepsilon~϶~backprime~‵~backsim~∽~backsimeq~⋍~barvee~⊽~barwed~⌅~barwedge~⌅~bbrk~⎵~bbrktbrk~⎶~bcong~≌~bcy~б~becaus~∵~because~∵~bemptyv~⦰~bepsi~϶~bernou~ℬ~beth~ℶ~between~≬~bfr~𝔟~bigcap~⋂~bigcirc~◯~bigcup~⋃~bigodot~⨀~bigoplus~⨁~bigotimes~⨂~bigsqcup~⨆~bigstar~★~bigtriangledown~▽~bigtriangleup~△~biguplus~⨄~bigvee~⋁~bigwedge~⋀~bkarow~⤍~blacklozenge~⧫~blacksquare~▪~blacktriangle~▴~blacktriangledown~▾~blacktriangleleft~◂~blacktriangleright~▸~blank~␣~blk12~▒~blk14~░~blk34~▓~block~█~bne~=⃥~bnequiv~≡⃥~bnot~⌐~bopf~𝕓~bot~⊥~bottom~⊥~bowtie~⋈~boxDL~╗~boxDR~╔~boxDl~╖~boxDr~╓~boxH~═~boxHD~╦~boxHU~╩~boxHd~╤~boxHu~╧~boxUL~╝~boxUR~╚~boxUl~╜~boxUr~╙~boxV~║~boxVH~╬~boxVL~╣~boxVR~╠~boxVh~╫~boxVl~╢~boxVr~╟~boxbox~⧉~boxdL~╕~boxdR~╒~boxdl~┐~boxdr~┌~boxh~─~boxhD~╥~boxhU~╨~boxhd~┬~boxhu~┴~boxminus~⊟~boxplus~⊞~boxtimes~⊠~boxuL~╛~boxuR~╘~boxul~┘~boxur~└~boxv~│~boxvH~╪~boxvL~╡~boxvR~╞~boxvh~┼~boxvl~┤~boxvr~├~bprime~‵~breve~˘~bscr~𝒷~bsemi~⁏~bsim~∽~bsime~⋍~bsol~\\~bsolb~⧅~bsolhsub~⟈~bullet~•~bump~≎~bumpE~⪮~bumpe~≏~bumpeq~≏~cacute~ć~capand~⩄~capbrcup~⩉~capcap~⩋~capcup~⩇~capdot~⩀~caps~∩︀~caret~⁁~caron~ˇ~ccaps~⩍~ccaron~č~ccirc~ĉ~ccups~⩌~ccupssm~⩐~cdot~ċ~cemptyv~⦲~centerdot~·~cfr~𝔠~chcy~ч~check~✓~checkmark~✓~cir~○~cirE~⧃~circeq~≗~circlearrowleft~↺~circlearrowright~↻~circledR~®~circledS~Ⓢ~circledast~⊛~circledcirc~⊚~circleddash~⊝~cire~≗~cirfnint~⨐~cirmid~⫯~cirscir~⧂~clubsuit~♣~colon~:~colone~≔~coloneq~≔~comma~,~commat~@~comp~∁~compfn~∘~complement~∁~complexes~ℂ~congdot~⩭~conint~∮~copf~𝕔~coprod~∐~copysr~℗~cross~✗~cscr~𝒸~csub~⫏~csube~⫑~csup~⫐~csupe~⫒~ctdot~⋯~cudarrl~⤸~cudarrr~⤵~cuepr~⋞~cuesc~⋟~cularr~↶~cularrp~⤽~cupbrcap~⩈~cupcap~⩆~cupcup~⩊~cupdot~⊍~cupor~⩅~cups~∪︀~curarr~↷~curarrm~⤼~curlyeqprec~⋞~curlyeqsucc~⋟~curlyvee~⋎~curlywedge~⋏~curvearrowleft~↶~curvearrowright~↷~cuvee~⋎~cuwed~⋏~cwconint~∲~cwint~∱~cylcty~⌭~dHar~⥥~daleth~ℸ~dash~‐~dashv~⊣~dbkarow~⤏~dblac~˝~dcaron~ď~dcy~д~dd~ⅆ~ddagger~‡~ddarr~⇊~ddotseq~⩷~demptyv~⦱~dfisht~⥿~dfr~𝔡~dharl~⇃~dharr~⇂~diam~⋄~diamond~⋄~diamondsuit~♦~die~¨~digamma~ϝ~disin~⋲~div~÷~divideontimes~⋇~divonx~⋇~djcy~ђ~dlcorn~⌞~dlcrop~⌍~dollar~$~dopf~𝕕~dot~˙~doteq~≐~doteqdot~≑~dotminus~∸~dotplus~∔~dotsquare~⊡~doublebarwedge~⌆~downarrow~↓~downdownarrows~⇊~downharpoonleft~⇃~downharpoonright~⇂~drbkarow~⤐~drcorn~⌟~drcrop~⌌~dscr~𝒹~dscy~ѕ~dsol~⧶~dstrok~đ~dtdot~⋱~dtri~▿~dtrif~▾~duarr~⇵~duhar~⥯~dwangle~⦦~dzcy~џ~dzigrarr~⟿~eDDot~⩷~eDot~≑~easter~⩮~ecaron~ě~ecir~≖~ecolon~≕~ecy~э~edot~ė~ee~ⅇ~efDot~≒~efr~𝔢~eg~⪚~egs~⪖~egsdot~⪘~el~⪙~elinters~⏧~ell~ℓ~els~⪕~elsdot~⪗~emacr~ē~emptyset~∅~emptyv~∅~emsp13~ ~emsp14~ ~eng~ŋ~eogon~ę~eopf~𝕖~epar~⋕~eparsl~⧣~eplus~⩱~epsi~ε~epsiv~ϵ~eqcirc~≖~eqcolon~≕~eqsim~≂~eqslantgtr~⪖~eqslantless~⪕~equals~=~equest~≟~equivDD~⩸~eqvparsl~⧥~erDot~≓~erarr~⥱~escr~ℯ~esdot~≐~esim~≂~excl~!~expectation~ℰ~exponentiale~ⅇ~fallingdotseq~≒~fcy~ф~female~♀~ffilig~ﬃ~fflig~ﬀ~ffllig~ﬄ~ffr~𝔣~filig~ﬁ~fjlig~fj~flat~♭~fllig~ﬂ~fltns~▱~fopf~𝕗~fork~⋔~forkv~⫙~fpartint~⨍~frac13~⅓~frac15~⅕~frac16~⅙~frac18~⅛~frac23~⅔~frac25~⅖~frac35~⅗~frac38~⅜~frac45~⅘~frac56~⅚~frac58~⅝~frac78~⅞~frown~⌢~fscr~𝒻~gE~≧~gEl~⪌~gacute~ǵ~gammad~ϝ~gap~⪆~gbreve~ğ~gcirc~ĝ~gcy~г~gdot~ġ~gel~⋛~geq~≥~geqq~≧~geqslant~⩾~ges~⩾~gescc~⪩~gesdot~⪀~gesdoto~⪂~gesdotol~⪄~gesl~⋛︀~gesles~⪔~gfr~𝔤~gg~≫~ggg~⋙~gimel~ℷ~gjcy~ѓ~gl~≷~glE~⪒~gla~⪥~glj~⪤~gnE~≩~gnap~⪊~gnapprox~⪊~gne~⪈~gneq~⪈~gneqq~≩~gnsim~⋧~gopf~𝕘~grave~`~gscr~ℊ~gsim~≳~gsime~⪎~gsiml~⪐~gtcc~⪧~gtcir~⩺~gtdot~⋗~gtlPar~⦕~gtquest~⩼~gtrapprox~⪆~gtrarr~⥸~gtrdot~⋗~gtreqless~⋛~gtreqqless~⪌~gtrless~≷~gtrsim~≳~gvertneqq~≩︀~gvnE~≩︀~hairsp~ ~half~½~hamilt~ℋ~hardcy~ъ~harrcir~⥈~harrw~↭~hbar~ℏ~hcirc~ĥ~heartsuit~♥~hercon~⊹~hfr~𝔥~hksearow~⤥~hkswarow~⤦~hoarr~⇿~homtht~∻~hookleftarrow~↩~hookrightarrow~↪~hopf~𝕙~horbar~―~hscr~𝒽~hslash~ℏ~hstrok~ħ~hybull~⁃~hyphen~‐~ic~⁣~icy~и~iecy~е~iff~⇔~ifr~𝔦~ii~ⅈ~iiiint~⨌~iiint~∭~iinfin~⧜~iiota~℩~ijlig~ĳ~imacr~ī~imagline~ℐ~imagpart~ℑ~imath~ı~imof~⊷~imped~Ƶ~in~∈~incare~℅~infintie~⧝~inodot~ı~intcal~⊺~integers~ℤ~intercal~⊺~intlarhk~⨗~intprod~⨼~iocy~ё~iogon~į~iopf~𝕚~iprod~⨼~iscr~𝒾~isinE~⋹~isindot~⋵~isins~⋴~isinsv~⋳~isinv~∈~it~⁢~itilde~ĩ~iukcy~і~jcirc~ĵ~jcy~й~jfr~𝔧~jmath~ȷ~jopf~𝕛~jscr~𝒿~jsercy~ј~jukcy~є~kappav~ϰ~kcedil~ķ~kcy~к~kfr~𝔨~kgreen~ĸ~khcy~х~kjcy~ќ~kopf~𝕜~kscr~𝓀~lAarr~⇚~lAtail~⤛~lBarr~⤎~lE~≦~lEg~⪋~lHar~⥢~lacute~ĺ~laemptyv~⦴~lagran~ℒ~langd~⦑~langle~⟨~lap~⪅~larrb~⇤~larrbfs~⤟~larrfs~⤝~larrhk~↩~larrlp~↫~larrpl~⤹~larrsim~⥳~larrtl~↢~lat~⪫~latail~⤙~late~⪭~lates~⪭︀~lbarr~⤌~lbbrk~❲~lbrace~{~lbrack~[~lbrke~⦋~lbrksld~⦏~lbrkslu~⦍~lcaron~ľ~lcedil~ļ~lcub~{~lcy~л~ldca~⤶~ldquor~„~ldrdhar~⥧~ldrushar~⥋~ldsh~↲~leftarrow~←~leftarrowtail~↢~leftharpoondown~↽~leftharpoonup~↼~leftleftarrows~⇇~leftrightarrow~↔~leftrightarrows~⇆~leftrightharpoons~⇋~leftrightsquigarrow~↭~leftthreetimes~⋋~leg~⋚~leq~≤~leqq~≦~leqslant~⩽~les~⩽~lescc~⪨~lesdot~⩿~lesdoto~⪁~lesdotor~⪃~lesg~⋚︀~lesges~⪓~lessapprox~⪅~lessdot~⋖~lesseqgtr~⋚~lesseqqgtr~⪋~lessgtr~≶~lesssim~≲~lfisht~⥼~lfr~𝔩~lg~≶~lgE~⪑~lhard~↽~lharu~↼~lharul~⥪~lhblk~▄~ljcy~љ~ll~≪~llarr~⇇~llcorner~⌞~llhard~⥫~lltri~◺~lmidot~ŀ~lmoust~⎰~lmoustache~⎰~lnE~≨~lnap~⪉~lnapprox~⪉~lne~⪇~lneq~⪇~lneqq~≨~lnsim~⋦~loang~⟬~loarr~⇽~lobrk~⟦~longleftarrow~⟵~longleftrightarrow~⟷~longmapsto~⟼~longrightarrow~⟶~looparrowleft~↫~looparrowright~↬~lopar~⦅~lopf~𝕝~loplus~⨭~lotimes~⨴~lowbar~_~lozenge~◊~lozf~⧫~lpar~(~lparlt~⦓~lrarr~⇆~lrcorner~⌟~lrhar~⇋~lrhard~⥭~lrtri~⊿~lscr~𝓁~lsh~↰~lsim~≲~lsime~⪍~lsimg~⪏~lsqb~[~lsquor~‚~lstrok~ł~ltcc~⪦~ltcir~⩹~ltdot~⋖~lthree~⋋~ltimes~⋉~ltlarr~⥶~ltquest~⩻~ltrPar~⦖~ltri~◃~ltrie~⊴~ltrif~◂~lurdshar~⥊~luruhar~⥦~lvertneqq~≨︀~lvnE~≨︀~mDDot~∺~male~♂~malt~✠~maltese~✠~map~↦~mapsto~↦~mapstodown~↧~mapstoleft~↤~mapstoup~↥~marker~▮~mcomma~⨩~mcy~м~measuredangle~∡~mfr~𝔪~mho~℧~mid~∣~midast~*~midcir~⫰~minusb~⊟~minusd~∸~minusdu~⨪~mlcp~⫛~mldr~…~mnplus~∓~models~⊧~mopf~𝕞~mp~∓~mscr~𝓂~mstpos~∾~multimap~⊸~mumap~⊸~nGg~⋙̸~nGt~≫⃒~nGtv~≫̸~nLeftarrow~⇍~nLeftrightarrow~⇎~nLl~⋘̸~nLt~≪⃒~nLtv~≪̸~nRightarrow~⇏~nVDash~⊯~nVdash~⊮~nacute~ń~nang~∠⃒~nap~≉~napE~⩰̸~napid~≋̸~napos~ŉ~napprox~≉~natur~♮~natural~♮~naturals~ℕ~nbump~≎̸~nbumpe~≏̸~ncap~⩃~ncaron~ň~ncedil~ņ~ncong~≇~ncongdot~⩭̸~ncup~⩂~ncy~н~neArr~⇗~nearhk~⤤~nearr~↗~nearrow~↗~nedot~≐̸~nequiv~≢~nesear~⤨~nesim~≂̸~nexist~∄~nexists~∄~nfr~𝔫~ngE~≧̸~nge~≱~ngeq~≱~ngeqq~≧̸~ngeqslant~⩾̸~nges~⩾̸~ngsim~≵~ngt~≯~ngtr~≯~nhArr~⇎~nharr~↮~nhpar~⫲~nis~⋼~nisd~⋺~niv~∋~njcy~њ~nlArr~⇍~nlE~≦̸~nlarr~↚~nldr~‥~nle~≰~nleftarrow~↚~nleftrightarrow~↮~nleq~≰~nleqq~≦̸~nleqslant~⩽̸~nles~⩽̸~nless~≮~nlsim~≴~nlt~≮~nltri~⋪~nltrie~⋬~nmid~∤~nopf~𝕟~notinE~⋹̸~notindot~⋵̸~notinva~∉~notinvb~⋷~notinvc~⋶~notni~∌~notniva~∌~notnivb~⋾~notnivc~⋽~npar~∦~nparallel~∦~nparsl~⫽⃥~npart~∂̸~npolint~⨔~npr~⊀~nprcue~⋠~npre~⪯̸~nprec~⊀~npreceq~⪯̸~nrArr~⇏~nrarr~↛~nrarrc~⤳̸~nrarrw~↝̸~nrightarrow~↛~nrtri~⋫~nrtrie~⋭~nsc~⊁~nsccue~⋡~nsce~⪰̸~nscr~𝓃~nshortmid~∤~nshortparallel~∦~nsim~≁~nsime~≄~nsimeq~≄~nsmid~∤~nspar~∦~nsqsube~⋢~nsqsupe~⋣~nsubE~⫅̸~nsube~⊈~nsubset~⊂⃒~nsubseteq~⊈~nsubseteqq~⫅̸~nsucc~⊁~nsucceq~⪰̸~nsup~⊅~nsupE~⫆̸~nsupe~⊉~nsupset~⊃⃒~nsupseteq~⊉~nsupseteqq~⫆̸~ntgl~≹~ntlg~≸~ntriangleleft~⋪~ntrianglelefteq~⋬~ntriangleright~⋫~ntrianglerighteq~⋭~num~#~numero~№~numsp~ ~nvDash~⊭~nvHarr~⤄~nvap~≍⃒~nvdash~⊬~nvge~≥⃒~nvgt~>⃒~nvinfin~⧞~nvlArr~⤂~nvle~≤⃒~nvlt~<⃒~nvltrie~⊴⃒~nvrArr~⤃~nvrtrie~⊵⃒~nvsim~∼⃒~nwArr~⇖~nwarhk~⤣~nwarr~↖~nwarrow~↖~nwnear~⤧~oS~Ⓢ~oast~⊛~ocir~⊚~ocy~о~odash~⊝~odblac~ő~odiv~⨸~odot~⊙~odsold~⦼~ofcir~⦿~ofr~𝔬~ogon~˛~ogt~⧁~ohbar~⦵~ohm~Ω~oint~∮~olarr~↺~olcir~⦾~olcross~⦻~olt~⧀~omacr~ō~omid~⦶~ominus~⊖~oopf~𝕠~opar~⦷~operp~⦹~orarr~↻~ord~⩝~order~ℴ~orderof~ℴ~origof~⊶~oror~⩖~orslope~⩗~orv~⩛~oscr~ℴ~osol~⊘~otimesas~⨶~ovbar~⌽~par~∥~parallel~∥~parsim~⫳~parsl~⫽~pcy~п~percnt~%~period~.~pertenk~‱~pfr~𝔭~phiv~ϕ~phmmat~ℳ~phone~☎~pitchfork~⋔~planck~ℏ~planckh~ℎ~plankv~ℏ~plus~+~plusacir~⨣~plusb~⊞~pluscir~⨢~plusdo~∔~plusdu~⨥~pluse~⩲~plussim~⨦~plustwo~⨧~pm~±~pointint~⨕~popf~𝕡~pr~≺~prE~⪳~prap~⪷~prcue~≼~pre~⪯~prec~≺~precapprox~⪷~preccurlyeq~≼~preceq~⪯~precnapprox~⪹~precneqq~⪵~precnsim~⋨~precsim~≾~primes~ℙ~prnE~⪵~prnap~⪹~prnsim~⋨~profalar~⌮~profline~⌒~profsurf~⌓~propto~∝~prsim~≾~prurel~⊰~pscr~𝓅~puncsp~ ~qfr~𝔮~qint~⨌~qopf~𝕢~qprime~⁗~qscr~𝓆~quaternions~ℍ~quatint~⨖~quest~?~questeq~≟~rAarr~⇛~rAtail~⤜~rBarr~⤏~rHar~⥤~race~∽̱~racute~ŕ~raemptyv~⦳~rangd~⦒~range~⦥~rangle~⟩~rarrap~⥵~rarrb~⇥~rarrbfs~⤠~rarrc~⤳~rarrfs~⤞~rarrhk~↪~rarrlp~↬~rarrpl~⥅~rarrsim~⥴~rarrtl~↣~rarrw~↝~ratail~⤚~ratio~∶~rationals~ℚ~rbarr~⤍~rbbrk~❳~rbrace~}~rbrack~]~rbrke~⦌~rbrksld~⦎~rbrkslu~⦐~rcaron~ř~rcedil~ŗ~rcub~}~rcy~р~rdca~⤷~rdldhar~⥩~rdquor~”~rdsh~↳~realine~ℛ~realpart~ℜ~reals~ℝ~rect~▭~rfisht~⥽~rfr~𝔯~rhard~⇁~rharu~⇀~rharul~⥬~rhov~ϱ~rightarrow~→~rightarrowtail~↣~rightharpoondown~⇁~rightharpoonup~⇀~rightleftarrows~⇄~rightleftharpoons~⇌~rightrightarrows~⇉~rightsquigarrow~↝~rightthreetimes~⋌~ring~˚~risingdotseq~≓~rlarr~⇄~rlhar~⇌~rmoust~⎱~rmoustache~⎱~rnmid~⫮~roang~⟭~roarr~⇾~robrk~⟧~ropar~⦆~ropf~𝕣~roplus~⨮~rotimes~⨵~rpar~)~rpargt~⦔~rppolint~⨒~rrarr~⇉~rscr~𝓇~rsh~↱~rsqb~]~rsquor~’~rthree~⋌~rtimes~⋊~rtri~▹~rtrie~⊵~rtrif~▸~rtriltri~⧎~ruluhar~⥨~rx~℞~sacute~ś~sc~≻~scE~⪴~scap~⪸~sccue~≽~sce~⪰~scedil~ş~scirc~ŝ~scnE~⪶~scnap~⪺~scnsim~⋩~scpolint~⨓~scsim~≿~scy~с~sdotb~⊡~sdote~⩦~seArr~⇘~searhk~⤥~searr~↘~searrow~↘~semi~;~seswar~⤩~setminus~∖~setmn~∖~sext~✶~sfr~𝔰~sfrown~⌢~sharp~♯~shchcy~щ~shcy~ш~shortmid~∣~shortparallel~∥~sigmav~ς~simdot~⩪~sime~≃~simeq~≃~simg~⪞~simgE~⪠~siml~⪝~simlE~⪟~simne~≆~simplus~⨤~simrarr~⥲~slarr~←~smallsetminus~∖~smashp~⨳~smeparsl~⧤~smid~∣~smile~⌣~smt~⪪~smte~⪬~smtes~⪬︀~softcy~ь~sol~/~solb~⧄~solbar~⌿~sopf~𝕤~spadesuit~♠~spar~∥~sqcap~⊓~sqcaps~⊓︀~sqcup~⊔~sqcups~⊔︀~sqsub~⊏~sqsube~⊑~sqsubset~⊏~sqsubseteq~⊑~sqsup~⊐~sqsupe~⊒~sqsupset~⊐~sqsupseteq~⊒~squ~□~square~□~squarf~▪~squf~▪~srarr~→~sscr~𝓈~ssetmn~∖~ssmile~⌣~sstarf~⋆~star~☆~starf~★~straightepsilon~ϵ~straightphi~ϕ~strns~¯~subE~⫅~subdot~⪽~subedot~⫃~submult~⫁~subnE~⫋~subne~⊊~subplus~⪿~subrarr~⥹~subset~⊂~subseteq~⊆~subseteqq~⫅~subsetneq~⊊~subsetneqq~⫋~subsim~⫇~subsub~⫕~subsup~⫓~succ~≻~succapprox~⪸~succcurlyeq~≽~succeq~⪰~succnapprox~⪺~succneqq~⪶~succnsim~⋩~succsim~≿~sung~♪~supE~⫆~supdot~⪾~supdsub~⫘~supedot~⫄~suphsol~⟉~suphsub~⫗~suplarr~⥻~supmult~⫂~supnE~⫌~supne~⊋~supplus~⫀~supset~⊃~supseteq~⊇~supseteqq~⫆~supsetneq~⊋~supsetneqq~⫌~supsim~⫈~supsub~⫔~supsup~⫖~swArr~⇙~swarhk~⤦~swarr~↙~swarrow~↙~swnwar~⤪~target~⌖~tbrk~⎴~tcaron~ť~tcedil~ţ~tcy~т~tdot~⃛~telrec~⌕~tfr~𝔱~therefore~∴~thetav~ϑ~thickapprox~≈~thicksim~∼~thkap~≈~thksim~∼~timesb~⊠~timesbar~⨱~timesd~⨰~tint~∭~toea~⤨~top~⊤~topbot~⌶~topcir~⫱~topf~𝕥~topfork~⫚~tosa~⤩~tprime~‴~triangle~▵~triangledown~▿~triangleleft~◃~trianglelefteq~⊴~triangleq~≜~triangleright~▹~trianglerighteq~⊵~tridot~◬~trie~≜~triminus~⨺~triplus~⨹~trisb~⧍~tritime~⨻~trpezium~⏢~tscr~𝓉~tscy~ц~tshcy~ћ~tstrok~ŧ~twixt~≬~twoheadleftarrow~↞~twoheadrightarrow~↠~uHar~⥣~ubrcy~ў~ubreve~ŭ~ucy~у~udarr~⇅~udblac~ű~udhar~⥮~ufisht~⥾~ufr~𝔲~uharl~↿~uharr~↾~uhblk~▀~ulcorn~⌜~ulcorner~⌜~ulcrop~⌏~ultri~◸~umacr~ū~uogon~ų~uopf~𝕦~uparrow~↑~updownarrow~↕~upharpoonleft~↿~upharpoonright~↾~uplus~⊎~upsi~υ~upuparrows~⇈~urcorn~⌝~urcorner~⌝~urcrop~⌎~uring~ů~urtri~◹~uscr~𝓊~utdot~⋰~utilde~ũ~utri~▵~utrif~▴~uuarr~⇈~uwangle~⦧~vArr~⇕~vBar~⫨~vBarv~⫩~vDash~⊨~vangrt~⦜~varepsilon~ϵ~varkappa~ϰ~varnothing~∅~varphi~ϕ~varpi~ϖ~varpropto~∝~varr~↕~varrho~ϱ~varsigma~ς~varsubsetneq~⊊︀~varsubsetneqq~⫋︀~varsupsetneq~⊋︀~varsupsetneqq~⫌︀~vartheta~ϑ~vartriangleleft~⊲~vartriangleright~⊳~vcy~в~vdash~⊢~vee~∨~veebar~⊻~veeeq~≚~vellip~⋮~verbar~|~vert~|~vfr~𝔳~vltri~⊲~vnsub~⊂⃒~vnsup~⊃⃒~vopf~𝕧~vprop~∝~vrtri~⊳~vscr~𝓋~vsubnE~⫋︀~vsubne~⊊︀~vsupnE~⫌︀~vsupne~⊋︀~vzigzag~⦚~wcirc~ŵ~wedbar~⩟~wedge~∧~wedgeq~≙~wfr~𝔴~wopf~𝕨~wp~℘~wr~≀~wreath~≀~wscr~𝓌~xcap~⋂~xcirc~◯~xcup~⋃~xdtri~▽~xfr~𝔵~xhArr~⟺~xharr~⟷~xlArr~⟸~xlarr~⟵~xmap~⟼~xnis~⋻~xodot~⨀~xopf~𝕩~xoplus~⨁~xotime~⨂~xrArr~⟹~xrarr~⟶~xscr~𝓍~xsqcup~⨆~xuplus~⨄~xutri~△~xvee~⋁~xwedge~⋀~yacy~я~ycirc~ŷ~ycy~ы~yfr~𝔶~yicy~ї~yopf~𝕪~yscr~𝓎~yucy~ю~zacute~ź~zcaron~ž~zcy~з~zdot~ż~zeetrf~ℨ~zfr~𝔷~zhcy~ж~zigrarr~⇝~zopf~𝕫~zscr~𝓏~~AMP~&~COPY~©~GT~>~LT~<~QUOT~"~REG~®', Ce.html4);
var mi = {
  0: 65533,
  128: 8364,
  130: 8218,
  131: 402,
  132: 8222,
  133: 8230,
  134: 8224,
  135: 8225,
  136: 710,
  137: 8240,
  138: 352,
  139: 8249,
  140: 338,
  142: 381,
  145: 8216,
  146: 8217,
  147: 8220,
  148: 8221,
  149: 8226,
  150: 8211,
  151: 8212,
  152: 732,
  153: 8482,
  154: 353,
  155: 8250,
  156: 339,
  158: 382,
  159: 376
}, yi = String.fromCodePoint || function(u) {
  return String.fromCharCode(Math.floor((u - 65536) / 1024) + 55296, (u - 65536) % 1024 + 56320);
}, Be = function() {
  return Be = Object.assign || function(u) {
    for (var d, l = 1, x = arguments.length; l < x; l++) {
      d = arguments[l];
      for (var v in d) Object.prototype.hasOwnProperty.call(d, v) && (u[v] = d[v]);
    }
    return u;
  }, Be.apply(this, arguments);
}, wi = Be(Be({}, Ce), { all: Ce.html5 }), vi = {
  scope: "body",
  level: "all"
}, Mt = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);/g, Gt = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+)[;=]?/g, br = {
  xml: {
    strict: Mt,
    attribute: Gt,
    body: Lt.xml
  },
  html4: {
    strict: Mt,
    attribute: Gt,
    body: Lt.html4
  },
  html5: {
    strict: Mt,
    attribute: Gt,
    body: Lt.html5
  }
}, xi = Be(Be({}, br), { all: br.html5 }), Rr = String.fromCharCode, Ii = Rr(65533);
function Ci(u, d, l, x) {
  var v = u, b = u[u.length - 1];
  if (l && b === "=")
    v = u;
  else if (x && b !== ";")
    v = u;
  else {
    var g = d[u];
    if (g)
      v = g;
    else if (u[0] === "&" && u[1] === "#") {
      var a = u[2], c = a == "x" || a == "X" ? parseInt(u.substr(3), 16) : parseInt(u.substr(2));
      v = c >= 1114111 ? Ii : c > 65535 ? yi(c) : Rr(mi[c] || c);
    }
  }
  return v;
}
function Ye(u, d) {
  var l = vi, x = l.level, v = x === void 0 ? "all" : x, b = l.scope, g = b === void 0 ? v === "xml" ? "strict" : "body" : b;
  if (!u)
    return "";
  var a = xi[v][g], c = wi[v].entities, e = g === "attribute", t = g === "strict";
  return u.replace(a, function(n) {
    return Ci(n, c, e, t);
  });
}
const Fr = ({ cents: u, locale: d, showCents: l = !1 }) => new Intl.NumberFormat(d, {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: l ? 2 : 0,
  maximumFractionDigits: l ? 2 : 0
}).format(u / 100), en = ({
  project: u,
  locale: d = document.documentElement.lang || "de",
  href: l,
  onClick: x,
  className: v,
  showDescription: b,
  openInTab: g,
  bottomContent: a,
  children: c,
  showCarrierName: e
}) => {
  const t = Fr({ cents: u.open_amount_in_cents, locale: d }), n = new Intl.NumberFormat(d).format(u.donations_count), r = d === "de" ? "fehlen noch" : "still needed", i = d === "de" ? "Spenden" : "donations", A = l || u.links.find((f) => f.rel === "platform")?.href, y = u.profile_picture?.links.find((f) => f.rel === "fill_410x214")?.href, w = u.carrier?.picture?.links.find((f) => f.rel === "fill_100x100")?.href, s = (f) => {
    x?.(f, u);
  };
  return /* @__PURE__ */ _(
    "a",
    {
      title: u.title ? Ye(u.title) : "",
      onClick: s,
      className: `donatable-teaser ${v ?? ""} ${b ? "donatable-teaser--with-description" : ""} ${a ? "donatable-teaser--with-bottom-content" : ""}`,
      href: A,
      target: g ? "_blank" : "_parent",
      rel: "noreferrer",
      children: [
        c,
        /* @__PURE__ */ L(
          "div",
          {
            className: "donatable-teaser--profile-picture",
            style: { backgroundImage: `url(${y})` },
            title: u.title ? Ye(u.title) : ""
          }
        ),
        /* @__PURE__ */ L(Pe, { as: "h2", className: "donatable-teaser--title", value: u.title }),
        b && /* @__PURE__ */ L(Pe, { className: "donatable-teaser--description", as: "div", value: u.description }),
        /* @__PURE__ */ _("div", { className: "donatable-teaser--divider", children: [
          /* @__PURE__ */ _("div", { className: "donatable-teaser--factlist", children: [
            /* @__PURE__ */ _("div", { children: [
              u.city && /* @__PURE__ */ _(Xt, { children: [
                /* @__PURE__ */ L("span", { children: u.city }),
                ",",
                " "
              ] }),
              u.country
            ] }),
            /* @__PURE__ */ L("div", { children: e ? /* @__PURE__ */ L("span", { children: u.carrier?.name }) : /* @__PURE__ */ _(Xt, { children: [
              /* @__PURE__ */ L("span", { children: n }),
              " ",
              i
            ] }) }),
            /* @__PURE__ */ _("div", { children: [
              /* @__PURE__ */ L("span", { children: t }),
              " ",
              r
            ] })
          ] }),
          /* @__PURE__ */ L("img", { src: w, alt: u.carrier?.name, className: "donatable-teaser--carrier-logo" })
        ] }),
        /* @__PURE__ */ L("div", { className: "donatable-teaser--progress", children: /* @__PURE__ */ L("div", { className: "donatable-teaser--progress-bar", style: { width: `${u.progress_percentage}%` } }) }),
        a
      ]
    }
  );
}, Bi = (u, d) => d === 1 ? u === "de" ? "Spende" : "donation" : u === "de" ? "Spenden" : "donations", tn = ({
  fundraisingEvent: u,
  locale: d = document.documentElement.lang || "de",
  href: l,
  onClick: x,
  openInTab: v,
  children: b
}) => {
  const g = l || u.links.find((r) => r.rel === "platform")?.href, a = u.profile_picture?.links.find(
    (r) => r.rel === "fill_410x214"
  )?.href, c = Fr({ cents: u.donated_amount_in_cents, locale: d }), e = u.contact?.picture?.links.find((r) => r.rel === "fill_100x100")?.href, t = (r) => {
    x?.(r, u);
  }, n = Bi(d, u.donations_count);
  return /* @__PURE__ */ _(
    "a",
    {
      title: u.title ? Ye(u.title) : "",
      onClick: t,
      className: "donatable-teaser",
      href: g,
      target: v ? "_blank" : "_parent",
      rel: "noreferrer",
      children: [
        b,
        /* @__PURE__ */ L(
          "div",
          {
            className: "donatable-teaser--profile-picture",
            style: { backgroundImage: `url(${a})` },
            title: u.title ? Ye(u.title) : ""
          }
        ),
        /* @__PURE__ */ L(Pe, { as: "h2", className: "donatable-teaser--title", value: u.title }),
        /* @__PURE__ */ _("div", { className: "donatable-teaser--divider", children: [
          /* @__PURE__ */ _("div", { className: "donatable-teaser--factlist", children: [
            /* @__PURE__ */ L("div", { children: /* @__PURE__ */ L(Pe, { as: "span", value: u.contact?.name }) }),
            /* @__PURE__ */ _("div", { children: [
              /* @__PURE__ */ L("span", { children: u.donations_count }),
              " ",
              n
            ] }),
            /* @__PURE__ */ _("div", { children: [
              /* @__PURE__ */ L("span", { children: c }),
              " ",
              d === "de" ? "gesammelt" : "collected"
            ] })
          ] }),
          /* @__PURE__ */ L(
            "img",
            {
              style: { borderRadius: "50%", border: "1px solid #cccccc" },
              src: e,
              alt: u.contact?.name ?? "",
              className: "donatable-teaser--carrier-logo"
            }
          )
        ] })
      ]
    }
  );
}, Ei = ({
  icon: u,
  content: d,
  className: l = "",
  boxShadow: x,
  buttonClassName: v = "",
  ...b
}) => {
  const g = u;
  return /* @__PURE__ */ _(
    "a",
    {
      ...b,
      className: `share-button--full ${x ? "share-button--box-shadowed" : ""} ${v} ${l}`,
      children: [
        /* @__PURE__ */ L("div", { className: "share-button--full-icon-wrapper", children: /* @__PURE__ */ L(g, { className: "share-button--icon" }) }),
        /* @__PURE__ */ L("span", { className: "share-button--text", children: d })
      ]
    }
  );
}, Di = ({
  icon: u,
  content: d,
  className: l = "",
  buttonClassName: x = "",
  boxShadow: v,
  ...b
}) => {
  const g = u;
  return /* @__PURE__ */ _("a", { ...b, className: `share-button--minimal ${x} ${l}`, children: [
    /* @__PURE__ */ L(g, { className: "share-button--icon" }),
    /* @__PURE__ */ L("span", { className: "share-button--text", children: d })
  ] });
}, Si = ({ icon: u, className: d = "", boxShadow: l, buttonClassName: x = "", ...v }) => {
  const b = u;
  return /* @__PURE__ */ L(
    "a",
    {
      ...v,
      className: `share-button--round ${l ? "share-button--box-shadowed" : ""} ${x} ${d}`,
      children: /* @__PURE__ */ L(b, {})
    }
  );
}, Ni = ({
  icon: u,
  className: d = "",
  buttonClassName: l = "",
  boxShadow: x,
  ...v
}) => {
  const b = u;
  return /* @__PURE__ */ L("a", { ...v, className: `share-button--square ${l} ${d}`, children: /* @__PURE__ */ L(b, {}) });
}, Ri = ({
  icon: u,
  content: d,
  className: l = "",
  boxShadow: x,
  buttonClassName: v = "",
  ...b
}) => {
  const g = u;
  return /* @__PURE__ */ _("div", { className: `share-button--round-with-label ${l}`, children: [
    /* @__PURE__ */ L(
      "a",
      {
        ...b,
        className: `share-button--round ${x ? "share-button--box-shadowed" : ""} ${v}`,
        children: /* @__PURE__ */ L(g, {})
      }
    ),
    d
  ] });
}, Fi = {
  full: Ei,
  minimal: Di,
  round: Si,
  square: Ni,
  roundWithLabel: Ri
}, ve = ({
  action: u,
  ariaLabel: d,
  buttonLabel: l,
  className: x,
  icon: v
}) => (g) => {
  const a = Fi[g.shape], c = (e) => {
    e.preventDefault(), g.beforeOnClick?.(e), u(g);
  };
  return /* @__PURE__ */ L(
    a,
    {
      "aria-label": d,
      boxShadow: g.boxShadow,
      className: g.className || "",
      buttonClassName: x,
      href: "#",
      onClick: c,
      role: "button",
      title: g.title || "",
      label: l || d,
      icon: v,
      content: g.content
    }
  );
}, Ti = ({ size: u = "60%" }) => /* @__PURE__ */ L(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    children: /* @__PURE__ */ L(
      "path",
      {
        fill: "currentColor",
        d: "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
      }
    )
  }
), ki = ({ size: u = "60%" }) => /* @__PURE__ */ L(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 264 512",
    children: /* @__PURE__ */ L(
      "path",
      {
        fill: "currentColor",
        d: "M215.8 85H264V3.6C255.7 2.5 227.1 0 193.8 0 124.3 0 76.7 42.4 76.7 120.3V192H0v91h76.7v229h94V283h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z"
      }
    )
  }
), Oi = ({ size: u = "60%" }) => /* @__PURE__ */ L(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ L(
      "path",
      {
        fill: "currentColor",
        d: "M224 32C15.9 32-77.5 278 84.6 400.6V480l75.7-42c142.2 39.8 285.4-59.9 285.4-198.7C445.8 124.8 346.5 32 224 32zm23.4 278.1L190 250.5 79.6 311.6l121.1-128.5 57.4 59.6 110.4-61.1-121.1 128.5z"
      }
    )
  }
), qi = ({ size: u = "60%" }) => /* @__PURE__ */ L(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ L(
      "path",
      {
        fill: "currentColor",
        d: "M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"
      }
    )
  }
), Qi = ({ size: u = "60%" }) => /* @__PURE__ */ L(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ L(
      "path",
      {
        fill: "currentColor",
        d: "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
      }
    )
  }
), Li = ({ size: u = "60%" }) => /* @__PURE__ */ L(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 700",
    children: /* @__PURE__ */ _("g", { children: [
      /* @__PURE__ */ L(
        "path",
        {
          fill: "currentColor",
          d: `M337.5,448c-5.7,0-11.4-1.7-16.4-5.2c-5.6-3.9-10.8-8.5-15.5-13.5l-19.3-20.6c-48.9-52.1-46.2-134.3,5.9-183.2l95-89.1
		c52.1-48.9,134.3-46.2,183.2,5.9c48.9,52.1,46.2,134.3-5.9,183.2l-31.8,29.8c-11.5,10.8-29.6,10.2-40.4-1.3
		c-10.8-11.5-10.2-29.6,1.3-40.4l31.8-29.8c29.2-27.3,30.7-73.3,3.3-102.5c-27.3-29.2-73.3-30.7-102.5-3.3l-95,89.1
		c-29.2,27.3-30.7,73.3-3.3,102.5l19.3,20.6c2,2.2,4.3,4.1,6.7,5.9c12.9,9.1,16,26.9,6.9,39.8C355.3,443.8,346.5,448,337.5,448z`
        }
      ),
      /* @__PURE__ */ L(
        "path",
        {
          fill: "currentColor",
          d: `M245.8,617.8c-34.6,0-69.1-13.7-94.6-40.9c-48.9-52.1-46.2-134.3,5.9-183.2l31.8-29.8c11.5-10.8,29.6-10.2,40.4,1.3
		c10.8,11.5,10.2,29.6-1.3,40.4l-31.8,29.8c-29.2,27.3-30.7,73.3-3.3,102.5c27.3,29.2,73.3,30.7,102.5,3.3l95-89.1
		c29.2-27.3,30.7-73.3,3.3-102.5L374.4,329c-2-2.2-4.3-4.1-6.7-5.9c-12.9-9.1-16-26.9-6.9-39.8c9.1-12.9,26.9-16,39.8-6.9
		c5.6,3.9,10.8,8.5,15.5,13.5l19.3,20.6c48.9,52.1,46.2,134.3-5.9,183.2l-95,89.1C309.5,606.3,277.6,617.8,245.8,617.8z`
        }
      )
    ] })
  }
), Mi = ({ size: u = "60%" }) => /* @__PURE__ */ _(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.486 40.912",
    children: [
      /* @__PURE__ */ L(
        "path",
        {
          fill: "currentColor",
          d: "M95.09,109.768c.137-.971.242-1.947.417-2.911.991-5.459,4.855-9.173,10.381-9.364,6.654-.229,13.327-.241,19.98,0a10.692,10.692,0,0,1,10.558,10.687q.3,9.583,0,19.182a10.691,10.691,0,0,1-10.558,10.687c-6.653.24-13.328.246-19.98,0-6.016-.226-10.174-4.69-10.576-10.715-.035-.521-.147-1.038-.223-1.557Zm20.749,24.713c3.045,0,6.092.091,9.133-.021,4.767-.177,7.7-3.022,7.811-7.785q.207-8.9,0-17.812c-.111-4.762-3.046-7.673-7.811-7.775q-9.072-.192-18.151,0c-4.729.1-7.67,2.952-7.8,7.661q-.245,9.014,0,18.039c.128,4.709,3.069,7.5,7.8,7.671C109.823,134.572,112.832,134.482,115.839,134.482Zm0,0",
          transform: "translate(-95.09 -97.317)"
        }
      ),
      /* @__PURE__ */ L(
        "path",
        {
          fill: "currentColor",
          d: "M184.564,174a10.572,10.572,0,1,0,10.572,10.571A10.572,10.572,0,0,0,184.564,174Zm0,17.5a6.932,6.932,0,1,1,6.932-6.932A6.932,6.932,0,0,1,184.564,191.5Zm0,0",
          transform: "translate(-163.821 -164.111)"
        }
      ),
      /* @__PURE__ */ L(
        "path",
        {
          fill: "currentColor",
          d: "M328.315,153.258a2.515,2.515,0,1,1-2.515-2.515A2.515,2.515,0,0,1,328.315,153.258Zm0,0",
          transform: "translate(-293.868 -143.855)"
        }
      )
    ]
  }
);
function Gi(u) {
  return u.toLowerCase().startsWith("utm_");
}
const Hi = (u) => new URLSearchParams(Object.entries(u).filter(([l, x]) => x !== void 0)), _t = (u, d = {}) => {
  if (!u) return u;
  const l = u.startsWith("http") ? u : `https://${u}`, x = new URL(l);
  return x.searchParams.forEach((b, g, a) => {
    Gi(g) && a.delete(g);
  }), Hi(d).forEach((b, g) => x.searchParams.set(g, b)), x.toString();
}, ke = (u, d = {}, l = "") => {
  const x = _t(u, d);
  return encodeURIComponent(l + x);
}, Tr = (u) => window.open(u, "sharer", "toolbar=no,width=1042,height=436"), kr = (u) => {
  const d = document.createElement("textarea");
  d.value = u, document.body.appendChild(d), d.select();
  const l = document.execCommand("copy");
  if (document.body.removeChild(d), !l) {
    const v = (document.documentElement.lang || "de") === "de" ? "Sorry, dein Browser unterstützt diese Funktion nicht." : "Sorry, your Browser doesn't support this feature.";
    alert(v);
  }
  return l;
}, Or = () => /(android|iphone|ipad|mobile)/i.test(navigator.userAgent), Ui = ({
  shareUrl: u,
  subject: d = null,
  teaser: l = "",
  utmParams: x
}) => {
  const v = encodeURIComponent(d || l), b = ke(u, x, `${l} `);
  return window.open(`mailto:?subject=${v}&body=${b}`, "_self");
}, un = ve({
  action: Ui,
  ariaLabel: "Email",
  className: "share-button--email",
  icon: Ti
}), Wi = ({ shareUrl: u, utmParams: d }) => Tr(`https://www.facebook.com/sharer/sharer.php?u=${ke(u, d)}`), rn = ve({
  action: Wi,
  ariaLabel: "Facebook",
  className: "share-button--facebook",
  icon: ki
}), Ki = ({
  facebookAppId: u,
  shareUrl: d,
  utmParams: l
}) => {
  const x = Or(), v = ke(d, l);
  return x ? window.open(`fb-messenger://share?link=${v}&app_id=${u}`) : Tr(
    `http://www.facebook.com/dialog/send?app_id=${u}&link=${v}&redirect_uri=${encodeURIComponent(d)}`
  );
}, nn = ve({
  action: Ki,
  ariaLabel: "Facebook Messenger",
  buttonLabel: "Messenger",
  className: "share-button--facebook-messenger",
  icon: Oi
}), Pi = ({ shareUrl: u, teaser: d = "", utmParams: l }) => window.open(
  `https://telegram.me/share/url?url=${ke(u, l)}&text=${encodeURIComponent(d)}`
), an = ve({
  action: Pi,
  ariaLabel: "Telegram",
  className: "share-button--telegram",
  icon: qi
}), Yi = ({ shareUrl: u, utmParams: d }) => window.open(
  `https://${Or() ? "api" : "web"}.whatsapp.com/send?text=${ke(u, d)}`
), sn = ve({
  action: Yi,
  ariaLabel: "WhatsApp",
  className: "share-button--whatsapp",
  icon: Qi
}), Ji = ({ shareUrl: u, utmParams: d }) => {
  kr(_t(u, d));
}, on = ve({
  action: Ji,
  ariaLabel: "ShareLink",
  buttonLabel: "Link",
  className: "share-button--share-link",
  icon: Li
}), Zi = ({ shareUrl: u, utmParams: d }) => {
  kr(_t(u, d));
}, cn = ve({
  action: Zi,
  ariaLabel: "Instagram",
  className: "share-button--instagram",
  icon: Mi
}), ln = (u, d) => u.replace(
  /\w\w/g,
  (l) => ("0" + Math.min(255, Math.max(0, parseInt(l, 16) + d)).toString(16)).substr(-2)
);
export {
  un as EmailButton,
  rn as FacebookButton,
  nn as FacebookMessengerButton,
  tn as FundraisingEventTeaser,
  cn as InstagramButton,
  on as LinkButton,
  en as ProjectTeaser,
  an as TelegramButton,
  sn as WhatsappButton,
  ln as changeBrightness,
  kr as copyToClipboard,
  Ui as emailShareAction,
  ke as encodeShareURL,
  Ki as facebookMessengerShareAction,
  Wi as facebookShareAction,
  Fr as formatAmount,
  _t as getShareURL,
  Zi as instagramAction,
  Or as isMobileOrTablet,
  Ji as linkAction,
  Tr as openPopup,
  Pi as telegramShareAction,
  Hi as toSearchParams,
  Yi as whatsappShareAction
};
